//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { injectable } from "inversify";
import { CPLError, CPLErrorTypes } from "cpl-react-common/Helpers/CustomErrors";

import { CPLClientBase } from "./CPLClientBase";

export interface ICPLAddressesClient {

    /**
     * @param body (optional) 
     * @return Created
     */
    createAddress(body?: NewAddressModel | undefined, signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateAddress(body?: UpdateAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return No Content
     */
    deleteAddress(addressID: string, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getAddress(addressID: string, signal?: AbortSignal | undefined): Promise<AddressModel>;
}

@injectable()
export class CPLAddressesClient extends CPLClientBase implements ICPLAddressesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createAddress(body?: NewAddressModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Addresses/CreateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAddress(_response);
        });
    }

    protected processCreateAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateAddress(body?: UpdateAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Addresses/UpdateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteAddress(addressID: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Addresses/DeleteAddress/{addressID}";
        if (addressID === undefined || addressID === null)
            throw new globalThis.Error("The parameter 'addressID' must be defined.");
        url_ = url_.replace("{addressID}", encodeURIComponent("" + addressID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAddress(_response);
        });
    }

    protected processDeleteAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAddress(addressID: string, signal?: AbortSignal | undefined): Promise<AddressModel> {
        let url_ = this.baseUrl + "/api/Addresses/GetAddress/{addressID}";
        if (addressID === undefined || addressID === null)
            throw new globalThis.Error("The parameter 'addressID' must be defined.");
        url_ = url_.replace("{addressID}", encodeURIComponent("" + addressID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAddress(_response);
        });
    }

    protected processGetAddress(response: Response): Promise<AddressModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AddressModel>(null as any);
    }
}

export interface ICPLAIChatClient {

    /**
     * @return Success
     */
    getChatSessions(signal?: AbortSignal | undefined): Promise<ChatSessionModel[]>;

    /**
     * @return Success
     */
    getChatSession(chatSessionID: string, signal?: AbortSignal | undefined): Promise<ChatSessionDetailModel>;

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateChatSession(body?: UpdateChatSessionModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return No Content
     */
    deleteChatSession(chatSessionID: string, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    sendChatMessage(body?: NewChatMessageModel | undefined, signal?: AbortSignal | undefined): Promise<ChatReplyModel>;

    /**
     * @param chatSessionID (optional) 
     * @param file (optional) 
     * @return Created
     */
    uploadChatDocument(formData: { chatSessionID?: string | null | undefined, file?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<UploadedChatDocumentModel>;

    /**
     * @return No Content
     */
    deleteChatDocument(documentID: string, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return No Content
     */
    setMessageFeedback(body?: SetMessageFeedbackModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return No Content
     */
    deleteMessageFeedback(messageID: number, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLAIChatClient extends CPLClientBase implements ICPLAIChatClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getChatSessions(signal?: AbortSignal | undefined): Promise<ChatSessionModel[]> {
        let url_ = this.baseUrl + "/api/AIChat/GetChatSessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChatSessions(_response);
        });
    }

    protected processGetChatSessions(response: Response): Promise<ChatSessionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatSessionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ChatSessionModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getChatSession(chatSessionID: string, signal?: AbortSignal | undefined): Promise<ChatSessionDetailModel> {
        let url_ = this.baseUrl + "/api/AIChat/GetChatSession/{chatSessionID}";
        if (chatSessionID === undefined || chatSessionID === null)
            throw new globalThis.Error("The parameter 'chatSessionID' must be defined.");
        url_ = url_.replace("{chatSessionID}", encodeURIComponent("" + chatSessionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChatSession(_response);
        });
    }

    protected processGetChatSession(response: Response): Promise<ChatSessionDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatSessionDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ChatSessionDetailModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateChatSession(body?: UpdateChatSessionModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AIChat/UpdateChatSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateChatSession(_response);
        });
    }

    protected processUpdateChatSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteChatSession(chatSessionID: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AIChat/DeleteChatSession/{chatSessionID}";
        if (chatSessionID === undefined || chatSessionID === null)
            throw new globalThis.Error("The parameter 'chatSessionID' must be defined.");
        url_ = url_.replace("{chatSessionID}", encodeURIComponent("" + chatSessionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteChatSession(_response);
        });
    }

    protected processDeleteChatSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendChatMessage(body?: NewChatMessageModel | undefined, signal?: AbortSignal | undefined): Promise<ChatReplyModel> {
        let url_ = this.baseUrl + "/api/AIChat/SendChatMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendChatMessage(_response);
        });
    }

    protected processSendChatMessage(response: Response): Promise<ChatReplyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatReplyModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ChatReplyModel>(null as any);
    }

    /**
     * @param chatSessionID (optional) 
     * @param file (optional) 
     * @return Created
     */
    uploadChatDocument(formData: { chatSessionID?: string | null | undefined, file?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<UploadedChatDocumentModel> {
        let url_ = this.baseUrl + "/api/AIChat/UploadChatDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.chatSessionID !== null && formData.chatSessionID !== undefined)
            content_.append("ChatSessionID", formData.chatSessionID.toString());
        if (formData.file !== null && formData.file !== undefined)
            content_.append("File", formData.file.data, formData.file.fileName ? formData.file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadChatDocument(_response);
        });
    }

    protected processUploadChatDocument(response: Response): Promise<UploadedChatDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UploadedChatDocumentModel.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UploadedChatDocumentModel>(null as any);
    }

    /**
     * @return No Content
     */
    deleteChatDocument(documentID: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AIChat/DeleteChatDocument/{documentID}";
        if (documentID === undefined || documentID === null)
            throw new globalThis.Error("The parameter 'documentID' must be defined.");
        url_ = url_.replace("{documentID}", encodeURIComponent("" + documentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteChatDocument(_response);
        });
    }

    protected processDeleteChatDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    setMessageFeedback(body?: SetMessageFeedbackModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AIChat/SetMessageFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetMessageFeedback(_response);
        });
    }

    protected processSetMessageFeedback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteMessageFeedback(messageID: number, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AIChat/DeleteMessageFeedback/{messageID}";
        if (messageID === undefined || messageID === null)
            throw new globalThis.Error("The parameter 'messageID' must be defined.");
        url_ = url_.replace("{messageID}", encodeURIComponent("" + messageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMessageFeedback(_response);
        });
    }

    protected processDeleteMessageFeedback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAIInvoicesClient {

    /**
     * @param file (optional) 
     * @return Success
     */
    processInvoice(formData: { file?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<ProcessedInvoiceModel>;
}

@injectable()
export class CPLAIInvoicesClient extends CPLClientBase implements ICPLAIInvoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    processInvoice(formData: { file?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<ProcessedInvoiceModel> {
        let url_ = this.baseUrl + "/api/AIInvoices/ProcessInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.file !== null && formData.file !== undefined)
            content_.append("File", formData.file.data, formData.file.fileName ? formData.file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessInvoice(_response);
        });
    }

    protected processProcessInvoice(response: Response): Promise<ProcessedInvoiceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessedInvoiceModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ProcessedInvoiceModel>(null as any);
    }
}

export interface ICPLAnticipatedExpenditureClient {

    /**
     * @return Success
     */
    resumeProcess(signal?: AbortSignal | undefined): Promise<AnticipatedExpenditureSelectionModel>;

    /**
     * @return Success
     */
    resetAnticipatedExpenditureProcess(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    previewAnticipatedExpenditureReport(body?: AnticipatedExpenditureSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptAnticipatedExpenditureReportBackgroundProcess(body?: AnticipatedExpenditureSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    printAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;

    /**
     * @return Success
     */
    emailAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;
}

@injectable()
export class CPLAnticipatedExpenditureClient extends CPLClientBase implements ICPLAnticipatedExpenditureClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    resumeProcess(signal?: AbortSignal | undefined): Promise<AnticipatedExpenditureSelectionModel> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/ResumeProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResumeProcess(_response);
        });
    }

    protected processResumeProcess(response: Response): Promise<AnticipatedExpenditureSelectionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnticipatedExpenditureSelectionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AnticipatedExpenditureSelectionModel>(null as any);
    }

    /**
     * @return Success
     */
    resetAnticipatedExpenditureProcess(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/ResetAnticipatedExpenditureProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetAnticipatedExpenditureProcess(_response);
        });
    }

    protected processResetAnticipatedExpenditureProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewAnticipatedExpenditureReport(body?: AnticipatedExpenditureSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/PreviewAnticipatedExpenditureReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewAnticipatedExpenditureReport(_response);
        });
    }

    protected processPreviewAnticipatedExpenditureReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptAnticipatedExpenditureReportBackgroundProcess(body?: AnticipatedExpenditureSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/AcceptAnticipatedExpenditureReportBackgroundProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptAnticipatedExpenditureReportBackgroundProcess(_response);
        });
    }

    protected processAcceptAnticipatedExpenditureReportBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    printAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/PrintAnticipatedExpenditureReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintAnticipatedExpenditureReport(_response);
        });
    }

    protected processPrintAnticipatedExpenditureReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    emailAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/AnticipatedExpenditure/EmailAnticipatedExpenditureReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailAnticipatedExpenditureReport(_response);
        });
    }

    protected processEmailAnticipatedExpenditureReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }
}

export interface ICPLAuthenticationClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyRPMUser(body?: RPMUserVerificationModel | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLAuthenticationClient extends CPLClientBase implements ICPLAuthenticationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyRPMUser(body?: RPMUserVerificationModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyRPMUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyRPMUser(_response);
        });
    }

    protected processVerifyRPMUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLBackgroundServiceClient {

    /**
     * @return Success
     */
    notifyAllActiveProcesses(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param processID (optional) 
     * @return Success
     */
    acknowledge(processID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLBackgroundServiceClient extends CPLClientBase implements ICPLBackgroundServiceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    notifyAllActiveProcesses(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BackgroundService/NotifyAllActiveProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotifyAllActiveProcesses(_response);
        });
    }

    protected processNotifyAllActiveProcesses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param processID (optional) 
     * @return Success
     */
    acknowledge(processID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/BackgroundService/Acknowledge?";
        if (processID === null)
            throw new globalThis.Error("The parameter 'processID' cannot be null.");
        else if (processID !== undefined)
            url_ += "processID=" + encodeURIComponent("" + processID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcknowledge(_response);
        });
    }

    protected processAcknowledge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLBlocksClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getBlocksSelectModels(body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLBlocksClient extends CPLClientBase implements ICPLBlocksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBlocksSelectModels(body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Blocks/GetBlocksSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBlocksSelectModels(_response);
        });
    }

    protected processGetBlocksSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLCalendarEventsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    createCalendarEvent(body?: NewCalendarEventModel | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @return Success
     */
    getCalendarEventTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCalendarEvent(body?: CalendarEventModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param calendarEventID (optional) 
     * @return Success
     */
    deleteCalendarEvent(calendarEventID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param calendarEventID (optional) 
     * @param userID (optional) 
     * @return Success
     */
    createCalendarEventUserMapping(calendarEventID?: number | undefined, userID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param calendarEventID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    createCalendarEventUserGroupMapping(calendarEventID?: number | undefined, userGroupID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param mappingID (optional) 
     * @return Success
     */
    deleteCalendarEventUserAndUserGroupMapping(mappingID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getCalendarEventsForUser(signal?: AbortSignal | undefined): Promise<CalendarEventModel[]>;
}

@injectable()
export class CPLCalendarEventsClient extends CPLClientBase implements ICPLCalendarEventsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCalendarEvent(body?: NewCalendarEventModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CalendarEvents/CreateCalendarEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCalendarEvent(_response);
        });
    }

    protected processCreateCalendarEvent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    getCalendarEventTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/CalendarEvents/GetCalendarEventTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCalendarEventTypeSelectModels(_response);
        });
    }

    protected processGetCalendarEventTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCalendarEvent(body?: CalendarEventModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CalendarEvents/UpdateCalendarEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCalendarEvent(_response);
        });
    }

    protected processUpdateCalendarEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param calendarEventID (optional) 
     * @return Success
     */
    deleteCalendarEvent(calendarEventID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CalendarEvents/DeleteCalendarEvent?";
        if (calendarEventID === null)
            throw new globalThis.Error("The parameter 'calendarEventID' cannot be null.");
        else if (calendarEventID !== undefined)
            url_ += "calendarEventID=" + encodeURIComponent("" + calendarEventID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCalendarEvent(_response);
        });
    }

    protected processDeleteCalendarEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param calendarEventID (optional) 
     * @param userID (optional) 
     * @return Success
     */
    createCalendarEventUserMapping(calendarEventID?: number | undefined, userID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CalendarEvents/CreateCalendarEventUserMapping?";
        if (calendarEventID === null)
            throw new globalThis.Error("The parameter 'calendarEventID' cannot be null.");
        else if (calendarEventID !== undefined)
            url_ += "calendarEventID=" + encodeURIComponent("" + calendarEventID) + "&";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCalendarEventUserMapping(_response);
        });
    }

    protected processCreateCalendarEventUserMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param calendarEventID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    createCalendarEventUserGroupMapping(calendarEventID?: number | undefined, userGroupID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CalendarEvents/CreateCalendarEventUserGroupMapping?";
        if (calendarEventID === null)
            throw new globalThis.Error("The parameter 'calendarEventID' cannot be null.");
        else if (calendarEventID !== undefined)
            url_ += "calendarEventID=" + encodeURIComponent("" + calendarEventID) + "&";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCalendarEventUserGroupMapping(_response);
        });
    }

    protected processCreateCalendarEventUserGroupMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param mappingID (optional) 
     * @return Success
     */
    deleteCalendarEventUserAndUserGroupMapping(mappingID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CalendarEvents/DeleteCalendarEventUserAndUserGroupMapping?";
        if (mappingID === null)
            throw new globalThis.Error("The parameter 'mappingID' cannot be null.");
        else if (mappingID !== undefined)
            url_ += "mappingID=" + encodeURIComponent("" + mappingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCalendarEventUserAndUserGroupMapping(_response);
        });
    }

    protected processDeleteCalendarEventUserAndUserGroupMapping(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCalendarEventsForUser(signal?: AbortSignal | undefined): Promise<CalendarEventModel[]> {
        let url_ = this.baseUrl + "/api/CalendarEvents/GetCalendarEventsForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCalendarEventsForUser(_response);
        });
    }

    protected processGetCalendarEventsForUser(response: Response): Promise<CalendarEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarEventModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CalendarEventModel[]>(null as any);
    }
}

export interface ICPLCasesClient {

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getCases(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<CaseModel[]>;

    /**
     * @param caseID (optional) 
     * @return Success
     */
    getCase(caseID?: number | undefined, signal?: AbortSignal | undefined): Promise<CaseModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCase(body?: NewCaseModel | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCase(body?: CaseModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param caseID (optional) 
     * @param caseStatusTypeID (optional) 
     * @return Success
     */
    changeCaseStatus(caseID?: number | undefined, caseStatusTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getCaseSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLCasesClient extends CPLClientBase implements ICPLCasesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getCases(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<CaseModel[]> {
        let url_ = this.baseUrl + "/api/Cases/GetCases?";
        if (meetingID === null)
            throw new globalThis.Error("The parameter 'meetingID' cannot be null.");
        else if (meetingID !== undefined)
            url_ += "meetingID=" + encodeURIComponent("" + meetingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCases(_response);
        });
    }

    protected processGetCases(response: Response): Promise<CaseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CaseModel[]>(null as any);
    }

    /**
     * @param caseID (optional) 
     * @return Success
     */
    getCase(caseID?: number | undefined, signal?: AbortSignal | undefined): Promise<CaseModel> {
        let url_ = this.baseUrl + "/api/Cases/GetCase?";
        if (caseID === null)
            throw new globalThis.Error("The parameter 'caseID' cannot be null.");
        else if (caseID !== undefined)
            url_ += "caseID=" + encodeURIComponent("" + caseID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCase(_response);
        });
    }

    protected processGetCase(response: Response): Promise<CaseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CaseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCase(body?: NewCaseModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Cases/CreateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCase(_response);
        });
    }

    protected processCreateCase(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCase(body?: CaseModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Cases/UpdateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCase(_response);
        });
    }

    protected processUpdateCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param caseID (optional) 
     * @param caseStatusTypeID (optional) 
     * @return Success
     */
    changeCaseStatus(caseID?: number | undefined, caseStatusTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Cases/ChangeCaseStatus?";
        if (caseID === null)
            throw new globalThis.Error("The parameter 'caseID' cannot be null.");
        else if (caseID !== undefined)
            url_ += "caseID=" + encodeURIComponent("" + caseID) + "&";
        if (caseStatusTypeID === null)
            throw new globalThis.Error("The parameter 'caseStatusTypeID' cannot be null.");
        else if (caseStatusTypeID !== undefined)
            url_ += "caseStatusTypeID=" + encodeURIComponent("" + caseStatusTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeCaseStatus(_response);
        });
    }

    protected processChangeCaseStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCaseSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/Cases/GetCaseSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseSelectModels(_response);
        });
    }

    protected processGetCaseSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLCaseStatusTypesClient {

    /**
     * @return Success
     */
    getCaseStatusTypes(signal?: AbortSignal | undefined): Promise<CaseStatusTypeModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCaseStatusType(body?: NewCaseStatusTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseStatusType(body?: CaseStatusTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param caseStatusTypeID (optional) 
     * @return Success
     */
    deleteCaseStatusType(caseStatusTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getCaseStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLCaseStatusTypesClient extends CPLClientBase implements ICPLCaseStatusTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCaseStatusTypes(signal?: AbortSignal | undefined): Promise<CaseStatusTypeModel[]> {
        let url_ = this.baseUrl + "/api/CaseStatusTypes/GetCaseStatusTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseStatusTypes(_response);
        });
    }

    protected processGetCaseStatusTypes(response: Response): Promise<CaseStatusTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseStatusTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CaseStatusTypeModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCaseStatusType(body?: NewCaseStatusTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseStatusTypes/CreateCaseStatusType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseStatusType(_response);
        });
    }

    protected processCreateCaseStatusType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseStatusType(body?: CaseStatusTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseStatusTypes/UpdateCaseStatusType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCaseStatusType(_response);
        });
    }

    protected processUpdateCaseStatusType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param caseStatusTypeID (optional) 
     * @return Success
     */
    deleteCaseStatusType(caseStatusTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseStatusTypes/DeleteCaseStatusType?";
        if (caseStatusTypeID === null)
            throw new globalThis.Error("The parameter 'caseStatusTypeID' cannot be null.");
        else if (caseStatusTypeID !== undefined)
            url_ += "caseStatusTypeID=" + encodeURIComponent("" + caseStatusTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCaseStatusType(_response);
        });
    }

    protected processDeleteCaseStatusType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCaseStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/CaseStatusTypes/GetCaseStatusTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseStatusTypeSelectModels(_response);
        });
    }

    protected processGetCaseStatusTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLCaseTypesClient {

    /**
     * @return Success
     */
    getCaseTypes(signal?: AbortSignal | undefined): Promise<CaseTypeModel[]>;

    /**
     * @param name (optional) 
     * @param showOnPortal (optional) 
     * @return Success
     */
    createCaseType(name?: string | undefined, showOnPortal?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseType(body?: CaseTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param caseTypeID (optional) 
     * @return Success
     */
    deleteCaseType(caseTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getCaseTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLCaseTypesClient extends CPLClientBase implements ICPLCaseTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCaseTypes(signal?: AbortSignal | undefined): Promise<CaseTypeModel[]> {
        let url_ = this.baseUrl + "/api/CaseTypes/GetCaseTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseTypes(_response);
        });
    }

    protected processGetCaseTypes(response: Response): Promise<CaseTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CaseTypeModel[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param showOnPortal (optional) 
     * @return Success
     */
    createCaseType(name?: string | undefined, showOnPortal?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseTypes/CreateCaseType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (showOnPortal === null)
            throw new globalThis.Error("The parameter 'showOnPortal' cannot be null.");
        else if (showOnPortal !== undefined)
            url_ += "showOnPortal=" + encodeURIComponent("" + showOnPortal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCaseType(_response);
        });
    }

    protected processCreateCaseType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCaseType(body?: CaseTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseTypes/UpdateCaseType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCaseType(_response);
        });
    }

    protected processUpdateCaseType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param caseTypeID (optional) 
     * @return Success
     */
    deleteCaseType(caseTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseTypes/DeleteCaseType?";
        if (caseTypeID === null)
            throw new globalThis.Error("The parameter 'caseTypeID' cannot be null.");
        else if (caseTypeID !== undefined)
            url_ += "caseTypeID=" + encodeURIComponent("" + caseTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCaseType(_response);
        });
    }

    protected processDeleteCaseType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCaseTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/CaseTypes/GetCaseTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseTypeSelectModels(_response);
        });
    }

    protected processGetCaseTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLChangeTrackingClient {

    /**
     * @param type (optional) 
     * @param recordID (optional) 
     * @return Success
     */
    getChangeHistory(type?: ChangeTrackingTypes | undefined, recordID?: string | undefined, signal?: AbortSignal | undefined): Promise<ChangeTrackingModel>;
}

@injectable()
export class CPLChangeTrackingClient extends CPLClientBase implements ICPLChangeTrackingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param type (optional) 
     * @param recordID (optional) 
     * @return Success
     */
    getChangeHistory(type?: ChangeTrackingTypes | undefined, recordID?: string | undefined, signal?: AbortSignal | undefined): Promise<ChangeTrackingModel> {
        let url_ = this.baseUrl + "/api/ChangeTracking/GetChangeHistory?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (recordID === null)
            throw new globalThis.Error("The parameter 'recordID' cannot be null.");
        else if (recordID !== undefined)
            url_ += "recordID=" + encodeURIComponent("" + recordID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChangeHistory(_response);
        });
    }

    protected processGetChangeHistory(response: Response): Promise<ChangeTrackingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeTrackingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ChangeTrackingModel>(null as any);
    }
}

export interface ICPLClientNoticeClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    previewClientNoticeReport(body?: ClientNoticeSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getClientNoticeReport(body?: ClientNoticeSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLClientNoticeClient extends CPLClientBase implements ICPLClientNoticeClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewClientNoticeReport(body?: ClientNoticeSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/ClientNotice/PreviewClientNoticeReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewClientNoticeReport(_response);
        });
    }

    protected processPreviewClientNoticeReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getClientNoticeReport(body?: ClientNoticeSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ClientNotice/GetClientNoticeReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientNoticeReport(_response);
        });
    }

    protected processGetClientNoticeReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLClientPortalAccountContactDetailsClient {

    /**
     * @return Success
     */
    getClientContactDetails(signal?: AbortSignal | undefined): Promise<ClientContactDetailsModel[]>;

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getClientAddressDetails(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientAddressModel[]>;

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getClientEmailAddressDetails(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientAccountEmailModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientAddress(body?: NewClientAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientEmailAddress(body?: NewClientEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientAddress(body?: ClientAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientEmailAddress(body?: ClientAccountEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param clientEmailAddressID (optional) 
     * @return Success
     */
    deleteClientEmailAddress(clientEmailAddressID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param clientAddressID (optional) 
     * @return Success
     */
    deleteClientAddress(clientAddressID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLClientPortalAccountContactDetailsClient extends CPLClientBase implements ICPLClientPortalAccountContactDetailsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getClientContactDetails(signal?: AbortSignal | undefined): Promise<ClientContactDetailsModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/GetClientContactDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientContactDetails(_response);
        });
    }

    protected processGetClientContactDetails(response: Response): Promise<ClientContactDetailsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientContactDetailsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientContactDetailsModel[]>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getClientAddressDetails(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientAddressModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/GetClientAddressDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientAddressDetails(_response);
        });
    }

    protected processGetClientAddressDetails(response: Response): Promise<ClientAddressModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientAddressModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientAddressModel[]>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getClientEmailAddressDetails(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientAccountEmailModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/GetClientEmailAddressDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientEmailAddressDetails(_response);
        });
    }

    protected processGetClientEmailAddressDetails(response: Response): Promise<ClientAccountEmailModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientAccountEmailModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientAccountEmailModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientAddress(body?: NewClientAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/CreateClientAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClientAddress(_response);
        });
    }

    protected processCreateClientAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClientEmailAddress(body?: NewClientEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/CreateClientEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClientEmailAddress(_response);
        });
    }

    protected processCreateClientEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientAddress(body?: ClientAddressModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/UpdateClientAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClientAddress(_response);
        });
    }

    protected processUpdateClientAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClientEmailAddress(body?: ClientAccountEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/UpdateClientEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClientEmailAddress(_response);
        });
    }

    protected processUpdateClientEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param clientEmailAddressID (optional) 
     * @return Success
     */
    deleteClientEmailAddress(clientEmailAddressID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/DeleteClientEmailAddress?";
        if (clientEmailAddressID === null)
            throw new globalThis.Error("The parameter 'clientEmailAddressID' cannot be null.");
        else if (clientEmailAddressID !== undefined)
            url_ += "clientEmailAddressID=" + encodeURIComponent("" + clientEmailAddressID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClientEmailAddress(_response);
        });
    }

    protected processDeleteClientEmailAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param clientAddressID (optional) 
     * @return Success
     */
    deleteClientAddress(clientAddressID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalAccountContactDetails/DeleteClientAddress?";
        if (clientAddressID === null)
            throw new globalThis.Error("The parameter 'clientAddressID' cannot be null.");
        else if (clientAddressID !== undefined)
            url_ += "clientAddressID=" + encodeURIComponent("" + clientAddressID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClientAddress(_response);
        });
    }

    protected processDeleteClientAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLClientPortalAccountsClient {

    /**
     * @return Success
     */
    getOverallOutstandingBalance(signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @return Success
     */
    getBalancesForAllProperties(signal?: AbortSignal | undefined): Promise<ClientPropertyBalanceListModel>;

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getAllTransactionsForClient(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<PLClientTransactionModel>;

    /**
     * @param transactionID (optional) 
     * @return Success
     */
    getAllInvoicesForTransaction(transactionID?: string | undefined, signal?: AbortSignal | undefined): Promise<PLInvoiceChargeModel>;

    downloadChargeFilePDF(chargefileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    downloadClientInvoicePDF(plClientTransactionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    /**
     * @return Success
     */
    getClientBillingAddress(signal?: AbortSignal | undefined): Promise<ClientAddressModel>;
}

@injectable()
export class CPLClientPortalAccountsClient extends CPLClientBase implements ICPLClientPortalAccountsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getOverallOutstandingBalance(signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/GetOverallOutstandingBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOverallOutstandingBalance(_response);
        });
    }

    protected processGetOverallOutstandingBalance(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    getBalancesForAllProperties(signal?: AbortSignal | undefined): Promise<ClientPropertyBalanceListModel> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/GetBalancesForAllProperties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBalancesForAllProperties(_response);
        });
    }

    protected processGetBalancesForAllProperties(response: Response): Promise<ClientPropertyBalanceListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPropertyBalanceListModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPropertyBalanceListModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getAllTransactionsForClient(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<PLClientTransactionModel> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/GetAllTransactionsForClient?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTransactionsForClient(_response);
        });
    }

    protected processGetAllTransactionsForClient(response: Response): Promise<PLClientTransactionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PLClientTransactionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PLClientTransactionModel>(null as any);
    }

    /**
     * @param transactionID (optional) 
     * @return Success
     */
    getAllInvoicesForTransaction(transactionID?: string | undefined, signal?: AbortSignal | undefined): Promise<PLInvoiceChargeModel> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/GetAllInvoicesForTransaction?";
        if (transactionID === null)
            throw new globalThis.Error("The parameter 'transactionID' cannot be null.");
        else if (transactionID !== undefined)
            url_ += "transactionID=" + encodeURIComponent("" + transactionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllInvoicesForTransaction(_response);
        });
    }

    protected processGetAllInvoicesForTransaction(response: Response): Promise<PLInvoiceChargeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PLInvoiceChargeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PLInvoiceChargeModel>(null as any);
    }

    downloadChargeFilePDF(chargefileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/DownloadChargeFilePDF?";
        if (chargefileID === null)
            throw new globalThis.Error("The parameter 'chargefileID' cannot be null.");
        else if (chargefileID !== undefined)
            url_ += "chargefileID=" + encodeURIComponent("" + chargefileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadChargeFilePDF(_response);
        });
    }

    protected processDownloadChargeFilePDF(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadClientInvoicePDF(plClientTransactionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/DownloadClientInvoicePDF?";
        if (plClientTransactionFileID === null)
            throw new globalThis.Error("The parameter 'plClientTransactionFileID' cannot be null.");
        else if (plClientTransactionFileID !== undefined)
            url_ += "plClientTransactionFileID=" + encodeURIComponent("" + plClientTransactionFileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadClientInvoicePDF(_response);
        });
    }

    protected processDownloadClientInvoicePDF(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getClientBillingAddress(signal?: AbortSignal | undefined): Promise<ClientAddressModel> {
        let url_ = this.baseUrl + "/api/ClientPortalAccounts/GetClientBillingAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientBillingAddress(_response);
        });
    }

    protected processGetClientBillingAddress(response: Response): Promise<ClientAddressModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAddressModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientAddressModel>(null as any);
    }
}

export interface ICPLClientPortalBudgetsClient {

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getBudgetsForClient(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetsModel>;

    /**
     * @param clientID (optional) 
     * @param budgetID (optional) 
     * @return Success
     */
    getBudgetHeadingsForClientsBudget(clientID?: string | undefined, budgetID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetHeadersModel>;

    /**
     * @param clientID (optional) 
     * @param budgetID (optional) 
     * @param budgetHeaderID (optional) 
     * @return Success
     */
    getChargesForClientsBudgetHeading(clientID?: string | undefined, budgetID?: number | undefined, budgetHeaderID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetChargesModel>;
}

@injectable()
export class CPLClientPortalBudgetsClient extends CPLClientBase implements ICPLClientPortalBudgetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientID (optional) 
     * @return Success
     */
    getBudgetsForClient(clientID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalBudgets/GetBudgetsForClient?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBudgetsForClient(_response);
        });
    }

    protected processGetBudgetsForClient(response: Response): Promise<ClientPortalBudgetsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalBudgetsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalBudgetsModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param budgetID (optional) 
     * @return Success
     */
    getBudgetHeadingsForClientsBudget(clientID?: string | undefined, budgetID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetHeadersModel> {
        let url_ = this.baseUrl + "/api/ClientPortalBudgets/GetBudgetHeadingsForClientsBudget?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (budgetID === null)
            throw new globalThis.Error("The parameter 'budgetID' cannot be null.");
        else if (budgetID !== undefined)
            url_ += "budgetID=" + encodeURIComponent("" + budgetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBudgetHeadingsForClientsBudget(_response);
        });
    }

    protected processGetBudgetHeadingsForClientsBudget(response: Response): Promise<ClientPortalBudgetHeadersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalBudgetHeadersModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalBudgetHeadersModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param budgetID (optional) 
     * @param budgetHeaderID (optional) 
     * @return Success
     */
    getChargesForClientsBudgetHeading(clientID?: string | undefined, budgetID?: number | undefined, budgetHeaderID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalBudgetChargesModel> {
        let url_ = this.baseUrl + "/api/ClientPortalBudgets/GetChargesForClientsBudgetHeading?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (budgetID === null)
            throw new globalThis.Error("The parameter 'budgetID' cannot be null.");
        else if (budgetID !== undefined)
            url_ += "budgetID=" + encodeURIComponent("" + budgetID) + "&";
        if (budgetHeaderID === null)
            throw new globalThis.Error("The parameter 'budgetHeaderID' cannot be null.");
        else if (budgetHeaderID !== undefined)
            url_ += "budgetHeaderID=" + encodeURIComponent("" + budgetHeaderID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChargesForClientsBudgetHeading(_response);
        });
    }

    protected processGetChargesForClientsBudgetHeading(response: Response): Promise<ClientPortalBudgetChargesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalBudgetChargesModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalBudgetChargesModel>(null as any);
    }
}

export interface ICPLClientPortalCasesClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getCases(body?: ClientPortalCaseFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCaseModel[]>;

    /**
     * @param caseID (optional) 
     * @return Success
     */
    getCaseDetails(caseID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCaseDetailsModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCase(body?: ClientPortalNewCaseModel | undefined, signal?: AbortSignal | undefined): Promise<number>;
}

@injectable()
export class CPLClientPortalCasesClient extends CPLClientBase implements ICPLClientPortalCasesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCases(body?: ClientPortalCaseFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCaseModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalCases/GetCases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCases(_response);
        });
    }

    protected processGetCases(response: Response): Promise<ClientPortalCaseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalCaseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalCaseModel[]>(null as any);
    }

    /**
     * @param caseID (optional) 
     * @return Success
     */
    getCaseDetails(caseID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCaseDetailsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalCases/GetCaseDetails?";
        if (caseID === null)
            throw new globalThis.Error("The parameter 'caseID' cannot be null.");
        else if (caseID !== undefined)
            url_ += "caseID=" + encodeURIComponent("" + caseID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseDetails(_response);
        });
    }

    protected processGetCaseDetails(response: Response): Promise<ClientPortalCaseDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalCaseDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalCaseDetailsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCase(body?: ClientPortalNewCaseModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientPortalCases/CreateCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCase(_response);
        });
    }

    protected processCreateCase(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICPLClientPortalCaseTypesClient {

    /**
     * @return Success
     */
    getCaseTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLClientPortalCaseTypesClient extends CPLClientBase implements ICPLClientPortalCaseTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCaseTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalCaseTypes/GetCaseTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCaseTypeSelectModels(_response);
        });
    }

    protected processGetCaseTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLClientPortalClientsClient {

    /**
     * @param clientAccountNumber (optional) 
     * @param emailAddress (optional) 
     * @return Success
     */
    getEmailMatchesClient(clientAccountNumber?: string | undefined, emailAddress?: string | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLClientPortalClientsClient extends CPLClientBase implements ICPLClientPortalClientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientAccountNumber (optional) 
     * @param emailAddress (optional) 
     * @return Success
     */
    getEmailMatchesClient(clientAccountNumber?: string | undefined, emailAddress?: string | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ClientPortalClients/GetEmailMatchesClient?";
        if (clientAccountNumber === null)
            throw new globalThis.Error("The parameter 'clientAccountNumber' cannot be null.");
        else if (clientAccountNumber !== undefined)
            url_ += "clientAccountNumber=" + encodeURIComponent("" + clientAccountNumber) + "&";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmailMatchesClient(_response);
        });
    }

    protected processGetEmailMatchesClient(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLClientPortalCommentsClient {

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getComments(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCommentModel[]>;

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getCommentThreadRecipients(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentThreadRecipientModel[]>;

    /**
     * @param clientID (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createComment(formData: { clientID?: string | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param commentID (optional) 
     * @param message (optional) 
     * @param deletedAttachmentIDs (optional) 
     * @param newAttachments (optional) 
     * @return Success
     */
    updateComment(formData: { commentID?: number | undefined, message?: string | null | undefined, deletedAttachmentIDs?: number[] | null | undefined, newAttachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param commentID (optional) 
     * @return Success
     */
    deleteComment(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    downloadCommentAttachment(commentAttachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;
}

@injectable()
export class CPLClientPortalCommentsClient extends CPLClientBase implements ICPLClientPortalCommentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getComments(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalCommentModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/GetComments?";
        if (commentThreadID === null)
            throw new globalThis.Error("The parameter 'commentThreadID' cannot be null.");
        else if (commentThreadID !== undefined)
            url_ += "commentThreadID=" + encodeURIComponent("" + commentThreadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComments(_response);
        });
    }

    protected processGetComments(response: Response): Promise<ClientPortalCommentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalCommentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalCommentModel[]>(null as any);
    }

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getCommentThreadRecipients(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentThreadRecipientModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/GetCommentThreadRecipients?";
        if (commentThreadID === null)
            throw new globalThis.Error("The parameter 'commentThreadID' cannot be null.");
        else if (commentThreadID !== undefined)
            url_ += "commentThreadID=" + encodeURIComponent("" + commentThreadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommentThreadRecipients(_response);
        });
    }

    protected processGetCommentThreadRecipients(response: Response): Promise<CommentThreadRecipientModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentThreadRecipientModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CommentThreadRecipientModel[]>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createComment(formData: { clientID?: string | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/CreateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.clientID === null || formData.clientID === undefined)
            throw new Error("The parameter 'clientID' cannot be null.");
        else
            content_.append("ClientID", formData.clientID.toString());
        if (formData.commentThreadID === null || formData.commentThreadID === undefined)
            throw new Error("The parameter 'commentThreadID' cannot be null.");
        else
            content_.append("CommentThreadID", formData.commentThreadID.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.attachments !== null && formData.attachments !== undefined)
            formData.attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param commentID (optional) 
     * @param message (optional) 
     * @param deletedAttachmentIDs (optional) 
     * @param newAttachments (optional) 
     * @return Success
     */
    updateComment(formData: { commentID?: number | undefined, message?: string | null | undefined, deletedAttachmentIDs?: number[] | null | undefined, newAttachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/UpdateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.commentID === null || formData.commentID === undefined)
            throw new Error("The parameter 'commentID' cannot be null.");
        else
            content_.append("CommentID", formData.commentID.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.deletedAttachmentIDs !== null && formData.deletedAttachmentIDs !== undefined)
            formData.deletedAttachmentIDs.forEach(item_ => content_.append("DeletedAttachmentIDs", item_.toString()));
        if (formData.newAttachments !== null && formData.newAttachments !== undefined)
            formData.newAttachments.forEach(item_ => content_.append("NewAttachments", item_.data, item_.fileName ? item_.fileName : "NewAttachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param commentID (optional) 
     * @return Success
     */
    deleteComment(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/DeleteComment?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    downloadCommentAttachment(commentAttachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientPortalComments/DownloadCommentAttachment?";
        if (commentAttachmentID === null)
            throw new globalThis.Error("The parameter 'commentAttachmentID' cannot be null.");
        else if (commentAttachmentID !== undefined)
            url_ += "commentAttachmentID=" + encodeURIComponent("" + commentAttachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCommentAttachment(_response);
        });
    }

    protected processDownloadCommentAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICPLClientPortalCreditControlClient {

    /**
     * @return Success
     */
    getCreditControlDevelopmentSummaries(signal?: AbortSignal | undefined): Promise<CreditControlDevelopmentSummaryModel[]>;

    /**
     * @param developmentID (optional) 
     * @return Success
     */
    getCreditControlStatusSummaries(developmentID?: string | undefined, signal?: AbortSignal | undefined): Promise<CreditControlStatusModel>;

    /**
     * @param developmentID (optional) 
     * @param statusID (optional) 
     * @return Success
     */
    getCreditControlUnitBreakdown(developmentID?: string | undefined, statusID?: number | undefined, signal?: AbortSignal | undefined): Promise<CreditControlUnitModel>;
}

@injectable()
export class CPLClientPortalCreditControlClient extends CPLClientBase implements ICPLClientPortalCreditControlClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCreditControlDevelopmentSummaries(signal?: AbortSignal | undefined): Promise<CreditControlDevelopmentSummaryModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalCreditControl/GetCreditControlDevelopmentSummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditControlDevelopmentSummaries(_response);
        });
    }

    protected processGetCreditControlDevelopmentSummaries(response: Response): Promise<CreditControlDevelopmentSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CreditControlDevelopmentSummaryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CreditControlDevelopmentSummaryModel[]>(null as any);
    }

    /**
     * @param developmentID (optional) 
     * @return Success
     */
    getCreditControlStatusSummaries(developmentID?: string | undefined, signal?: AbortSignal | undefined): Promise<CreditControlStatusModel> {
        let url_ = this.baseUrl + "/api/ClientPortalCreditControl/GetCreditControlStatusSummaries?";
        if (developmentID === null)
            throw new globalThis.Error("The parameter 'developmentID' cannot be null.");
        else if (developmentID !== undefined)
            url_ += "developmentID=" + encodeURIComponent("" + developmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditControlStatusSummaries(_response);
        });
    }

    protected processGetCreditControlStatusSummaries(response: Response): Promise<CreditControlStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditControlStatusModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CreditControlStatusModel>(null as any);
    }

    /**
     * @param developmentID (optional) 
     * @param statusID (optional) 
     * @return Success
     */
    getCreditControlUnitBreakdown(developmentID?: string | undefined, statusID?: number | undefined, signal?: AbortSignal | undefined): Promise<CreditControlUnitModel> {
        let url_ = this.baseUrl + "/api/ClientPortalCreditControl/GetCreditControlUnitBreakdown?";
        if (developmentID === null)
            throw new globalThis.Error("The parameter 'developmentID' cannot be null.");
        else if (developmentID !== undefined)
            url_ += "developmentID=" + encodeURIComponent("" + developmentID) + "&";
        if (statusID === null)
            throw new globalThis.Error("The parameter 'statusID' cannot be null.");
        else if (statusID !== undefined)
            url_ += "statusID=" + encodeURIComponent("" + statusID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditControlUnitBreakdown(_response);
        });
    }

    protected processGetCreditControlUnitBreakdown(response: Response): Promise<CreditControlUnitModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditControlUnitModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CreditControlUnitModel>(null as any);
    }
}

export interface ICPLClientPortalDevelopmentsClient {

    /**
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getContacts(index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDevelopmentInfoModel[]>;
}

@injectable()
export class CPLClientPortalDevelopmentsClient extends CPLClientBase implements ICPLClientPortalDevelopmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getContacts(index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDevelopmentInfoModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalDevelopments/GetContacts?";
        if (index === null)
            throw new globalThis.Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContacts(_response);
        });
    }

    protected processGetContacts(response: Response): Promise<ClientPortalDevelopmentInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalDevelopmentInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalDevelopmentInfoModel[]>(null as any);
    }
}

export interface ICPLClientPortalDocumentsClient {

    /**
     * @param documentId (optional) 
     * @return Success
     */
    getDocumentInstances(documentId?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDocumentInstanceModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body?: ClientPortalDocumentFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDocumentModel[]>;

    /**
     * @param documentID (optional) 
     * @return Success
     */
    getDocumentAttachments(documentID?: string | undefined, signal?: AbortSignal | undefined): Promise<DocumentAttachmentModel[]>;

    downloadAttachmentFile(attachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    downloadDocumentFile(documentID?: string | undefined, filePath?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    /**
     * @return Success
     */
    getDocumentTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLClientPortalDocumentsClient extends CPLClientBase implements ICPLClientPortalDocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    getDocumentInstances(documentId?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDocumentInstanceModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/GetDocumentInstances?";
        if (documentId === null)
            throw new globalThis.Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentInstances(_response);
        });
    }

    protected processGetDocumentInstances(response: Response): Promise<ClientPortalDocumentInstanceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalDocumentInstanceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalDocumentInstanceModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body?: ClientPortalDocumentFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalDocumentModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<ClientPortalDocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalDocumentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalDocumentModel[]>(null as any);
    }

    /**
     * @param documentID (optional) 
     * @return Success
     */
    getDocumentAttachments(documentID?: string | undefined, signal?: AbortSignal | undefined): Promise<DocumentAttachmentModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/GetDocumentAttachments?";
        if (documentID === null)
            throw new globalThis.Error("The parameter 'documentID' cannot be null.");
        else if (documentID !== undefined)
            url_ += "documentID=" + encodeURIComponent("" + documentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentAttachments(_response);
        });
    }

    protected processGetDocumentAttachments(response: Response): Promise<DocumentAttachmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentAttachmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DocumentAttachmentModel[]>(null as any);
    }

    downloadAttachmentFile(attachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/DownloadAttachmentFile?";
        if (attachmentID === null)
            throw new globalThis.Error("The parameter 'attachmentID' cannot be null.");
        else if (attachmentID !== undefined)
            url_ += "attachmentID=" + encodeURIComponent("" + attachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachmentFile(_response);
        });
    }

    protected processDownloadAttachmentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadDocumentFile(documentID?: string | undefined, filePath?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/DownloadDocumentFile?";
        if (documentID === null)
            throw new globalThis.Error("The parameter 'documentID' cannot be null.");
        else if (documentID !== undefined)
            url_ += "documentID=" + encodeURIComponent("" + documentID) + "&";
        if (filePath === null)
            throw new globalThis.Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocumentFile(_response);
        });
    }

    protected processDownloadDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDocumentTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalDocuments/GetDocumentTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentTypeSelectModels(_response);
        });
    }

    protected processGetDocumentTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLClientPortalEmailsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmail(body?: ClientPortalEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLClientPortalEmailsClient extends CPLClientBase implements ICPLClientPortalEmailsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmail(body?: ClientPortalEmailModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalEmails/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLClientPortalGlobalSearchClient {

    /**
     * @param searchValue (optional) 
     * @return Success
     */
    globalSearch(searchValue?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalGlobalSearchResultModel[]>;
}

@injectable()
export class CPLClientPortalGlobalSearchClient extends CPLClientBase implements ICPLClientPortalGlobalSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param searchValue (optional) 
     * @return Success
     */
    globalSearch(searchValue?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalGlobalSearchResultModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalGlobalSearch/GlobalSearch?";
        if (searchValue === null)
            throw new globalThis.Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGlobalSearch(_response);
        });
    }

    protected processGlobalSearch(response: Response): Promise<ClientPortalGlobalSearchResultModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalGlobalSearchResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalGlobalSearchResultModel[]>(null as any);
    }
}

export interface ICPLClientPortalJobsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getJobs(body?: ClientPortalJobFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobOverviewModel[]>;

    /**
     * @param jobID (optional) 
     * @param taskSeqNo (optional) 
     * @return Success
     */
    getJobFromJobID(jobID?: number | undefined, taskSeqNo?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobDetailsModel>;

    /**
     * @param estimateRequestID (optional) 
     * @return Success
     */
    getJobFromEstimateRequestID(estimateRequestID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobDetailsModel>;
}

@injectable()
export class CPLClientPortalJobsClient extends CPLClientBase implements ICPLClientPortalJobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJobs(body?: ClientPortalJobFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobOverviewModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalJobs/GetJobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: Response): Promise<ClientPortalJobOverviewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalJobOverviewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalJobOverviewModel[]>(null as any);
    }

    /**
     * @param jobID (optional) 
     * @param taskSeqNo (optional) 
     * @return Success
     */
    getJobFromJobID(jobID?: number | undefined, taskSeqNo?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobDetailsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalJobs/GetJobFromJobID?";
        if (jobID === null)
            throw new globalThis.Error("The parameter 'jobID' cannot be null.");
        else if (jobID !== undefined)
            url_ += "jobID=" + encodeURIComponent("" + jobID) + "&";
        if (taskSeqNo === null)
            throw new globalThis.Error("The parameter 'taskSeqNo' cannot be null.");
        else if (taskSeqNo !== undefined)
            url_ += "taskSeqNo=" + encodeURIComponent("" + taskSeqNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobFromJobID(_response);
        });
    }

    protected processGetJobFromJobID(response: Response): Promise<ClientPortalJobDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalJobDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalJobDetailsModel>(null as any);
    }

    /**
     * @param estimateRequestID (optional) 
     * @return Success
     */
    getJobFromEstimateRequestID(estimateRequestID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalJobDetailsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalJobs/GetJobFromEstimateRequestID?";
        if (estimateRequestID === null)
            throw new globalThis.Error("The parameter 'estimateRequestID' cannot be null.");
        else if (estimateRequestID !== undefined)
            url_ += "estimateRequestID=" + encodeURIComponent("" + estimateRequestID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobFromEstimateRequestID(_response);
        });
    }

    protected processGetJobFromEstimateRequestID(response: Response): Promise<ClientPortalJobDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalJobDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalJobDetailsModel>(null as any);
    }
}

export interface ICPLClientPortalMeetingsClient {

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getClientPortalMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalMeetingModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getClientPortalMeetings(body?: ClientPortalMeetingsFilterModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalMeetingModel[]>;
}

@injectable()
export class CPLClientPortalMeetingsClient extends CPLClientBase implements ICPLClientPortalMeetingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getClientPortalMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalMeetingModel> {
        let url_ = this.baseUrl + "/api/ClientPortalMeetings/GetClientPortalMeeting?";
        if (meetingID === null)
            throw new globalThis.Error("The parameter 'meetingID' cannot be null.");
        else if (meetingID !== undefined)
            url_ += "meetingID=" + encodeURIComponent("" + meetingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalMeeting(_response);
        });
    }

    protected processGetClientPortalMeeting(response: Response): Promise<ClientPortalMeetingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalMeetingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalMeetingModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getClientPortalMeetings(body?: ClientPortalMeetingsFilterModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalMeetingModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalMeetings/GetClientPortalMeetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalMeetings(_response);
        });
    }

    protected processGetClientPortalMeetings(response: Response): Promise<ClientPortalMeetingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalMeetingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalMeetingModel[]>(null as any);
    }
}

export interface ICPLClientPortalMeetingTypesClient {

    /**
     * @return Success
     */
    getMeetingTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLClientPortalMeetingTypesClient extends CPLClientBase implements ICPLClientPortalMeetingTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getMeetingTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalMeetingTypes/GetMeetingTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingTypeSelectModels(_response);
        });
    }

    protected processGetMeetingTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLClientPortalNewsClient {

    /**
     * @param developmentNewsID (optional) 
     * @return Success
     */
    getNewsPost(developmentNewsID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel>;

    /**
     * @return Success
     */
    getLatestNews(signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel>;

    /**
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAllNews(index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel[]>;
}

@injectable()
export class CPLClientPortalNewsClient extends CPLClientBase implements ICPLClientPortalNewsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param developmentNewsID (optional) 
     * @return Success
     */
    getNewsPost(developmentNewsID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalNews/GetNewsPost?";
        if (developmentNewsID === null)
            throw new globalThis.Error("The parameter 'developmentNewsID' cannot be null.");
        else if (developmentNewsID !== undefined)
            url_ += "developmentNewsID=" + encodeURIComponent("" + developmentNewsID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewsPost(_response);
        });
    }

    protected processGetNewsPost(response: Response): Promise<ClientPortalNewsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalNewsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalNewsModel>(null as any);
    }

    /**
     * @return Success
     */
    getLatestNews(signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalNews/GetLatestNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestNews(_response);
        });
    }

    protected processGetLatestNews(response: Response): Promise<ClientPortalNewsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalNewsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalNewsModel>(null as any);
    }

    /**
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getAllNews(index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalNewsModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalNews/GetAllNews?";
        if (index === null)
            throw new globalThis.Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllNews(_response);
        });
    }

    protected processGetAllNews(response: Response): Promise<ClientPortalNewsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalNewsModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalNewsModel[]>(null as any);
    }
}

export interface ICPLClientPortalPaymentsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentRequest(body?: PaymentRequestModel | undefined, signal?: AbortSignal | undefined): Promise<CreatePaymentResponseModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    handleGoCardlessEvents(body?: Event[] | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    saveGoCardlessAccessToken(body?: GoCardlessAccessToken | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getGoCardlessAccessToken(signal?: AbortSignal | undefined): Promise<GoCardlessAccessToken>;

    /**
     * @return Success
     */
    deleteGoCardlessAccessToken(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param paymentDetailsJson (optional) 
     * @return Success
     */
    processBlinkPayment(paymentDetailsJson?: string | undefined, signal?: AbortSignal | undefined): Promise<BlinkProcessPaymentResponseModel>;

    /**
     * @param transaction_id (optional) 
     * @param status (optional) 
     * @param note (optional) 
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    handleBlinkTransactionComplete(transaction_id?: string | undefined, status?: string | undefined, note?: string | undefined, clientPortalPaymentID?: string | undefined, signal?: AbortSignal | undefined): Promise<boolean>;

    /**
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    getClientPortalPayment(clientPortalPaymentID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalPaymentModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    setPaymentConfirmationEmail(body?: PaymentConfirmationModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getAllowedDirectDebitCollectionDays(signal?: AbortSignal | undefined): Promise<number[]>;

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateMonthlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<MonthlyDirectDebitCalculationModel>;

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateQuarterlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<QuarterlyDirectDebitCalculationModel>;

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param frequency (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    setUpDirectDebit(clientID?: string | undefined, collectionDay?: number | undefined, frequency?: ClientDDFrequencies | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<DirectDebitSetupSuccessModel>;

    /**
     * @param clientID (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    cancelDirectDebit(clientID?: string | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLClientPortalPaymentsClient extends CPLClientBase implements ICPLClientPortalPaymentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentRequest(body?: PaymentRequestModel | undefined, signal?: AbortSignal | undefined): Promise<CreatePaymentResponseModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/CreatePaymentRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePaymentRequest(_response);
        });
    }

    protected processCreatePaymentRequest(response: Response): Promise<CreatePaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CreatePaymentResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    handleGoCardlessEvents(body?: Event[] | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/HandleGoCardlessEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandleGoCardlessEvents(_response);
        });
    }

    protected processHandleGoCardlessEvents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveGoCardlessAccessToken(body?: GoCardlessAccessToken | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/SaveGoCardlessAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveGoCardlessAccessToken(_response);
        });
    }

    protected processSaveGoCardlessAccessToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getGoCardlessAccessToken(signal?: AbortSignal | undefined): Promise<GoCardlessAccessToken> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/GetGoCardlessAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGoCardlessAccessToken(_response);
        });
    }

    protected processGetGoCardlessAccessToken(response: Response): Promise<GoCardlessAccessToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoCardlessAccessToken.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GoCardlessAccessToken>(null as any);
    }

    /**
     * @return Success
     */
    deleteGoCardlessAccessToken(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/DeleteGoCardlessAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteGoCardlessAccessToken(_response);
        });
    }

    protected processDeleteGoCardlessAccessToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param paymentDetailsJson (optional) 
     * @return Success
     */
    processBlinkPayment(paymentDetailsJson?: string | undefined, signal?: AbortSignal | undefined): Promise<BlinkProcessPaymentResponseModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/ProcessBlinkPayment?";
        if (paymentDetailsJson === null)
            throw new globalThis.Error("The parameter 'paymentDetailsJson' cannot be null.");
        else if (paymentDetailsJson !== undefined)
            url_ += "paymentDetailsJson=" + encodeURIComponent("" + paymentDetailsJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessBlinkPayment(_response);
        });
    }

    protected processProcessBlinkPayment(response: Response): Promise<BlinkProcessPaymentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlinkProcessPaymentResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<BlinkProcessPaymentResponseModel>(null as any);
    }

    /**
     * @param transaction_id (optional) 
     * @param status (optional) 
     * @param note (optional) 
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    handleBlinkTransactionComplete(transaction_id?: string | undefined, status?: string | undefined, note?: string | undefined, clientPortalPaymentID?: string | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/HandleBlinkTransactionComplete?";
        if (transaction_id === null)
            throw new globalThis.Error("The parameter 'transaction_id' cannot be null.");
        else if (transaction_id !== undefined)
            url_ += "transaction_id=" + encodeURIComponent("" + transaction_id) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (clientPortalPaymentID === null)
            throw new globalThis.Error("The parameter 'clientPortalPaymentID' cannot be null.");
        else if (clientPortalPaymentID !== undefined)
            url_ += "clientPortalPaymentID=" + encodeURIComponent("" + clientPortalPaymentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandleBlinkTransactionComplete(_response);
        });
    }

    protected processHandleBlinkTransactionComplete(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    getClientPortalPayment(clientPortalPaymentID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalPaymentModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/GetClientPortalPayment?";
        if (clientPortalPaymentID === null)
            throw new globalThis.Error("The parameter 'clientPortalPaymentID' cannot be null.");
        else if (clientPortalPaymentID !== undefined)
            url_ += "clientPortalPaymentID=" + encodeURIComponent("" + clientPortalPaymentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalPayment(_response);
        });
    }

    protected processGetClientPortalPayment(response: Response): Promise<ClientPortalPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalPaymentModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setPaymentConfirmationEmail(body?: PaymentConfirmationModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/SetPaymentConfirmationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPaymentConfirmationEmail(_response);
        });
    }

    protected processSetPaymentConfirmationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllowedDirectDebitCollectionDays(signal?: AbortSignal | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/GetAllowedDirectDebitCollectionDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedDirectDebitCollectionDays(_response);
        });
    }

    protected processGetAllowedDirectDebitCollectionDays(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateMonthlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<MonthlyDirectDebitCalculationModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/CalculateMonthlyDirectDebitDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (collectionDay === null)
            throw new globalThis.Error("The parameter 'collectionDay' cannot be null.");
        else if (collectionDay !== undefined)
            url_ += "collectionDay=" + encodeURIComponent("" + collectionDay) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateMonthlyDirectDebitDetails(_response);
        });
    }

    protected processCalculateMonthlyDirectDebitDetails(response: Response): Promise<MonthlyDirectDebitCalculationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDirectDebitCalculationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<MonthlyDirectDebitCalculationModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateQuarterlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<QuarterlyDirectDebitCalculationModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/CalculateQuarterlyDirectDebitDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (collectionDay === null)
            throw new globalThis.Error("The parameter 'collectionDay' cannot be null.");
        else if (collectionDay !== undefined)
            url_ += "collectionDay=" + encodeURIComponent("" + collectionDay) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateQuarterlyDirectDebitDetails(_response);
        });
    }

    protected processCalculateQuarterlyDirectDebitDetails(response: Response): Promise<QuarterlyDirectDebitCalculationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuarterlyDirectDebitCalculationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<QuarterlyDirectDebitCalculationModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param frequency (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    setUpDirectDebit(clientID?: string | undefined, collectionDay?: number | undefined, frequency?: ClientDDFrequencies | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<DirectDebitSetupSuccessModel> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/SetUpDirectDebit?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (collectionDay === null)
            throw new globalThis.Error("The parameter 'collectionDay' cannot be null.");
        else if (collectionDay !== undefined)
            url_ += "collectionDay=" + encodeURIComponent("" + collectionDay) + "&";
        if (frequency === null)
            throw new globalThis.Error("The parameter 'frequency' cannot be null.");
        else if (frequency !== undefined)
            url_ += "frequency=" + encodeURIComponent("" + frequency) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUpDirectDebit(_response);
        });
    }

    protected processSetUpDirectDebit(response: Response): Promise<DirectDebitSetupSuccessModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectDebitSetupSuccessModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DirectDebitSetupSuccessModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    cancelDirectDebit(clientID?: string | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalPayments/CancelDirectDebit?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelDirectDebit(_response);
        });
    }

    protected processCancelDirectDebit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLClientPortalPropertiesClient {

    /**
     * @return Success
     */
    getPropertySelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLClientPortalPropertiesClient extends CPLClientBase implements ICPLClientPortalPropertiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getPropertySelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalProperties/GetPropertySelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertySelectModels(_response);
        });
    }

    protected processGetPropertySelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLClientPortalProposedWorksClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getProposedWorks(body?: ClientPortalProposedWorkFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkModel[]>;

    /**
     * @param proposedWorksID (optional) 
     * @return Success
     */
    getProposedWorkDetails(proposedWorksID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkDetailsModel>;

    /**
     * @param proposedWorkID (optional) 
     * @param agreed (optional) 
     * @return Success
     */
    voteOnProposedWork(proposedWorkID?: string | undefined, agreed?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param proposedWorksID (optional) 
     * @return Success
     */
    getProposedWorkDocuments(proposedWorksID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkDocumentModel[]>;
}

@injectable()
export class CPLClientPortalProposedWorksClient extends CPLClientBase implements ICPLClientPortalProposedWorksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getProposedWorks(body?: ClientPortalProposedWorkFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalProposedWorks/GetProposedWorks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposedWorks(_response);
        });
    }

    protected processGetProposedWorks(response: Response): Promise<ClientPortalProposedWorkModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalProposedWorkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalProposedWorkModel[]>(null as any);
    }

    /**
     * @param proposedWorksID (optional) 
     * @return Success
     */
    getProposedWorkDetails(proposedWorksID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkDetailsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalProposedWorks/GetProposedWorkDetails?";
        if (proposedWorksID === null)
            throw new globalThis.Error("The parameter 'proposedWorksID' cannot be null.");
        else if (proposedWorksID !== undefined)
            url_ += "proposedWorksID=" + encodeURIComponent("" + proposedWorksID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposedWorkDetails(_response);
        });
    }

    protected processGetProposedWorkDetails(response: Response): Promise<ClientPortalProposedWorkDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalProposedWorkDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalProposedWorkDetailsModel>(null as any);
    }

    /**
     * @param proposedWorkID (optional) 
     * @param agreed (optional) 
     * @return Success
     */
    voteOnProposedWork(proposedWorkID?: string | undefined, agreed?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalProposedWorks/VoteOnProposedWork?";
        if (proposedWorkID === null)
            throw new globalThis.Error("The parameter 'proposedWorkID' cannot be null.");
        else if (proposedWorkID !== undefined)
            url_ += "proposedWorkID=" + encodeURIComponent("" + proposedWorkID) + "&";
        if (agreed === null)
            throw new globalThis.Error("The parameter 'agreed' cannot be null.");
        else if (agreed !== undefined)
            url_ += "agreed=" + encodeURIComponent("" + agreed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVoteOnProposedWork(_response);
        });
    }

    protected processVoteOnProposedWork(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param proposedWorksID (optional) 
     * @return Success
     */
    getProposedWorkDocuments(proposedWorksID?: string | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalProposedWorkDocumentModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalProposedWorks/GetProposedWorkDocuments?";
        if (proposedWorksID === null)
            throw new globalThis.Error("The parameter 'proposedWorksID' cannot be null.");
        else if (proposedWorksID !== undefined)
            url_ += "proposedWorksID=" + encodeURIComponent("" + proposedWorksID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposedWorkDocuments(_response);
        });
    }

    protected processGetProposedWorkDocuments(response: Response): Promise<ClientPortalProposedWorkDocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalProposedWorkDocumentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalProposedWorkDocumentModel[]>(null as any);
    }
}

export interface ICPLClientPortalProposedWorkTypesClient {

    /**
     * @return Success
     */
    getProposedWorksTypesSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLClientPortalProposedWorkTypesClient extends CPLClientBase implements ICPLClientPortalProposedWorkTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getProposedWorksTypesSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalProposedWorkTypes/GetProposedWorksTypesSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProposedWorksTypesSelectModels(_response);
        });
    }

    protected processGetProposedWorksTypesSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLClientPortalSettingsClient {

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getBooleanSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<boolean>;

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getStringSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getIntSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @return Success
     */
    getGlobalClientPortalSettings(signal?: AbortSignal | undefined): Promise<GlobalClientPortalSettingsModel>;
}

@injectable()
export class CPLClientPortalSettingsClient extends CPLClientBase implements ICPLClientPortalSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getBooleanSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalSettings/GetBooleanSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBooleanSetting(_response);
        });
    }

    protected processGetBooleanSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getStringSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ClientPortalSettings/GetStringSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStringSetting(_response);
        });
    }

    protected processGetStringSetting(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getIntSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ClientPortalSettings/GetIntSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntSetting(_response);
        });
    }

    protected processGetIntSetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    getGlobalClientPortalSettings(signal?: AbortSignal | undefined): Promise<GlobalClientPortalSettingsModel> {
        let url_ = this.baseUrl + "/api/ClientPortalSettings/GetGlobalClientPortalSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalClientPortalSettings(_response);
        });
    }

    protected processGetGlobalClientPortalSettings(response: Response): Promise<GlobalClientPortalSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalClientPortalSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GlobalClientPortalSettingsModel>(null as any);
    }
}

export interface ICPLClientPortalWebNarrativesClient {

    /**
     * @param clientPortalWebNarrativeID (optional) 
     * @return Success
     */
    getClientPortalWebNarrative(clientPortalWebNarrativeID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalWebNarrativeModel>;
}

@injectable()
export class CPLClientPortalWebNarrativesClient extends CPLClientBase implements ICPLClientPortalWebNarrativesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientPortalWebNarrativeID (optional) 
     * @return Success
     */
    getClientPortalWebNarrative(clientPortalWebNarrativeID?: number | undefined, signal?: AbortSignal | undefined): Promise<ClientPortalWebNarrativeModel> {
        let url_ = this.baseUrl + "/api/ClientPortalWebNarratives/GetClientPortalWebNarrative?";
        if (clientPortalWebNarrativeID === null)
            throw new globalThis.Error("The parameter 'clientPortalWebNarrativeID' cannot be null.");
        else if (clientPortalWebNarrativeID !== undefined)
            url_ += "clientPortalWebNarrativeID=" + encodeURIComponent("" + clientPortalWebNarrativeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalWebNarrative(_response);
        });
    }

    protected processGetClientPortalWebNarrative(response: Response): Promise<ClientPortalWebNarrativeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalWebNarrativeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalWebNarrativeModel>(null as any);
    }
}

export interface ICPLClientsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectModels(body?: ClientSelectRequestModel | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getLinkedClientSelectModels(body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLClientsClient extends CPLClientBase implements ICPLClientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSelectModels(body?: ClientSelectRequestModel | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Clients/GetSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLinkedClientSelectModels(body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Clients/GetLinkedClientSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkedClientSelectModels(_response);
        });
    }

    protected processGetLinkedClientSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLCommentsClient {

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getComments(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentModel[]>;

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getCommentThreadRecipients(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentThreadRecipientModel[]>;

    /**
     * @param private (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createSystemComment(formData: { private?: boolean | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param private (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createComment(formData: { private?: boolean | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param singleUseToken (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createExternalAccessComment(formData: { singleUseToken?: string | null | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param private (optional) 
     * @param commentID (optional) 
     * @param message (optional) 
     * @param deletedAttachmentIDs (optional) 
     * @param newAttachments (optional) 
     * @return Success
     */
    updateComment(formData: { private?: boolean | undefined, commentID?: number | undefined, message?: string | null | undefined, deletedAttachmentIDs?: number[] | null | undefined, newAttachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param commentID (optional) 
     * @return Success
     */
    makeCommentPublic(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param commentID (optional) 
     * @return Success
     */
    deleteComment(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param recipientID (optional) 
     * @return Success
     */
    deleteRecipient(recipientID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    addRecipient(body?: NewCommentRecipientModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    downloadCommentAttachment(commentAttachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    /**
     * @param commentID (optional) 
     * @param commentThreadID (optional) 
     * @return Success
     */
    updateCommentReadStatus(commentID?: number | undefined, commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLCommentsClient extends CPLClientBase implements ICPLCommentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getComments(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentModel[]> {
        let url_ = this.baseUrl + "/api/Comments/GetComments?";
        if (commentThreadID === null)
            throw new globalThis.Error("The parameter 'commentThreadID' cannot be null.");
        else if (commentThreadID !== undefined)
            url_ += "commentThreadID=" + encodeURIComponent("" + commentThreadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetComments(_response);
        });
    }

    protected processGetComments(response: Response): Promise<CommentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CommentModel[]>(null as any);
    }

    /**
     * @param commentThreadID (optional) 
     * @return Success
     */
    getCommentThreadRecipients(commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<CommentThreadRecipientModel[]> {
        let url_ = this.baseUrl + "/api/Comments/GetCommentThreadRecipients?";
        if (commentThreadID === null)
            throw new globalThis.Error("The parameter 'commentThreadID' cannot be null.");
        else if (commentThreadID !== undefined)
            url_ += "commentThreadID=" + encodeURIComponent("" + commentThreadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommentThreadRecipients(_response);
        });
    }

    protected processGetCommentThreadRecipients(response: Response): Promise<CommentThreadRecipientModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentThreadRecipientModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CommentThreadRecipientModel[]>(null as any);
    }

    /**
     * @param private (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createSystemComment(formData: { private?: boolean | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Comments/CreateSystemComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.private === null || formData.private === undefined)
            throw new Error("The parameter 'private' cannot be null.");
        else
            content_.append("Private", formData.private.toString());
        if (formData.commentThreadID === null || formData.commentThreadID === undefined)
            throw new Error("The parameter 'commentThreadID' cannot be null.");
        else
            content_.append("CommentThreadID", formData.commentThreadID.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.attachments !== null && formData.attachments !== undefined)
            formData.attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSystemComment(_response);
        });
    }

    protected processCreateSystemComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param private (optional) 
     * @param commentThreadID (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createComment(formData: { private?: boolean | undefined, commentThreadID?: string | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Comments/CreateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.private === null || formData.private === undefined)
            throw new Error("The parameter 'private' cannot be null.");
        else
            content_.append("Private", formData.private.toString());
        if (formData.commentThreadID === null || formData.commentThreadID === undefined)
            throw new Error("The parameter 'commentThreadID' cannot be null.");
        else
            content_.append("CommentThreadID", formData.commentThreadID.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.attachments !== null && formData.attachments !== undefined)
            formData.attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param singleUseToken (optional) 
     * @param message (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    createExternalAccessComment(formData: { singleUseToken?: string | null | undefined, message?: string | null | undefined, attachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Comments/CreateExternalAccessComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.singleUseToken !== null && formData.singleUseToken !== undefined)
            content_.append("SingleUseToken", formData.singleUseToken.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.attachments !== null && formData.attachments !== undefined)
            formData.attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateExternalAccessComment(_response);
        });
    }

    protected processCreateExternalAccessComment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param private (optional) 
     * @param commentID (optional) 
     * @param message (optional) 
     * @param deletedAttachmentIDs (optional) 
     * @param newAttachments (optional) 
     * @return Success
     */
    updateComment(formData: { private?: boolean | undefined, commentID?: number | undefined, message?: string | null | undefined, deletedAttachmentIDs?: number[] | null | undefined, newAttachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/UpdateComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.private === null || formData.private === undefined)
            throw new Error("The parameter 'private' cannot be null.");
        else
            content_.append("Private", formData.private.toString());
        if (formData.commentID === null || formData.commentID === undefined)
            throw new Error("The parameter 'commentID' cannot be null.");
        else
            content_.append("CommentID", formData.commentID.toString());
        if (formData.message !== null && formData.message !== undefined)
            content_.append("Message", formData.message.toString());
        if (formData.deletedAttachmentIDs !== null && formData.deletedAttachmentIDs !== undefined)
            formData.deletedAttachmentIDs.forEach(item_ => content_.append("DeletedAttachmentIDs", item_.toString()));
        if (formData.newAttachments !== null && formData.newAttachments !== undefined)
            formData.newAttachments.forEach(item_ => content_.append("NewAttachments", item_.data, item_.fileName ? item_.fileName : "NewAttachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param commentID (optional) 
     * @return Success
     */
    makeCommentPublic(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/MakeCommentPublic?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMakeCommentPublic(_response);
        });
    }

    protected processMakeCommentPublic(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param commentID (optional) 
     * @return Success
     */
    deleteComment(commentID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/DeleteComment?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param recipientID (optional) 
     * @return Success
     */
    deleteRecipient(recipientID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/DeleteRecipient?";
        if (recipientID === null)
            throw new globalThis.Error("The parameter 'recipientID' cannot be null.");
        else if (recipientID !== undefined)
            url_ += "recipientID=" + encodeURIComponent("" + recipientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRecipient(_response);
        });
    }

    protected processDeleteRecipient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRecipient(body?: NewCommentRecipientModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/AddRecipient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddRecipient(_response);
        });
    }

    protected processAddRecipient(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    downloadCommentAttachment(commentAttachmentID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Comments/DownloadCommentAttachment?";
        if (commentAttachmentID === null)
            throw new globalThis.Error("The parameter 'commentAttachmentID' cannot be null.");
        else if (commentAttachmentID !== undefined)
            url_ += "commentAttachmentID=" + encodeURIComponent("" + commentAttachmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadCommentAttachment(_response);
        });
    }

    protected processDownloadCommentAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param commentID (optional) 
     * @param commentThreadID (optional) 
     * @return Success
     */
    updateCommentReadStatus(commentID?: number | undefined, commentThreadID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Comments/UpdateCommentReadStatus?";
        if (commentID === null)
            throw new globalThis.Error("The parameter 'commentID' cannot be null.");
        else if (commentID !== undefined)
            url_ += "commentID=" + encodeURIComponent("" + commentID) + "&";
        if (commentThreadID === null)
            throw new globalThis.Error("The parameter 'commentThreadID' cannot be null.");
        else if (commentThreadID !== undefined)
            url_ += "commentThreadID=" + encodeURIComponent("" + commentThreadID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCommentReadStatus(_response);
        });
    }

    protected processUpdateCommentReadStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLCookieReflectionClient {

    /**
     * @param imageToken (optional) 
     * @return Success
     */
    reflectImageCookie(imageToken?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    deleteImageCookie(signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLCookieReflectionClient extends CPLClientBase implements ICPLCookieReflectionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param imageToken (optional) 
     * @return Success
     */
    reflectImageCookie(imageToken?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CookieReflection/ReflectImageCookie?";
        if (imageToken === null)
            throw new globalThis.Error("The parameter 'imageToken' cannot be null.");
        else if (imageToken !== undefined)
            url_ += "imageToken=" + encodeURIComponent("" + imageToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReflectImageCookie(_response);
        });
    }

    protected processReflectImageCookie(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteImageCookie(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CookieReflection/DeleteImageCookie";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteImageCookie(_response);
        });
    }

    protected processDeleteImageCookie(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLCPL3SettingsClient {

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getBooleanSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<boolean>;

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateBooleanSetting(settingType?: CPL3Settings | undefined, value?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getStringSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateStringSetting(settingType?: CPL3Settings | undefined, value?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getIntSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateIntSetting(settingType?: CPL3Settings | undefined, value?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLCPL3SettingsClient extends CPLClientBase implements ICPLCPL3SettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getBooleanSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/CPL3Settings/GetBooleanSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBooleanSetting(_response);
        });
    }

    protected processGetBooleanSetting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateBooleanSetting(settingType?: CPL3Settings | undefined, value?: boolean | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CPL3Settings/UpdateBooleanSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBooleanSetting(_response);
        });
    }

    protected processUpdateBooleanSetting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getStringSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/CPL3Settings/GetStringSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStringSetting(_response);
        });
    }

    protected processGetStringSetting(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateStringSetting(settingType?: CPL3Settings | undefined, value?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CPL3Settings/UpdateStringSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStringSetting(_response);
        });
    }

    protected processUpdateStringSetting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @return Success
     */
    getIntSetting(settingType?: CPL3Settings | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CPL3Settings/GetIntSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIntSetting(_response);
        });
    }

    protected processGetIntSetting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param settingType (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateIntSetting(settingType?: CPL3Settings | undefined, value?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CPL3Settings/UpdateIntSetting?";
        if (settingType === null)
            throw new globalThis.Error("The parameter 'settingType' cannot be null.");
        else if (settingType !== undefined)
            url_ += "settingType=" + encodeURIComponent("" + settingType) + "&";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateIntSetting(_response);
        });
    }

    protected processUpdateIntSetting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLCPLCoreConnectClient {

    /**
     * @param customURISchemeType (optional) 
     * @param jsonDataModel (optional) 
     * @return Success
     */
    saveCustomData(customURISchemeType?: CustomURISchemeTypes | undefined, jsonDataModel?: string | undefined, signal?: AbortSignal | undefined): Promise<number>;
}

@injectable()
export class CPLCPLCoreConnectClient extends CPLClientBase implements ICPLCPLCoreConnectClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param customURISchemeType (optional) 
     * @param jsonDataModel (optional) 
     * @return Success
     */
    saveCustomData(customURISchemeType?: CustomURISchemeTypes | undefined, jsonDataModel?: string | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CPLCoreConnect/SaveCustomData?";
        if (customURISchemeType === null)
            throw new globalThis.Error("The parameter 'customURISchemeType' cannot be null.");
        else if (customURISchemeType !== undefined)
            url_ += "customURISchemeType=" + encodeURIComponent("" + customURISchemeType) + "&";
        if (jsonDataModel === null)
            throw new globalThis.Error("The parameter 'jsonDataModel' cannot be null.");
        else if (jsonDataModel !== undefined)
            url_ += "jsonDataModel=" + encodeURIComponent("" + jsonDataModel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCustomData(_response);
        });
    }

    protected processSaveCustomData(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICPLDashboardClient {

    /**
     * @return Success
     */
    getDailyItinerary(signal?: AbortSignal | undefined): Promise<DailyItineraryItemModel[]>;

    /**
     * @return Success
     */
    getWeeklyMeetings(signal?: AbortSignal | undefined): Promise<CalendarEventModel[]>;

    /**
     * @return Success
     */
    getActionableCases(signal?: AbortSignal | undefined): Promise<CaseModel[]>;
}

@injectable()
export class CPLDashboardClient extends CPLClientBase implements ICPLDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getDailyItinerary(signal?: AbortSignal | undefined): Promise<DailyItineraryItemModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetDailyItinerary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDailyItinerary(_response);
        });
    }

    protected processGetDailyItinerary(response: Response): Promise<DailyItineraryItemModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DailyItineraryItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DailyItineraryItemModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getWeeklyMeetings(signal?: AbortSignal | undefined): Promise<CalendarEventModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetWeeklyMeetings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWeeklyMeetings(_response);
        });
    }

    protected processGetWeeklyMeetings(response: Response): Promise<CalendarEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarEventModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CalendarEventModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getActionableCases(signal?: AbortSignal | undefined): Promise<CaseModel[]> {
        let url_ = this.baseUrl + "/api/Dashboard/GetActionableCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActionableCases(_response);
        });
    }

    protected processGetActionableCases(response: Response): Promise<CaseModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CaseModel[]>(null as any);
    }
}

export interface ICPLDevelopmentsClient {

    /**
     * @return Success
     */
    get(signal?: AbortSignal | undefined): Promise<DevelopmentModel[]>;

    /**
     * @param isServiceChargeOnly (optional) 
     * @return Success
     */
    getSelectModels(isServiceChargeOnly?: boolean | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLDevelopmentsClient extends CPLClientBase implements ICPLDevelopmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    get(signal?: AbortSignal | undefined): Promise<DevelopmentModel[]> {
        let url_ = this.baseUrl + "/api/Developments/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<DevelopmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DevelopmentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DevelopmentModel[]>(null as any);
    }

    /**
     * @param isServiceChargeOnly (optional) 
     * @return Success
     */
    getSelectModels(isServiceChargeOnly?: boolean | undefined, signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Developments/GetSelectModels?";
        if (isServiceChargeOnly === null)
            throw new globalThis.Error("The parameter 'isServiceChargeOnly' cannot be null.");
        else if (isServiceChargeOnly !== undefined)
            url_ += "isServiceChargeOnly=" + encodeURIComponent("" + isServiceChargeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLDirectDebitCalculationClient {

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateMonthlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<MonthlyDirectDebitCalculationModel>;

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateQuarterlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<QuarterlyDirectDebitCalculationModel>;
}

@injectable()
export class CPLDirectDebitCalculationClient extends CPLClientBase implements ICPLDirectDebitCalculationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateMonthlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<MonthlyDirectDebitCalculationModel> {
        let url_ = this.baseUrl + "/api/DirectDebitCalculation/CalculateMonthlyDirectDebitDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (collectionDay === null)
            throw new globalThis.Error("The parameter 'collectionDay' cannot be null.");
        else if (collectionDay !== undefined)
            url_ += "collectionDay=" + encodeURIComponent("" + collectionDay) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateMonthlyDirectDebitDetails(_response);
        });
    }

    protected processCalculateMonthlyDirectDebitDetails(response: Response): Promise<MonthlyDirectDebitCalculationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDirectDebitCalculationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<MonthlyDirectDebitCalculationModel>(null as any);
    }

    /**
     * @param clientID (optional) 
     * @param collectionDay (optional) 
     * @param fundScheduleChargeCategoryID (optional) 
     * @return Success
     */
    calculateQuarterlyDirectDebitDetails(clientID?: string | undefined, collectionDay?: number | undefined, fundScheduleChargeCategoryID?: FundScheduleChargeCategories | undefined, signal?: AbortSignal | undefined): Promise<QuarterlyDirectDebitCalculationModel> {
        let url_ = this.baseUrl + "/api/DirectDebitCalculation/CalculateQuarterlyDirectDebitDetails?";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        if (collectionDay === null)
            throw new globalThis.Error("The parameter 'collectionDay' cannot be null.");
        else if (collectionDay !== undefined)
            url_ += "collectionDay=" + encodeURIComponent("" + collectionDay) + "&";
        if (fundScheduleChargeCategoryID === null)
            throw new globalThis.Error("The parameter 'fundScheduleChargeCategoryID' cannot be null.");
        else if (fundScheduleChargeCategoryID !== undefined)
            url_ += "fundScheduleChargeCategoryID=" + encodeURIComponent("" + fundScheduleChargeCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateQuarterlyDirectDebitDetails(_response);
        });
    }

    protected processCalculateQuarterlyDirectDebitDetails(response: Response): Promise<QuarterlyDirectDebitCalculationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuarterlyDirectDebitCalculationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<QuarterlyDirectDebitCalculationModel>(null as any);
    }
}

export interface ICPLDirectDebitCollectionDaysClient {

    /**
     * @return Success
     */
    getDirectDebitCollectionDays(signal?: AbortSignal | undefined): Promise<DirectDebitCollectionDayModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllowedCollectionDays(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLDirectDebitCollectionDaysClient extends CPLClientBase implements ICPLDirectDebitCollectionDaysClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getDirectDebitCollectionDays(signal?: AbortSignal | undefined): Promise<DirectDebitCollectionDayModel[]> {
        let url_ = this.baseUrl + "/api/DirectDebitCollectionDays/GetDirectDebitCollectionDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDirectDebitCollectionDays(_response);
        });
    }

    protected processGetDirectDebitCollectionDays(response: Response): Promise<DirectDebitCollectionDayModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectDebitCollectionDayModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DirectDebitCollectionDayModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllowedCollectionDays(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DirectDebitCollectionDays/UpdateAllowedCollectionDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAllowedCollectionDays(_response);
        });
    }

    protected processUpdateAllowedCollectionDays(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLDirectorsClient {

    /**
     * @param body (optional) 
     * @return Created
     */
    createDirector(body?: NewDirectorModel | undefined, signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getDirectors(includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DirectorModel[]>;

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getDirector(directorID: string, includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DirectorModel>;

    /**
     * @return No Content
     */
    deleteDirector(directorID: string, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDirector(body?: UpdateDirectorModel | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLDirectorsClient extends CPLClientBase implements ICPLDirectorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createDirector(body?: NewDirectorModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Directors/CreateDirector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDirector(_response);
        });
    }

    protected processCreateDirector(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getDirectors(includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DirectorModel[]> {
        let url_ = this.baseUrl + "/api/Directors/GetDirectors?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDirectors(_response);
        });
    }

    protected processGetDirectors(response: Response): Promise<DirectorModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DirectorModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DirectorModel[]>(null as any);
    }

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getDirector(directorID: string, includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DirectorModel> {
        let url_ = this.baseUrl + "/api/Directors/GetDirector/{directorID}?";
        if (directorID === undefined || directorID === null)
            throw new globalThis.Error("The parameter 'directorID' must be defined.");
        url_ = url_.replace("{directorID}", encodeURIComponent("" + directorID));
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDirector(_response);
        });
    }

    protected processGetDirector(response: Response): Promise<DirectorModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DirectorModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DirectorModel>(null as any);
    }

    /**
     * @return No Content
     */
    deleteDirector(directorID: string, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Directors/DeleteDirector/{directorID}";
        if (directorID === undefined || directorID === null)
            throw new globalThis.Error("The parameter 'directorID' must be defined.");
        url_ = url_.replace("{directorID}", encodeURIComponent("" + directorID));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDirector(_response);
        });
    }

    protected processDeleteDirector(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateDirector(body?: UpdateDirectorModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Directors/UpdateDirector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDirector(_response);
        });
    }

    protected processUpdateDirector(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLDocumentSubTypesClient {

    /**
     * @return Success
     */
    getDocumentSubTypes(signal?: AbortSignal | undefined): Promise<DocumentSubTypeModel[]>;

    /**
     * @param name (optional) 
     * @param documentTypeID (optional) 
     * @return Success
     */
    createDocumentSubType(name?: string | undefined, documentTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentSubType(body?: DocumentSubTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param documentSubTypeID (optional) 
     * @return Success
     */
    deleteDocumentSubType(documentSubTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLDocumentSubTypesClient extends CPLClientBase implements ICPLDocumentSubTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getDocumentSubTypes(signal?: AbortSignal | undefined): Promise<DocumentSubTypeModel[]> {
        let url_ = this.baseUrl + "/api/DocumentSubTypes/GetDocumentSubTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentSubTypes(_response);
        });
    }

    protected processGetDocumentSubTypes(response: Response): Promise<DocumentSubTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentSubTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DocumentSubTypeModel[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param documentTypeID (optional) 
     * @return Success
     */
    createDocumentSubType(name?: string | undefined, documentTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentSubTypes/CreateDocumentSubType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (documentTypeID === null)
            throw new globalThis.Error("The parameter 'documentTypeID' cannot be null.");
        else if (documentTypeID !== undefined)
            url_ += "documentTypeID=" + encodeURIComponent("" + documentTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateDocumentSubType(_response);
        });
    }

    protected processCreateDocumentSubType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentSubType(body?: DocumentSubTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentSubTypes/UpdateDocumentSubType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDocumentSubType(_response);
        });
    }

    protected processUpdateDocumentSubType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param documentSubTypeID (optional) 
     * @return Success
     */
    deleteDocumentSubType(documentSubTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/DocumentSubTypes/DeleteDocumentSubType?";
        if (documentSubTypeID === null)
            throw new globalThis.Error("The parameter 'documentSubTypeID' cannot be null.");
        else if (documentSubTypeID !== undefined)
            url_ += "documentSubTypeID=" + encodeURIComponent("" + documentSubTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocumentSubType(_response);
        });
    }

    protected processDeleteDocumentSubType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLDocumentTypesClient {

    /**
     * @param includeHidden (optional) 
     * @return Success
     */
    getDocumentTypes(includeHidden?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DocumentTypeModel[]>;
}

@injectable()
export class CPLDocumentTypesClient extends CPLClientBase implements ICPLDocumentTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param includeHidden (optional) 
     * @return Success
     */
    getDocumentTypes(includeHidden?: boolean | undefined, signal?: AbortSignal | undefined): Promise<DocumentTypeModel[]> {
        let url_ = this.baseUrl + "/api/DocumentTypes/GetDocumentTypes?";
        if (includeHidden === null)
            throw new globalThis.Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "includeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentTypes(_response);
        });
    }

    protected processGetDocumentTypes(response: Response): Promise<DocumentTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<DocumentTypeModel[]>(null as any);
    }
}

export interface ICPLEstimatesClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getEstimates(body?: EstimateFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<EstimateModel[]>;

    /**
     * @param estimateID (optional) 
     * @return Success
     */
    getEstimate(estimateID?: string | undefined, signal?: AbortSignal | undefined): Promise<EstimateModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommentThreadForEstimate(body?: NewEstimateCommentThreadModel | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLEstimatesClient extends CPLClientBase implements ICPLEstimatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEstimates(body?: EstimateFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<EstimateModel[]> {
        let url_ = this.baseUrl + "/api/Estimates/GetEstimates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEstimates(_response);
        });
    }

    protected processGetEstimates(response: Response): Promise<EstimateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EstimateModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<EstimateModel[]>(null as any);
    }

    /**
     * @param estimateID (optional) 
     * @return Success
     */
    getEstimate(estimateID?: string | undefined, signal?: AbortSignal | undefined): Promise<EstimateModel> {
        let url_ = this.baseUrl + "/api/Estimates/GetEstimate?";
        if (estimateID === null)
            throw new globalThis.Error("The parameter 'estimateID' cannot be null.");
        else if (estimateID !== undefined)
            url_ += "estimateID=" + encodeURIComponent("" + estimateID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEstimate(_response);
        });
    }

    protected processGetEstimate(response: Response): Promise<EstimateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EstimateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<EstimateModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommentThreadForEstimate(body?: NewEstimateCommentThreadModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Estimates/CreateCommentThreadForEstimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCommentThreadForEstimate(_response);
        });
    }

    protected processCreateCommentThreadForEstimate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLApiClient {

    file(signal?: AbortSignal | undefined): Promise<FileResponse>;
}

@injectable()
export class CPLApiClient extends CPLClientBase implements ICPLApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    file(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/file";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICPLFreeholderPaymentClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getFreeholderPaymentPrelist(body?: FreeholderPaymentPrelistFilterModel | undefined, signal?: AbortSignal | undefined): Promise<FreeholderPaymentPrelistModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    processFreeholderPayments(body?: FreeholderPaymentPrelistModel[] | undefined, signal?: AbortSignal | undefined): Promise<ProcessFreeholderPaymentsModel>;
}

@injectable()
export class CPLFreeholderPaymentClient extends CPLClientBase implements ICPLFreeholderPaymentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFreeholderPaymentPrelist(body?: FreeholderPaymentPrelistFilterModel | undefined, signal?: AbortSignal | undefined): Promise<FreeholderPaymentPrelistModel[]> {
        let url_ = this.baseUrl + "/api/FreeholderPayment/GetFreeholderPaymentPrelist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFreeholderPaymentPrelist(_response);
        });
    }

    protected processGetFreeholderPaymentPrelist(response: Response): Promise<FreeholderPaymentPrelistModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreeholderPaymentPrelistModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FreeholderPaymentPrelistModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processFreeholderPayments(body?: FreeholderPaymentPrelistModel[] | undefined, signal?: AbortSignal | undefined): Promise<ProcessFreeholderPaymentsModel> {
        let url_ = this.baseUrl + "/api/FreeholderPayment/ProcessFreeholderPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processProcessFreeholderPayments(_response);
        });
    }

    protected processProcessFreeholderPayments(response: Response): Promise<ProcessFreeholderPaymentsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProcessFreeholderPaymentsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ProcessFreeholderPaymentsModel>(null as any);
    }
}

export interface ICPLFreeholderStatementClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    previewFreeholderStatementReport(body?: FreeholderStatementSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param backgroundProcessID (optional) 
     * @param body (optional) 
     * @return Success
     */
    acceptFreeholderStatementReport(backgroundProcessID?: number | undefined, body?: FreeholderStatementSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param documentBatchID (optional) 
     * @return Success
     */
    printFreeholderStatementReport(documentBatchID?: number | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;

    /**
     * @param documentBatchID (optional) 
     * @return Success
     */
    emailFreeholderStatementReport(documentBatchID?: number | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;
}

@injectable()
export class CPLFreeholderStatementClient extends CPLClientBase implements ICPLFreeholderStatementClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    previewFreeholderStatementReport(body?: FreeholderStatementSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/FreeholderStatement/PreviewFreeholderStatementReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewFreeholderStatementReport(_response);
        });
    }

    protected processPreviewFreeholderStatementReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param backgroundProcessID (optional) 
     * @param body (optional) 
     * @return Success
     */
    acceptFreeholderStatementReport(backgroundProcessID?: number | undefined, body?: FreeholderStatementSelectionModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/FreeholderStatement/AcceptFreeholderStatementReport?";
        if (backgroundProcessID === null)
            throw new globalThis.Error("The parameter 'backgroundProcessID' cannot be null.");
        else if (backgroundProcessID !== undefined)
            url_ += "backgroundProcessID=" + encodeURIComponent("" + backgroundProcessID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptFreeholderStatementReport(_response);
        });
    }

    protected processAcceptFreeholderStatementReport(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param documentBatchID (optional) 
     * @return Success
     */
    printFreeholderStatementReport(documentBatchID?: number | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/FreeholderStatement/PrintFreeholderStatementReport?";
        if (documentBatchID === null)
            throw new globalThis.Error("The parameter 'documentBatchID' cannot be null.");
        else if (documentBatchID !== undefined)
            url_ += "documentBatchID=" + encodeURIComponent("" + documentBatchID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintFreeholderStatementReport(_response);
        });
    }

    protected processPrintFreeholderStatementReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }

    /**
     * @param documentBatchID (optional) 
     * @return Success
     */
    emailFreeholderStatementReport(documentBatchID?: number | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/FreeholderStatement/EmailFreeholderStatementReport?";
        if (documentBatchID === null)
            throw new globalThis.Error("The parameter 'documentBatchID' cannot be null.");
        else if (documentBatchID !== undefined)
            url_ += "documentBatchID=" + encodeURIComponent("" + documentBatchID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailFreeholderStatementReport(_response);
        });
    }

    protected processEmailFreeholderStatementReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }
}

export interface ICPLFundHeaderClient {

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLFundHeaderClient extends CPLClientBase implements ICPLFundHeaderClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/FundHeader/GetSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLFundSchedulesClient {

    /**
     * @param isServiceChargeOnly (optional) 
     * @param body (optional) 
     * @return Success
     */
    getSelectModels(isServiceChargeOnly?: boolean | undefined, body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @return Success
     */
    getFundScheduleChargeTypesSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLFundSchedulesClient extends CPLClientBase implements ICPLFundSchedulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param isServiceChargeOnly (optional) 
     * @param body (optional) 
     * @return Success
     */
    getSelectModels(isServiceChargeOnly?: boolean | undefined, body?: string[] | undefined, signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/FundSchedules/GetSelectModels?";
        if (isServiceChargeOnly === null)
            throw new globalThis.Error("The parameter 'isServiceChargeOnly' cannot be null.");
        else if (isServiceChargeOnly !== undefined)
            url_ += "isServiceChargeOnly=" + encodeURIComponent("" + isServiceChargeOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getFundScheduleChargeTypesSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/FundSchedules/GetFundScheduleChargeTypesSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundScheduleChargeTypesSelectModels(_response);
        });
    }

    protected processGetFundScheduleChargeTypesSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLJobsClient {

    /**
     * @param jobID (optional) 
     * @param taskSeqID (optional) 
     * @return Success
     */
    getJob(jobID?: number | undefined, taskSeqID?: number | undefined, signal?: AbortSignal | undefined): Promise<ConnectJobModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getJobs(body?: JobFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ConnectJobModel[]>;

    /**
     * @return Success
     */
    getJobStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommentThreadForJob(body?: NewJobCommentThreadModel | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLJobsClient extends CPLClientBase implements ICPLJobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param jobID (optional) 
     * @param taskSeqID (optional) 
     * @return Success
     */
    getJob(jobID?: number | undefined, taskSeqID?: number | undefined, signal?: AbortSignal | undefined): Promise<ConnectJobModel> {
        let url_ = this.baseUrl + "/api/Jobs/GetJob?";
        if (jobID === null)
            throw new globalThis.Error("The parameter 'jobID' cannot be null.");
        else if (jobID !== undefined)
            url_ += "jobID=" + encodeURIComponent("" + jobID) + "&";
        if (taskSeqID === null)
            throw new globalThis.Error("The parameter 'taskSeqID' cannot be null.");
        else if (taskSeqID !== undefined)
            url_ += "taskSeqID=" + encodeURIComponent("" + taskSeqID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: Response): Promise<ConnectJobModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectJobModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ConnectJobModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJobs(body?: JobFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<ConnectJobModel[]> {
        let url_ = this.baseUrl + "/api/Jobs/GetJobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: Response): Promise<ConnectJobModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectJobModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ConnectJobModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getJobStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Jobs/GetJobStatusTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobStatusTypeSelectModels(_response);
        });
    }

    protected processGetJobStatusTypeSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommentThreadForJob(body?: NewJobCommentThreadModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Jobs/CreateCommentThreadForJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCommentThreadForJob(_response);
        });
    }

    protected processCreateCommentThreadForJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLJobTypesClient {

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLJobTypesClient extends CPLClientBase implements ICPLJobTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/JobTypes/GetSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLLegalEntitiesClient {

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getLegalEntities(includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<LegalEntityModel[]>;
}

@injectable()
export class CPLLegalEntitiesClient extends CPLClientBase implements ICPLLegalEntitiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param includeDeleted (optional) 
     * @return Success
     */
    getLegalEntities(includeDeleted?: boolean | undefined, signal?: AbortSignal | undefined): Promise<LegalEntityModel[]> {
        let url_ = this.baseUrl + "/api/LegalEntities/GetLegalEntities?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalEntities(_response);
        });
    }

    protected processGetLegalEntities(response: Response): Promise<LegalEntityModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LegalEntityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<LegalEntityModel[]>(null as any);
    }
}

export interface ICPLLicenceClient {

    /**
     * @param licenceTypeID (optional) 
     * @return Success
     */
    getUnitCountForLicence(licenceTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<number>;
}

@injectable()
export class CPLLicenceClient extends CPLClientBase implements ICPLLicenceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param licenceTypeID (optional) 
     * @return Success
     */
    getUnitCountForLicence(licenceTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Licence/GetUnitCountForLicence?";
        if (licenceTypeID === null)
            throw new globalThis.Error("The parameter 'licenceTypeID' cannot be null.");
        else if (licenceTypeID !== undefined)
            url_ += "licenceTypeID=" + encodeURIComponent("" + licenceTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitCountForLicence(_response);
        });
    }

    protected processGetUnitCountForLicence(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICPLMeetingsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getMeetings(body?: MeetingFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<MeetingModel[]>;

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<MeetingModel>;

    /**
     * @return Success
     */
    getMeetingsSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createMeeting(body?: NewMeetingModel | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeeting(body?: MeetingModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    deleteMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLMeetingsClient extends CPLClientBase implements ICPLMeetingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMeetings(body?: MeetingFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<MeetingModel[]> {
        let url_ = this.baseUrl + "/api/Meetings/GetMeetings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetings(_response);
        });
    }

    protected processGetMeetings(response: Response): Promise<MeetingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<MeetingModel[]>(null as any);
    }

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    getMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<MeetingModel> {
        let url_ = this.baseUrl + "/api/Meetings/GetMeeting?";
        if (meetingID === null)
            throw new globalThis.Error("The parameter 'meetingID' cannot be null.");
        else if (meetingID !== undefined)
            url_ += "meetingID=" + encodeURIComponent("" + meetingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeeting(_response);
        });
    }

    protected processGetMeeting(response: Response): Promise<MeetingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<MeetingModel>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingsSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/Meetings/GetMeetingsSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingsSelectModels(_response);
        });
    }

    protected processGetMeetingsSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMeeting(body?: NewMeetingModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Meetings/CreateMeeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMeeting(_response);
        });
    }

    protected processCreateMeeting(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeeting(body?: MeetingModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Meetings/UpdateMeeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMeeting(_response);
        });
    }

    protected processUpdateMeeting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param meetingID (optional) 
     * @return Success
     */
    deleteMeeting(meetingID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Meetings/DeleteMeeting?";
        if (meetingID === null)
            throw new globalThis.Error("The parameter 'meetingID' cannot be null.");
        else if (meetingID !== undefined)
            url_ += "meetingID=" + encodeURIComponent("" + meetingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMeeting(_response);
        });
    }

    protected processDeleteMeeting(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLMeetingTypesClient {

    /**
     * @return Success
     */
    getMeetingTypes(signal?: AbortSignal | undefined): Promise<MeetingTypeModel[]>;

    /**
     * @param name (optional) 
     * @return Success
     */
    createMeetingType(name?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeetingType(body?: MeetingTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param meetingTypeID (optional) 
     * @return Success
     */
    deleteMeetingType(meetingTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getMeetingTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLMeetingTypesClient extends CPLClientBase implements ICPLMeetingTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getMeetingTypes(signal?: AbortSignal | undefined): Promise<MeetingTypeModel[]> {
        let url_ = this.baseUrl + "/api/MeetingTypes/GetMeetingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingTypes(_response);
        });
    }

    protected processGetMeetingTypes(response: Response): Promise<MeetingTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<MeetingTypeModel[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    createMeetingType(name?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeetingTypes/CreateMeetingType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMeetingType(_response);
        });
    }

    protected processCreateMeetingType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeetingType(body?: MeetingTypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeetingTypes/UpdateMeetingType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMeetingType(_response);
        });
    }

    protected processUpdateMeetingType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param meetingTypeID (optional) 
     * @return Success
     */
    deleteMeetingType(meetingTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/MeetingTypes/DeleteMeetingType?";
        if (meetingTypeID === null)
            throw new globalThis.Error("The parameter 'meetingTypeID' cannot be null.");
        else if (meetingTypeID !== undefined)
            url_ += "meetingTypeID=" + encodeURIComponent("" + meetingTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMeetingType(_response);
        });
    }

    protected processDeleteMeetingType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/MeetingTypes/GetMeetingTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingTypeSelectModels(_response);
        });
    }

    protected processGetMeetingTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLPaymentProvidersClient {

    /**
     * @return Success
     */
    getPaymentProviders(signal?: AbortSignal | undefined): Promise<PaymentProviderModel[]>;

    /**
     * @param paymentProviderID (optional) 
     * @return Success
     */
    enablePaymentProvider(paymentProviderID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    disablePaymentProvider(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getGoCardlessSettings(signal?: AbortSignal | undefined): Promise<GoCardlessSettingsModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGoCardlessSettings(body?: GoCardlessSettingsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getBlinkSettings(signal?: AbortSignal | undefined): Promise<BlinkSettingsModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBlinkSettings(body?: BlinkSettingsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLPaymentProvidersClient extends CPLClientBase implements ICPLPaymentProvidersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getPaymentProviders(signal?: AbortSignal | undefined): Promise<PaymentProviderModel[]> {
        let url_ = this.baseUrl + "/api/PaymentProviders/GetPaymentProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentProviders(_response);
        });
    }

    protected processGetPaymentProviders(response: Response): Promise<PaymentProviderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentProviderModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PaymentProviderModel[]>(null as any);
    }

    /**
     * @param paymentProviderID (optional) 
     * @return Success
     */
    enablePaymentProvider(paymentProviderID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PaymentProviders/EnablePaymentProvider?";
        if (paymentProviderID === null)
            throw new globalThis.Error("The parameter 'paymentProviderID' cannot be null.");
        else if (paymentProviderID !== undefined)
            url_ += "paymentProviderID=" + encodeURIComponent("" + paymentProviderID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnablePaymentProvider(_response);
        });
    }

    protected processEnablePaymentProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    disablePaymentProvider(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PaymentProviders/DisablePaymentProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisablePaymentProvider(_response);
        });
    }

    protected processDisablePaymentProvider(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getGoCardlessSettings(signal?: AbortSignal | undefined): Promise<GoCardlessSettingsModel> {
        let url_ = this.baseUrl + "/api/PaymentProviders/GetGoCardlessSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGoCardlessSettings(_response);
        });
    }

    protected processGetGoCardlessSettings(response: Response): Promise<GoCardlessSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoCardlessSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GoCardlessSettingsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGoCardlessSettings(body?: GoCardlessSettingsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PaymentProviders/UpdateGoCardlessSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGoCardlessSettings(_response);
        });
    }

    protected processUpdateGoCardlessSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getBlinkSettings(signal?: AbortSignal | undefined): Promise<BlinkSettingsModel> {
        let url_ = this.baseUrl + "/api/PaymentProviders/GetBlinkSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBlinkSettings(_response);
        });
    }

    protected processGetBlinkSettings(response: Response): Promise<BlinkSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlinkSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<BlinkSettingsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBlinkSettings(body?: BlinkSettingsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PaymentProviders/UpdateBlinkSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBlinkSettings(_response);
        });
    }

    protected processUpdateBlinkSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLPowerBIClient {

    /**
     * @param reportID (optional) 
     * @return Success
     */
    getReport(reportID?: number | undefined, signal?: AbortSignal | undefined): Promise<PowerBIReportModel>;

    /**
     * @return Success
     */
    getReportSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;
}

@injectable()
export class CPLPowerBIClient extends CPLClientBase implements ICPLPowerBIClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param reportID (optional) 
     * @return Success
     */
    getReport(reportID?: number | undefined, signal?: AbortSignal | undefined): Promise<PowerBIReportModel> {
        let url_ = this.baseUrl + "/api/PowerBI/GetReport?";
        if (reportID === null)
            throw new globalThis.Error("The parameter 'reportID' cannot be null.");
        else if (reportID !== undefined)
            url_ += "reportID=" + encodeURIComponent("" + reportID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<PowerBIReportModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PowerBIReportModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PowerBIReportModel>(null as any);
    }

    /**
     * @return Success
     */
    getReportSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/PowerBI/GetReportSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportSelectModels(_response);
        });
    }

    protected processGetReportSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }
}

export interface ICPLPurchaseAccountInformationClient {

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLPurchaseAccountInformationClient extends CPLClientBase implements ICPLPurchaseAccountInformationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/PurchaseAccountInformation/GetSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLReportsClient {

    /**
     * @param reportName (optional) 
     * @param reportStoredProcedure (optional) 
     * @param body (optional) 
     * @return Success
     */
    previewGenericReport(reportName?: string | undefined, reportStoredProcedure?: string | undefined, body?: SqlParameter[] | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;
}

@injectable()
export class CPLReportsClient extends CPLClientBase implements ICPLReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param reportName (optional) 
     * @param reportStoredProcedure (optional) 
     * @param body (optional) 
     * @return Success
     */
    previewGenericReport(reportName?: string | undefined, reportStoredProcedure?: string | undefined, body?: SqlParameter[] | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/Reports/PreviewGenericReport?";
        if (reportName === null)
            throw new globalThis.Error("The parameter 'reportName' cannot be null.");
        else if (reportName !== undefined)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (reportStoredProcedure === null)
            throw new globalThis.Error("The parameter 'reportStoredProcedure' cannot be null.");
        else if (reportStoredProcedure !== undefined)
            url_ += "reportStoredProcedure=" + encodeURIComponent("" + reportStoredProcedure) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewGenericReport(_response);
        });
    }

    protected processPreviewGenericReport(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }
}

export interface ICPLResumableProcessClient {

    /**
     * @param type (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveResumableProcess(type?: UserResumableProcessType | undefined, data?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param type (optional) 
     * @param data (optional) 
     * @param backgroundProcessID (optional) 
     * @return Success
     */
    saveResumableProcessWithBackgroundProcess(type?: UserResumableProcessType | undefined, data?: string | undefined, backgroundProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param type (optional) 
     * @return Success
     */
    checkForResumableProcess(type?: UserResumableProcessType | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param userResumableProcessID (optional) 
     * @return Success
     */
    retrieveResumableProcessByID(userResumableProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<ResumableProcessModel>;

    /**
     * @param backgroundProcessID (optional) 
     * @return Success
     */
    retrieveResumableProcessByBackgroundProcess(backgroundProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<ResumableProcessModel>;
}

@injectable()
export class CPLResumableProcessClient extends CPLClientBase implements ICPLResumableProcessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param type (optional) 
     * @param data (optional) 
     * @return Success
     */
    saveResumableProcess(type?: UserResumableProcessType | undefined, data?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ResumableProcess/SaveResumableProcess?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResumableProcess(_response);
        });
    }

    protected processSaveResumableProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @param data (optional) 
     * @param backgroundProcessID (optional) 
     * @return Success
     */
    saveResumableProcessWithBackgroundProcess(type?: UserResumableProcessType | undefined, data?: string | undefined, backgroundProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ResumableProcess/SaveResumableProcessWithBackgroundProcess?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (data === null)
            throw new globalThis.Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        if (backgroundProcessID === null)
            throw new globalThis.Error("The parameter 'backgroundProcessID' cannot be null.");
        else if (backgroundProcessID !== undefined)
            url_ += "backgroundProcessID=" + encodeURIComponent("" + backgroundProcessID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResumableProcessWithBackgroundProcess(_response);
        });
    }

    protected processSaveResumableProcessWithBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    checkForResumableProcess(type?: UserResumableProcessType | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ResumableProcess/CheckForResumableProcess?";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckForResumableProcess(_response);
        });
    }

    protected processCheckForResumableProcess(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param userResumableProcessID (optional) 
     * @return Success
     */
    retrieveResumableProcessByID(userResumableProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<ResumableProcessModel> {
        let url_ = this.baseUrl + "/api/ResumableProcess/RetrieveResumableProcessByID?";
        if (userResumableProcessID === null)
            throw new globalThis.Error("The parameter 'userResumableProcessID' cannot be null.");
        else if (userResumableProcessID !== undefined)
            url_ += "userResumableProcessID=" + encodeURIComponent("" + userResumableProcessID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetrieveResumableProcessByID(_response);
        });
    }

    protected processRetrieveResumableProcessByID(response: Response): Promise<ResumableProcessModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumableProcessModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ResumableProcessModel>(null as any);
    }

    /**
     * @param backgroundProcessID (optional) 
     * @return Success
     */
    retrieveResumableProcessByBackgroundProcess(backgroundProcessID?: number | undefined, signal?: AbortSignal | undefined): Promise<ResumableProcessModel> {
        let url_ = this.baseUrl + "/api/ResumableProcess/RetrieveResumableProcessByBackgroundProcess?";
        if (backgroundProcessID === null)
            throw new globalThis.Error("The parameter 'backgroundProcessID' cannot be null.");
        else if (backgroundProcessID !== undefined)
            url_ += "backgroundProcessID=" + encodeURIComponent("" + backgroundProcessID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRetrieveResumableProcessByBackgroundProcess(_response);
        });
    }

    protected processRetrieveResumableProcessByBackgroundProcess(response: Response): Promise<ResumableProcessModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResumableProcessModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ResumableProcessModel>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionBundlesClient {

    /**
     * @param submissionID (optional) 
     * @param file (optional) 
     * @return Success
     */
    submit(formData: { submissionID?: string | undefined, file?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel>;

    downloadBundle(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionBundlesClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionBundlesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param submissionID (optional) 
     * @param file (optional) 
     * @return Success
     */
    submit(formData: { submissionID?: string | undefined, file?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionBundles/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.submissionID === null || formData.submissionID === undefined)
            throw new Error("The parameter 'submissionID' cannot be null.");
        else
            content_.append("SubmissionID", formData.submissionID.toString());
        if (formData.file !== null && formData.file !== undefined)
            content_.append("File", formData.file.data, formData.file.fileName ? formData.file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<SelfServeDataImportSubmissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel>(null as any);
    }

    downloadBundle(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionBundles/DownloadBundle?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadBundle(_response);
        });
    }

    protected processDownloadBundle(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionColumnMappingsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    saveColumnMappings(body?: NewSelfServeDataImportSubmissionColumnMappingsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSaveColumnMappings(body?: NewSelfServeDataImportSubmissionColumnMappingsBulkModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getColumnMappings(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionColumnMappingsClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionColumnMappingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveColumnMappings(body?: NewSelfServeDataImportSubmissionColumnMappingsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionColumnMappings/SaveColumnMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveColumnMappings(_response);
        });
    }

    protected processSaveColumnMappings(response: Response): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionColumnMappingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionColumnMappingModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSaveColumnMappings(body?: NewSelfServeDataImportSubmissionColumnMappingsBulkModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionColumnMappings/BulkSaveColumnMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSaveColumnMappings(_response);
        });
    }

    protected processBulkSaveColumnMappings(response: Response): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionColumnMappingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionColumnMappingModel[]>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getColumnMappings(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionColumnMappings/GetColumnMappings?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetColumnMappings(_response);
        });
    }

    protected processGetColumnMappings(response: Response): Promise<SelfServeDataImportSubmissionColumnMappingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionColumnMappingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionColumnMappingModel[]>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionEditsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEdits(body?: NewSelfServeDataImportSubmissionEditsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionEditsModel>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getEdits(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionEditsModel>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionEditsClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionEditsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveEdits(body?: NewSelfServeDataImportSubmissionEditsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionEditsModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionEdits/SaveEdits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveEdits(_response);
        });
    }

    protected processSaveEdits(response: Response): Promise<SelfServeDataImportSubmissionEditsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionEditsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionEditsModel>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getEdits(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionEditsModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionEdits/GetEdits?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEdits(_response);
        });
    }

    protected processGetEdits(response: Response): Promise<SelfServeDataImportSubmissionEditsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionEditsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionEditsModel>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionFilesClient {

    /**
     * @param submissionID (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadFiles(formData: { submissionID?: string | undefined, files?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionFileModel[]>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getFiles(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionFileModel[]>;

    downloadFile(submissionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    /**
     * @param submissionFileID (optional) 
     * @return Success
     */
    deleteFile(submissionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionFilesClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionFilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param submissionID (optional) 
     * @param files (optional) 
     * @return Success
     */
    uploadFiles(formData: { submissionID?: string | undefined, files?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionFileModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionFiles/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.submissionID === null || formData.submissionID === undefined)
            throw new Error("The parameter 'submissionID' cannot be null.");
        else
            content_.append("SubmissionID", formData.submissionID.toString());
        if (formData.files !== null && formData.files !== undefined)
            formData.files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFiles(_response);
        });
    }

    protected processUploadFiles(response: Response): Promise<SelfServeDataImportSubmissionFileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionFileModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionFileModel[]>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getFiles(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionFileModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionFiles/GetFiles?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFiles(_response);
        });
    }

    protected processGetFiles(response: Response): Promise<SelfServeDataImportSubmissionFileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionFileModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionFileModel[]>(null as any);
    }

    downloadFile(submissionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionFiles/DownloadFile?";
        if (submissionFileID === null)
            throw new globalThis.Error("The parameter 'submissionFileID' cannot be null.");
        else if (submissionFileID !== undefined)
            url_ += "submissionFileID=" + encodeURIComponent("" + submissionFileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param submissionFileID (optional) 
     * @return Success
     */
    deleteFile(submissionFileID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionFiles/DeleteFile?";
        if (submissionFileID === null)
            throw new globalThis.Error("The parameter 'submissionFileID' cannot be null.");
        else if (submissionFileID !== undefined)
            url_ += "submissionFileID=" + encodeURIComponent("" + submissionFileID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionLocksClient {

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    acquireLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionLockModel>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionLockModel>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    releaseLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionLocksClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionLocksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    acquireLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionLockModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionLocks/AcquireLock?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcquireLock(_response);
        });
    }

    protected processAcquireLock(response: Response): Promise<SelfServeDataImportSubmissionLockModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionLockModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionLockModel>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionLockModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionLocks/GetLock?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLock(_response);
        });
    }

    protected processGetLock(response: Response): Promise<SelfServeDataImportSubmissionLockModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionLockModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionLockModel>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    releaseLock(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionLocks/ReleaseLock?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseLock(_response);
        });
    }

    protected processReleaseLock(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubmission(body?: NewSelfServeDataImportSubmissionModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel>;

    /**
     * @param submissionStatus (optional) 
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getSubmissions(submissionStatus?: SubmissionStatus | undefined, index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel[]>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatus(body?: UpdateSelfServeDataImportSubmissionStatusModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    deleteSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    closeSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionsClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSubmission(body?: NewSelfServeDataImportSubmissionModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/CreateSubmission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubmission(_response);
        });
    }

    protected processCreateSubmission(response: Response): Promise<SelfServeDataImportSubmissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel>(null as any);
    }

    /**
     * @param submissionStatus (optional) 
     * @param index (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getSubmissions(submissionStatus?: SubmissionStatus | undefined, index?: number | undefined, pageSize?: number | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/GetSubmissions?";
        if (submissionStatus === null)
            throw new globalThis.Error("The parameter 'submissionStatus' cannot be null.");
        else if (submissionStatus !== undefined)
            url_ += "submissionStatus=" + encodeURIComponent("" + submissionStatus) + "&";
        if (index === null)
            throw new globalThis.Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmissions(_response);
        });
    }

    protected processGetSubmissions(response: Response): Promise<SelfServeDataImportSubmissionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel[]>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/GetSubmission?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmission(_response);
        });
    }

    protected processGetSubmission(response: Response): Promise<SelfServeDataImportSubmissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatus(body?: UpdateSelfServeDataImportSubmissionStatusModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<SelfServeDataImportSubmissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    deleteSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/DeleteSubmission?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSubmission(_response);
        });
    }

    protected processDeleteSubmission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    closeSubmission(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissions/CloseSubmission?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCloseSubmission(_response);
        });
    }

    protected processCloseSubmission(response: Response): Promise<SelfServeDataImportSubmissionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionModel>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionSheetMappingsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSheetMappings(body?: NewSelfServeDataImportSubmissionSheetMappingsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionSheetMappingModel[]>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getSheetMappings(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionSheetMappingModel[]>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionSheetMappingsClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionSheetMappingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSheetMappings(body?: NewSelfServeDataImportSubmissionSheetMappingsModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionSheetMappingModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionSheetMappings/SaveSheetMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveSheetMappings(_response);
        });
    }

    protected processSaveSheetMappings(response: Response): Promise<SelfServeDataImportSubmissionSheetMappingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionSheetMappingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionSheetMappingModel[]>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getSheetMappings(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionSheetMappingModel[]> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionSheetMappings/GetSheetMappings?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSheetMappings(_response);
        });
    }

    protected processGetSheetMappings(response: Response): Promise<SelfServeDataImportSubmissionSheetMappingModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportSubmissionSheetMappingModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionSheetMappingModel[]>(null as any);
    }
}

export interface ICPLSelfServeDataImportSubmissionValidationResultsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    saveValidationResult(body?: NewSelfServeDataImportSubmissionValidationResultModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionValidationResultModel>;

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getValidationResult(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionValidationResultModel>;
}

@injectable()
export class CPLSelfServeDataImportSubmissionValidationResultsClient extends CPLClientBase implements ICPLSelfServeDataImportSubmissionValidationResultsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveValidationResult(body?: NewSelfServeDataImportSubmissionValidationResultModel | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionValidationResultModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionValidationResults/SaveValidationResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveValidationResult(_response);
        });
    }

    protected processSaveValidationResult(response: Response): Promise<SelfServeDataImportSubmissionValidationResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionValidationResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionValidationResultModel>(null as any);
    }

    /**
     * @param submissionID (optional) 
     * @return Success
     */
    getValidationResult(submissionID?: string | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportSubmissionValidationResultModel> {
        let url_ = this.baseUrl + "/api/SelfServeDataImportSubmissionValidationResults/GetValidationResult?";
        if (submissionID === null)
            throw new globalThis.Error("The parameter 'submissionID' cannot be null.");
        else if (submissionID !== undefined)
            url_ += "submissionID=" + encodeURIComponent("" + submissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetValidationResult(_response);
        });
    }

    protected processGetValidationResult(response: Response): Promise<SelfServeDataImportSubmissionValidationResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportSubmissionValidationResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportSubmissionValidationResultModel>(null as any);
    }
}

export interface ICPLServiceChargeInvoicingClient {

    /**
     * @return Success
     */
    resumeProcess(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceProcessSelectionsModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getServiceChargeDateCodes(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateDevelopmentChargesPreListBackgroundProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    generateServiceChargeInvoicesBackgroundProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    generateReportPreview(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<ReportPreviewModel>;

    /**
     * @return Success
     */
    acceptInvoices(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    printInvoices(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    emailInvoices(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    completeServiceChargeInvoicingWizard(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param batchID (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    uploadInvoiceAttachments(formData: { batchID?: number | undefined, attachments?: FileParameter[] | null | undefined } , signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLServiceChargeInvoicingClient extends CPLClientBase implements ICPLServiceChargeInvoicingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    resumeProcess(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceProcessSelectionsModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/ResumeProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResumeProcess(_response);
        });
    }

    protected processResumeProcess(response: Response): Promise<ServiceChargeInvoiceProcessSelectionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceChargeInvoiceProcessSelectionsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ServiceChargeInvoiceProcessSelectionsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/SaveProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveProcess(_response);
        });
    }

    protected processSaveProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getServiceChargeDateCodes(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/GetServiceChargeDateCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceChargeDateCodes(_response);
        });
    }

    protected processGetServiceChargeDateCodes(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateDevelopmentChargesPreListBackgroundProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/CalculateDevelopmentChargesPreListBackgroundProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateDevelopmentChargesPreListBackgroundProcess(_response);
        });
    }

    protected processCalculateDevelopmentChargesPreListBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateServiceChargeInvoicesBackgroundProcess(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/GenerateServiceChargeInvoicesBackgroundProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateServiceChargeInvoicesBackgroundProcess(_response);
        });
    }

    protected processGenerateServiceChargeInvoicesBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateReportPreview(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<ReportPreviewModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/GenerateReportPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateReportPreview(_response);
        });
    }

    protected processGenerateReportPreview(response: Response): Promise<ReportPreviewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportPreviewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportPreviewModel>(null as any);
    }

    /**
     * @return Success
     */
    acceptInvoices(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/AcceptInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptInvoices(_response);
        });
    }

    protected processAcceptInvoices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printInvoices(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/PrintInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintInvoices(_response);
        });
    }

    protected processPrintInvoices(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailInvoices(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/EmailInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEmailInvoices(_response);
        });
    }

    protected processEmailInvoices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeServiceChargeInvoicingWizard(body?: ServiceChargeInvoiceProcessSelectionsModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/CompleteServiceChargeInvoicingWizard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteServiceChargeInvoicingWizard(_response);
        });
    }

    protected processCompleteServiceChargeInvoicingWizard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param batchID (optional) 
     * @param attachments (optional) 
     * @return Success
     */
    uploadInvoiceAttachments(formData: { batchID?: number | undefined, attachments?: FileParameter[] | null | undefined }, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicing/UploadInvoiceAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.batchID === null || formData.batchID === undefined)
            throw new Error("The parameter 'batchID' cannot be null.");
        else
            content_.append("BatchID", formData.batchID.toString());
        if (formData.attachments !== null && formData.attachments !== undefined)
            formData.attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadInvoiceAttachments(_response);
        });
    }

    protected processUploadInvoiceAttachments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLServiceChargeInvoicingSettingsClient {

    /**
     * @return Success
     */
    getLogoURLs(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceSettingsModel>;

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadHeaderLogo(formData: { image?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadFooterLogo(formData: { image?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    deleteHeaderLogo(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    deleteFooterLogo(signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLServiceChargeInvoicingSettingsClient extends CPLClientBase implements ICPLServiceChargeInvoicingSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getLogoURLs(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceSettingsModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSettings/GetLogoURLs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLogoURLs(_response);
        });
    }

    protected processGetLogoURLs(response: Response): Promise<ServiceChargeInvoiceSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceChargeInvoiceSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ServiceChargeInvoiceSettingsModel>(null as any);
    }

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadHeaderLogo(formData: { image?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSettings/UploadHeaderLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.image !== null && formData.image !== undefined)
            content_.append("Image", formData.image.data, formData.image.fileName ? formData.image.fileName : "Image");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadHeaderLogo(_response);
        });
    }

    protected processUploadHeaderLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadFooterLogo(formData: { image?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSettings/UploadFooterLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.image !== null && formData.image !== undefined)
            content_.append("Image", formData.image.data, formData.image.fileName ? formData.image.fileName : "Image");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFooterLogo(_response);
        });
    }

    protected processUploadFooterLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteHeaderLogo(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSettings/DeleteHeaderLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteHeaderLogo(_response);
        });
    }

    protected processDeleteHeaderLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteFooterLogo(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSettings/DeleteFooterLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFooterLogo(_response);
        });
    }

    protected processDeleteFooterLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLServiceChargeInvoicingSummariesClient {

    /**
     * @return Success
     */
    getServiceChargeInvoiceSummaries(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceSummaryModel[]>;

    /**
     * @param logID (optional) 
     * @return Success
     */
    getServiceChargeInvoiceDetails(logID?: number | undefined, signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceDetailsModel>;

    downloadServiceChargeInvoice(breakdownID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse>;

    /**
     * @param body (optional) 
     * @return Success
     */
    resendServiceChargeInvoiceEmails(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    resendServiceChargeInvoicePrints(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel>;
}

@injectable()
export class CPLServiceChargeInvoicingSummariesClient extends CPLClientBase implements ICPLServiceChargeInvoicingSummariesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getServiceChargeInvoiceSummaries(signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceSummaryModel[]> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSummaries/GetServiceChargeInvoiceSummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceChargeInvoiceSummaries(_response);
        });
    }

    protected processGetServiceChargeInvoiceSummaries(response: Response): Promise<ServiceChargeInvoiceSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceChargeInvoiceSummaryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ServiceChargeInvoiceSummaryModel[]>(null as any);
    }

    /**
     * @param logID (optional) 
     * @return Success
     */
    getServiceChargeInvoiceDetails(logID?: number | undefined, signal?: AbortSignal | undefined): Promise<ServiceChargeInvoiceDetailsModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSummaries/GetServiceChargeInvoiceDetails?";
        if (logID === null)
            throw new globalThis.Error("The parameter 'logID' cannot be null.");
        else if (logID !== undefined)
            url_ += "logID=" + encodeURIComponent("" + logID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceChargeInvoiceDetails(_response);
        });
    }

    protected processGetServiceChargeInvoiceDetails(response: Response): Promise<ServiceChargeInvoiceDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceChargeInvoiceDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ServiceChargeInvoiceDetailsModel>(null as any);
    }

    downloadServiceChargeInvoice(breakdownID?: number | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSummaries/DownloadServiceChargeInvoice?";
        if (breakdownID === null)
            throw new globalThis.Error("The parameter 'breakdownID' cannot be null.");
        else if (breakdownID !== undefined)
            url_ += "breakdownID=" + encodeURIComponent("" + breakdownID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadServiceChargeInvoice(_response);
        });
    }

    protected processDownloadServiceChargeInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendServiceChargeInvoiceEmails(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSummaries/ResendServiceChargeInvoiceEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendServiceChargeInvoiceEmails(_response);
        });
    }

    protected processResendServiceChargeInvoiceEmails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendServiceChargeInvoicePrints(body?: number[] | undefined, signal?: AbortSignal | undefined): Promise<ReportURLResponseModel> {
        let url_ = this.baseUrl + "/api/ServiceChargeInvoicingSummaries/ResendServiceChargeInvoicePrints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendServiceChargeInvoicePrints(_response);
        });
    }

    protected processResendServiceChargeInvoicePrints(response: Response): Promise<ReportURLResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportURLResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ReportURLResponseModel>(null as any);
    }
}

export interface ICPLSettingsClient {

    /**
     * @return Success
     */
    getTermsAndConditions(signal?: AbortSignal | undefined): Promise<TermsAndConditionsModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTermsAndConditions(body?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    isTestDatabase(signal?: AbortSignal | undefined): Promise<boolean>;

    /**
     * @return Success
     */
    useExternalPrinting(signal?: AbortSignal | undefined): Promise<boolean>;

    /**
     * @return Success
     */
    dataImportUrlTemplates(signal?: AbortSignal | undefined): Promise<SelfServeDataImportTemplateUrlModel>;
}

@injectable()
export class CPLSettingsClient extends CPLClientBase implements ICPLSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getTermsAndConditions(signal?: AbortSignal | undefined): Promise<TermsAndConditionsModel> {
        let url_ = this.baseUrl + "/api/Settings/GetTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTermsAndConditions(_response);
        });
    }

    protected processGetTermsAndConditions(response: Response): Promise<TermsAndConditionsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TermsAndConditionsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<TermsAndConditionsModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTermsAndConditions(body?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Settings/UpdateTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTermsAndConditions(_response);
        });
    }

    protected processUpdateTermsAndConditions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    isTestDatabase(signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Settings/IsTestDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsTestDatabase(_response);
        });
    }

    protected processIsTestDatabase(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    useExternalPrinting(signal?: AbortSignal | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Settings/UseExternalPrinting";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUseExternalPrinting(_response);
        });
    }

    protected processUseExternalPrinting(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    dataImportUrlTemplates(signal?: AbortSignal | undefined): Promise<SelfServeDataImportTemplateUrlModel> {
        let url_ = this.baseUrl + "/api/Settings/DataImportUrlTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDataImportUrlTemplates(_response);
        });
    }

    protected processDataImportUrlTemplates(response: Response): Promise<SelfServeDataImportTemplateUrlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SelfServeDataImportTemplateUrlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportTemplateUrlModel>(null as any);
    }
}

export interface ICPLSLATypesClient {

    /**
     * @return Success
     */
    getSLATypes(signal?: AbortSignal | undefined): Promise<SLATypeModel[]>;

    /**
     * @param name (optional) 
     * @param targetMinutes (optional) 
     * @return Success
     */
    createSLAType(name?: string | undefined, targetMinutes?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSLAType(body?: SLATypeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param slaTypeID (optional) 
     * @return Success
     */
    deleteSLAType(slaTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getSLATypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @param startDate (optional) 
     * @param slaTypeID (optional) 
     * @return Success
     */
    calculateSLATargetDate(startDate?: Date | undefined, slaTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<Date>;
}

@injectable()
export class CPLSLATypesClient extends CPLClientBase implements ICPLSLATypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSLATypes(signal?: AbortSignal | undefined): Promise<SLATypeModel[]> {
        let url_ = this.baseUrl + "/api/SLATypes/GetSLATypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSLATypes(_response);
        });
    }

    protected processGetSLATypes(response: Response): Promise<SLATypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SLATypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SLATypeModel[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param targetMinutes (optional) 
     * @return Success
     */
    createSLAType(name?: string | undefined, targetMinutes?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SLATypes/CreateSLAType?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (targetMinutes === null)
            throw new globalThis.Error("The parameter 'targetMinutes' cannot be null.");
        else if (targetMinutes !== undefined)
            url_ += "targetMinutes=" + encodeURIComponent("" + targetMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSLAType(_response);
        });
    }

    protected processCreateSLAType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSLAType(body?: SLATypeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SLATypes/UpdateSLAType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSLAType(_response);
        });
    }

    protected processUpdateSLAType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param slaTypeID (optional) 
     * @return Success
     */
    deleteSLAType(slaTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SLATypes/DeleteSLAType?";
        if (slaTypeID === null)
            throw new globalThis.Error("The parameter 'slaTypeID' cannot be null.");
        else if (slaTypeID !== undefined)
            url_ += "slaTypeID=" + encodeURIComponent("" + slaTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSLAType(_response);
        });
    }

    protected processDeleteSLAType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getSLATypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/SLATypes/GetSLATypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSLATypeSelectModels(_response);
        });
    }

    protected processGetSLATypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param slaTypeID (optional) 
     * @return Success
     */
    calculateSLATargetDate(startDate?: Date | undefined, slaTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/SLATypes/CalculateSLATargetDate?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (slaTypeID === null)
            throw new globalThis.Error("The parameter 'slaTypeID' cannot be null.");
        else if (slaTypeID !== undefined)
            url_ += "slaTypeID=" + encodeURIComponent("" + slaTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateSLATargetDate(_response);
        });
    }

    protected processCalculateSLATargetDate(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<Date>(null as any);
    }
}

export interface ICPLStandardDescriptionsClient {

    /**
     * @return Success
     */
    getStandardDescriptions(signal?: AbortSignal | undefined): Promise<StandardDescriptionModel[]>;
}

@injectable()
export class CPLStandardDescriptionsClient extends CPLClientBase implements ICPLStandardDescriptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getStandardDescriptions(signal?: AbortSignal | undefined): Promise<StandardDescriptionModel[]> {
        let url_ = this.baseUrl + "/api/StandardDescriptions/GetStandardDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardDescriptions(_response);
        });
    }

    protected processGetStandardDescriptions(response: Response): Promise<StandardDescriptionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandardDescriptionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<StandardDescriptionModel[]>(null as any);
    }
}

export interface ICPLSystemInfoClient {

    /**
     * @return Success
     */
    getMaxAllowedContentLength(signal?: AbortSignal | undefined): Promise<number>;
}

@injectable()
export class CPLSystemInfoClient extends CPLClientBase implements ICPLSystemInfoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getMaxAllowedContentLength(signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/SystemInfo/GetMaxAllowedContentLength";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaxAllowedContentLength(_response);
        });
    }

    protected processGetMaxAllowedContentLength(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface ICPLTestClient {

    /**
     * @return Success
     */
    sendTestEmail(signal?: AbortSignal | undefined): Promise<string>;

    /**
     * @param userID (optional) 
     * @param notificationType (optional) 
     * @param notificationStyle (optional) 
     * @return Success
     */
    testSignalRNotification(userID?: string | undefined, notificationType?: NotificationTypes | undefined, notificationStyle?: NotificationStyles | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    checkJobCreated(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    createCompletedBackgroundProcess(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    createFailedBackgroundProcess(signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    sendDocumentToPrint(signal?: AbortSignal | undefined): Promise<void>;

    generateServiceChargeInvoice(signal?: AbortSignal | undefined): Promise<FileResponse>;

    generateAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<FileResponse>;
}

@injectable()
export class CPLTestClient extends CPLClientBase implements ICPLTestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    sendTestEmail(signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Test/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param notificationType (optional) 
     * @param notificationStyle (optional) 
     * @return Success
     */
    testSignalRNotification(userID?: string | undefined, notificationType?: NotificationTypes | undefined, notificationStyle?: NotificationStyles | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/TestSignalRNotification?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (notificationStyle === null)
            throw new globalThis.Error("The parameter 'notificationStyle' cannot be null.");
        else if (notificationStyle !== undefined)
            url_ += "notificationStyle=" + encodeURIComponent("" + notificationStyle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTestSignalRNotification(_response);
        });
    }

    protected processTestSignalRNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    checkJobCreated(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/CheckJobCreated";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckJobCreated(_response);
        });
    }

    protected processCheckJobCreated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    createCompletedBackgroundProcess(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/CreateCompletedBackgroundProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCompletedBackgroundProcess(_response);
        });
    }

    protected processCreateCompletedBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    createFailedBackgroundProcess(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/CreateFailedBackgroundProcess";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFailedBackgroundProcess(_response);
        });
    }

    protected processCreateFailedBackgroundProcess(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendDocumentToPrint(signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/SendDocumentToPrint";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendDocumentToPrint(_response);
        });
    }

    protected processSendDocumentToPrint(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    generateServiceChargeInvoice(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Test/GenerateServiceChargeInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateServiceChargeInvoice(_response);
        });
    }

    protected processGenerateServiceChargeInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    generateAnticipatedExpenditureReport(signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Test/GenerateAnticipatedExpenditureReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateAnticipatedExpenditureReport(_response);
        });
    }

    protected processGenerateAnticipatedExpenditureReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICPLTextEditorImageRetrievalClient {

    /**
     * @param documentID (optional) 
     * @param savePath (optional) 
     * @return Success
     */
    getImage(documentID?: number | undefined, savePath?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLTextEditorImageRetrievalClient extends CPLClientBase implements ICPLTextEditorImageRetrievalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param documentID (optional) 
     * @param savePath (optional) 
     * @return Success
     */
    getImage(documentID?: number | undefined, savePath?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TextEditorImageRetrieval/GetImage?";
        if (documentID === null)
            throw new globalThis.Error("The parameter 'documentID' cannot be null.");
        else if (documentID !== undefined)
            url_ += "documentID=" + encodeURIComponent("" + documentID) + "&";
        if (savePath === null)
            throw new globalThis.Error("The parameter 'savePath' cannot be null.");
        else if (savePath !== undefined)
            url_ += "savePath=" + encodeURIComponent("" + savePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImage(_response);
        });
    }

    protected processGetImage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLTextEditorImageUploadClient {

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadImage(formData: { image?: FileParameter | null | undefined } , signal?: AbortSignal | undefined): Promise<ImageUploadResultModel>;
}

@injectable()
export class CPLTextEditorImageUploadClient extends CPLClientBase implements ICPLTextEditorImageUploadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param image (optional) 
     * @return Success
     */
    uploadImage(formData: { image?: FileParameter | null | undefined }, signal?: AbortSignal | undefined): Promise<ImageUploadResultModel> {
        let url_ = this.baseUrl + "/api/TextEditorImageUpload/UploadImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.image !== null && formData.image !== undefined)
            content_.append("Image", formData.image.data, formData.image.fileName ? formData.image.fileName : "Image");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: Response): Promise<ImageUploadResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageUploadResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ImageUploadResultModel>(null as any);
    }
}

export interface ICPLTypesClient {

    /**
     * @return Success
     */
    getAccountTypes(signal?: AbortSignal | undefined): Promise<string[]>;

    /**
     * @return Success
     */
    getPropertyTypes(signal?: AbortSignal | undefined): Promise<PropertyTypeModel[]>;

    /**
     * @return Success
     */
    getAccountingBasisTypes(signal?: AbortSignal | undefined): Promise<AccountingBasisTypeModel[]>;

    /**
     * @return Success
     */
    getPropertyServiceChargeTypes(signal?: AbortSignal | undefined): Promise<PropertyServiceChargeTypeModel[]>;

    /**
     * @return Success
     */
    getAuthorityToActTypes(signal?: AbortSignal | undefined): Promise<AuthorityToActTypeModel[]>;

    /**
     * @return Success
     */
    getListedTypes(signal?: AbortSignal | undefined): Promise<ListedTypeModel[]>;

    /**
     * @return Success
     */
    getFreeholderCommissionRateTypes(signal?: AbortSignal | undefined): Promise<FreeholderCommissionRateTypeModel[]>;

    /**
     * @return Success
     */
    getClientPaymentTypes(signal?: AbortSignal | undefined): Promise<ClientPaymentTypeModel[]>;

    /**
     * @return Success
     */
    getFundScheduleChargeTypes(signal?: AbortSignal | undefined): Promise<FundScheduleChargeTypeModel[]>;

    /**
     * @return Success
     */
    getCountries(signal?: AbortSignal | undefined): Promise<CountryCodeModel[]>;

    /**
     * @param templateTypeID (optional) 
     * @return Success
     */
    getSelfServeDataImportWorksheetTypes(templateTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportWorksheetTypeModel[]>;
}

@injectable()
export class CPLTypesClient extends CPLClientBase implements ICPLTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getAccountTypes(signal?: AbortSignal | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Types/GetAccountTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountTypes(_response);
        });
    }

    protected processGetAccountTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getPropertyTypes(signal?: AbortSignal | undefined): Promise<PropertyTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetPropertyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertyTypes(_response);
        });
    }

    protected processGetPropertyTypes(response: Response): Promise<PropertyTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PropertyTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getAccountingBasisTypes(signal?: AbortSignal | undefined): Promise<AccountingBasisTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetAccountingBasisTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccountingBasisTypes(_response);
        });
    }

    protected processGetAccountingBasisTypes(response: Response): Promise<AccountingBasisTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountingBasisTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AccountingBasisTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPropertyServiceChargeTypes(signal?: AbortSignal | undefined): Promise<PropertyServiceChargeTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetPropertyServiceChargeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertyServiceChargeTypes(_response);
        });
    }

    protected processGetPropertyServiceChargeTypes(response: Response): Promise<PropertyServiceChargeTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyServiceChargeTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PropertyServiceChargeTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getAuthorityToActTypes(signal?: AbortSignal | undefined): Promise<AuthorityToActTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetAuthorityToActTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAuthorityToActTypes(_response);
        });
    }

    protected processGetAuthorityToActTypes(response: Response): Promise<AuthorityToActTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorityToActTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AuthorityToActTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getListedTypes(signal?: AbortSignal | undefined): Promise<ListedTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetListedTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListedTypes(_response);
        });
    }

    protected processGetListedTypes(response: Response): Promise<ListedTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListedTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ListedTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getFreeholderCommissionRateTypes(signal?: AbortSignal | undefined): Promise<FreeholderCommissionRateTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetFreeholderCommissionRateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFreeholderCommissionRateTypes(_response);
        });
    }

    protected processGetFreeholderCommissionRateTypes(response: Response): Promise<FreeholderCommissionRateTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreeholderCommissionRateTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FreeholderCommissionRateTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getClientPaymentTypes(signal?: AbortSignal | undefined): Promise<ClientPaymentTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetClientPaymentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPaymentTypes(_response);
        });
    }

    protected processGetClientPaymentTypes(response: Response): Promise<ClientPaymentTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPaymentTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPaymentTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getFundScheduleChargeTypes(signal?: AbortSignal | undefined): Promise<FundScheduleChargeTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetFundScheduleChargeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundScheduleChargeTypes(_response);
        });
    }

    protected processGetFundScheduleChargeTypes(response: Response): Promise<FundScheduleChargeTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FundScheduleChargeTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<FundScheduleChargeTypeModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getCountries(signal?: AbortSignal | undefined): Promise<CountryCodeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<CountryCodeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryCodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CountryCodeModel[]>(null as any);
    }

    /**
     * @param templateTypeID (optional) 
     * @return Success
     */
    getSelfServeDataImportWorksheetTypes(templateTypeID?: number | undefined, signal?: AbortSignal | undefined): Promise<SelfServeDataImportWorksheetTypeModel[]> {
        let url_ = this.baseUrl + "/api/Types/GetSelfServeDataImportWorksheetTypes?";
        if (templateTypeID === null)
            throw new globalThis.Error("The parameter 'templateTypeID' cannot be null.");
        else if (templateTypeID !== undefined)
            url_ += "templateTypeID=" + encodeURIComponent("" + templateTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelfServeDataImportWorksheetTypes(_response);
        });
    }

    protected processGetSelfServeDataImportWorksheetTypes(response: Response): Promise<SelfServeDataImportWorksheetTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelfServeDataImportWorksheetTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<SelfServeDataImportWorksheetTypeModel[]>(null as any);
    }
}

export interface ICPLUsersClient {

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;

    /**
     * @param useConnectLogin (optional) 
     * @param userID (optional) 
     * @return Success
     */
    setUseConnectLogin(useConnectLogin?: boolean | undefined, userID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getUsers(signal?: AbortSignal | undefined): Promise<UserModel[]>;

    /**
     * @return Success
     */
    getPropertyManagerSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createCoreUser(body?: NewUserModel | undefined, signal?: AbortSignal | undefined): Promise<string>;
}

@injectable()
export class CPLUsersClient extends CPLClientBase implements ICPLUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Users/GetSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSelectModels(_response);
        });
    }

    protected processGetSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }

    /**
     * @param useConnectLogin (optional) 
     * @param userID (optional) 
     * @return Success
     */
    setUseConnectLogin(useConnectLogin?: boolean | undefined, userID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/SetUseConnectLogin?";
        if (useConnectLogin === null)
            throw new globalThis.Error("The parameter 'useConnectLogin' cannot be null.");
        else if (useConnectLogin !== undefined)
            url_ += "useConnectLogin=" + encodeURIComponent("" + useConnectLogin) + "&";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUseConnectLogin(_response);
        });
    }

    protected processSetUseConnectLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUsers(signal?: AbortSignal | undefined): Promise<UserModel[]> {
        let url_ = this.baseUrl + "/api/Users/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getPropertyManagerSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/Users/GetPropertyManagerSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertyManagerSelectModels(_response);
        });
    }

    protected processGetPropertyManagerSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCoreUser(body?: NewUserModel | undefined, signal?: AbortSignal | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/CreateCoreUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCoreUser(_response);
        });
    }

    protected processCreateCoreUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLUsersSupervisorsClient {

    /**
     * @return Success
     */
    getSubordinateUserSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]>;
}

@injectable()
export class CPLUsersSupervisorsClient extends CPLClientBase implements ICPLUsersSupervisorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getSubordinateUserSelectModels(signal?: AbortSignal | undefined): Promise<GuidSelectModel[]> {
        let url_ = this.baseUrl + "/api/UsersSupervisors/GetSubordinateUserSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubordinateUserSelectModels(_response);
        });
    }

    protected processGetSubordinateUserSelectModels(response: Response): Promise<GuidSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuidSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<GuidSelectModel[]>(null as any);
    }
}

export interface ICPLUserTasksClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserTasks(body?: UserTaskFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<UserTaskModel[]>;

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    getUserTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<UserTaskModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserTask(body?: NewUserTaskModel | undefined, signal?: AbortSignal | undefined): Promise<number>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserTask(body?: UserTaskModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    holdTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    resumeTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    cancelUserTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getUserTaskTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @return Success
     */
    getUserTaskStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]>;

    /**
     * @param userTaskID (optional) 
     * @param jobID (optional) 
     * @param jobTaskNo (optional) 
     * @return Success
     */
    onJobCreated(userTaskID?: number | undefined, jobID?: number | undefined, jobTaskNo?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param userTaskID (optional) 
     * @param estimateRequestID (optional) 
     * @return Success
     */
    onEstimateRequestCreated(userTaskID?: number | undefined, estimateRequestID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param userTaskID (optional) 
     * @param proposedWorkID (optional) 
     * @return Success
     */
    onProposedWorkCreated(userTaskID?: number | undefined, proposedWorkID?: string | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLUserTasksClient extends CPLClientBase implements ICPLUserTasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUserTasks(body?: UserTaskFiltersModel | undefined, signal?: AbortSignal | undefined): Promise<UserTaskModel[]> {
        let url_ = this.baseUrl + "/api/UserTasks/GetUserTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTasks(_response);
        });
    }

    protected processGetUserTasks(response: Response): Promise<UserTaskModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTaskModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserTaskModel[]>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    getUserTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<UserTaskModel> {
        let url_ = this.baseUrl + "/api/UserTasks/GetUserTask?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTask(_response);
        });
    }

    protected processGetUserTask(response: Response): Promise<UserTaskModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTaskModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserTaskModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserTask(body?: NewUserTaskModel | undefined, signal?: AbortSignal | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/UserTasks/CreateUserTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserTask(_response);
        });
    }

    protected processCreateUserTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserTask(body?: UserTaskModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/UpdateUserTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserTask(_response);
        });
    }

    protected processUpdateUserTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    holdTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/HoldTask?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHoldTask(_response);
        });
    }

    protected processHoldTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    resumeTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/ResumeTask?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResumeTask(_response);
        });
    }

    protected processResumeTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @return Success
     */
    cancelUserTask(userTaskID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/CancelUserTask?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelUserTask(_response);
        });
    }

    protected processCancelUserTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserTaskTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/UserTasks/GetUserTaskTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTaskTypeSelectModels(_response);
        });
    }

    protected processGetUserTaskTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @return Success
     */
    getUserTaskStatusTypeSelectModels(signal?: AbortSignal | undefined): Promise<IntSelectModel[]> {
        let url_ = this.baseUrl + "/api/UserTasks/GetUserTaskStatusTypeSelectModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTaskStatusTypeSelectModels(_response);
        });
    }

    protected processGetUserTaskStatusTypeSelectModels(response: Response): Promise<IntSelectModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntSelectModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<IntSelectModel[]>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @param jobID (optional) 
     * @param jobTaskNo (optional) 
     * @return Success
     */
    onJobCreated(userTaskID?: number | undefined, jobID?: number | undefined, jobTaskNo?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/OnJobCreated?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        if (jobID === null)
            throw new globalThis.Error("The parameter 'jobID' cannot be null.");
        else if (jobID !== undefined)
            url_ += "jobID=" + encodeURIComponent("" + jobID) + "&";
        if (jobTaskNo === null)
            throw new globalThis.Error("The parameter 'jobTaskNo' cannot be null.");
        else if (jobTaskNo !== undefined)
            url_ += "jobTaskNo=" + encodeURIComponent("" + jobTaskNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOnJobCreated(_response);
        });
    }

    protected processOnJobCreated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @param estimateRequestID (optional) 
     * @return Success
     */
    onEstimateRequestCreated(userTaskID?: number | undefined, estimateRequestID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/OnEstimateRequestCreated?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        if (estimateRequestID === null)
            throw new globalThis.Error("The parameter 'estimateRequestID' cannot be null.");
        else if (estimateRequestID !== undefined)
            url_ += "estimateRequestID=" + encodeURIComponent("" + estimateRequestID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOnEstimateRequestCreated(_response);
        });
    }

    protected processOnEstimateRequestCreated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userTaskID (optional) 
     * @param proposedWorkID (optional) 
     * @return Success
     */
    onProposedWorkCreated(userTaskID?: number | undefined, proposedWorkID?: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserTasks/OnProposedWorkCreated?";
        if (userTaskID === null)
            throw new globalThis.Error("The parameter 'userTaskID' cannot be null.");
        else if (userTaskID !== undefined)
            url_ += "userTaskID=" + encodeURIComponent("" + userTaskID) + "&";
        if (proposedWorkID === null)
            throw new globalThis.Error("The parameter 'proposedWorkID' cannot be null.");
        else if (proposedWorkID !== undefined)
            url_ += "proposedWorkID=" + encodeURIComponent("" + proposedWorkID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOnProposedWorkCreated(_response);
        });
    }

    protected processOnProposedWorkCreated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLWebNarrativesClient {

    /**
     * @return Success
     */
    getWebNarratives(signal?: AbortSignal | undefined): Promise<ClientPortalWebNarrativeModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWebNarrative(body?: ClientPortalWebNarrativeModel | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLWebNarrativesClient extends CPLClientBase implements ICPLWebNarrativesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getWebNarratives(signal?: AbortSignal | undefined): Promise<ClientPortalWebNarrativeModel[]> {
        let url_ = this.baseUrl + "/api/WebNarratives/GetWebNarratives";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWebNarratives(_response);
        });
    }

    protected processGetWebNarratives(response: Response): Promise<ClientPortalWebNarrativeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalWebNarrativeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalWebNarrativeModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWebNarrative(body?: ClientPortalWebNarrativeModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WebNarratives/UpdateWebNarrative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWebNarrative(_response);
        });
    }

    protected processUpdateWebNarrative(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLWorkingHoursClient {

    /**
     * @return Success
     */
    getStandardWorkingHours(signal?: AbortSignal | undefined): Promise<WorkingHoursModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandardWorkingHours(body?: WorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @return Success
     */
    getOverrideWorkingHours(signal?: AbortSignal | undefined): Promise<OverrideWorkingHoursModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createOverrideWorkingHours(body?: OverrideWorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOverrideWorkingHours(body?: OverrideWorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void>;

    /**
     * @param overrideWorkingHoursID (optional) 
     * @return Success
     */
    deleteOverrideWorkingHours(overrideWorkingHoursID?: number | undefined, signal?: AbortSignal | undefined): Promise<void>;
}

@injectable()
export class CPLWorkingHoursClient extends CPLClientBase implements ICPLWorkingHoursClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getStandardWorkingHours(signal?: AbortSignal | undefined): Promise<WorkingHoursModel[]> {
        let url_ = this.baseUrl + "/api/WorkingHours/GetStandardWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStandardWorkingHours(_response);
        });
    }

    protected processGetStandardWorkingHours(response: Response): Promise<WorkingHoursModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkingHoursModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<WorkingHoursModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStandardWorkingHours(body?: WorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingHours/UpdateStandardWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStandardWorkingHours(_response);
        });
    }

    protected processUpdateStandardWorkingHours(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getOverrideWorkingHours(signal?: AbortSignal | undefined): Promise<OverrideWorkingHoursModel[]> {
        let url_ = this.baseUrl + "/api/WorkingHours/GetOverrideWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOverrideWorkingHours(_response);
        });
    }

    protected processGetOverrideWorkingHours(response: Response): Promise<OverrideWorkingHoursModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OverrideWorkingHoursModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<OverrideWorkingHoursModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOverrideWorkingHours(body?: OverrideWorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingHours/CreateOverrideWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOverrideWorkingHours(_response);
        });
    }

    protected processCreateOverrideWorkingHours(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOverrideWorkingHours(body?: OverrideWorkingHoursModel | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingHours/UpdateOverrideWorkingHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOverrideWorkingHours(_response);
        });
    }

    protected processUpdateOverrideWorkingHours(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param overrideWorkingHoursID (optional) 
     * @return Success
     */
    deleteOverrideWorkingHours(overrideWorkingHoursID?: number | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WorkingHours/DeleteOverrideWorkingHours?";
        if (overrideWorkingHoursID === null)
            throw new globalThis.Error("The parameter 'overrideWorkingHoursID' cannot be null.");
        else if (overrideWorkingHoursID !== undefined)
            url_ += "overrideWorkingHoursID=" + encodeURIComponent("" + overrideWorkingHoursID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOverrideWorkingHours(_response);
        });
    }

    protected processDeleteOverrideWorkingHours(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountingBasisTypeModel implements IAccountingBasisTypeModel {
    accountingBasisTypeID?: number;
    accountingBasisType?: string | undefined;

    constructor(data?: IAccountingBasisTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountingBasisTypeID = _data["accountingBasisTypeID"];
            this.accountingBasisType = _data["accountingBasisType"];
        }
    }

    static fromJS(data: any): AccountingBasisTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingBasisTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountingBasisTypeID"] = this.accountingBasisTypeID;
        data["accountingBasisType"] = this.accountingBasisType;
        return data;
    }
}

export interface IAccountingBasisTypeModel {
    accountingBasisTypeID?: number;
    accountingBasisType?: string | undefined;
}

export enum AccountingBasisTypes {
    Budgeted = "Budgeted",
    Actual = "Actual",
    ActualBudgeted = "ActualBudgeted",
    ServiceCharge = "ServiceCharge",
}

export class AdHocRecipientModel implements IAdHocRecipientModel {
    emailAddress?: string | undefined;
    displayName?: string | undefined;

    constructor(data?: IAdHocRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): AdHocRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IAdHocRecipientModel {
    emailAddress?: string | undefined;
    displayName?: string | undefined;
}

export class AddressModel implements IAddressModel {
    addressID?: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressID = _data["addressID"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.addressLine4 = _data["addressLine4"];
            this.addressLine5 = _data["addressLine5"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postCode = _data["postCode"];
            this.countryCodeID = _data["countryCodeID"];
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressID"] = this.addressID;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["addressLine4"] = this.addressLine4;
        data["addressLine5"] = this.addressLine5;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postCode"] = this.postCode;
        data["countryCodeID"] = this.countryCodeID;
        return data;
    }
}

export interface IAddressModel {
    addressID?: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;
}

export class AnticipatedExpenditureFooter implements IAnticipatedExpenditureFooter {
    reportFooterImageURL?: string | undefined;

    constructor(data?: IAnticipatedExpenditureFooter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportFooterImageURL = _data["reportFooterImageURL"];
        }
    }

    static fromJS(data: any): AnticipatedExpenditureFooter {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipatedExpenditureFooter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportFooterImageURL"] = this.reportFooterImageURL;
        return data;
    }
}

export interface IAnticipatedExpenditureFooter {
    reportFooterImageURL?: string | undefined;
}

export class AnticipatedExpenditureFundSchedule implements IAnticipatedExpenditureFundSchedule {
    scheduleName?: string | undefined;
    expenditureItems?: ExpenditureItem[] | undefined;
    totalGrossAnticipatedExpenditure?: number;
    estimatedGrossAnnualExpenditure?: number;
    vatTotal?: number;
    netTotal?: number;
    isVATElected?: boolean;

    constructor(data?: IAnticipatedExpenditureFundSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleName = _data["scheduleName"];
            if (Array.isArray(_data["expenditureItems"])) {
                this.expenditureItems = [] as any;
                for (let item of _data["expenditureItems"])
                    this.expenditureItems!.push(ExpenditureItem.fromJS(item));
            }
            this.totalGrossAnticipatedExpenditure = _data["totalGrossAnticipatedExpenditure"];
            this.estimatedGrossAnnualExpenditure = _data["estimatedGrossAnnualExpenditure"];
            this.vatTotal = _data["vatTotal"];
            this.netTotal = _data["netTotal"];
            this.isVATElected = _data["isVATElected"];
        }
    }

    static fromJS(data: any): AnticipatedExpenditureFundSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipatedExpenditureFundSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleName"] = this.scheduleName;
        if (Array.isArray(this.expenditureItems)) {
            data["expenditureItems"] = [];
            for (let item of this.expenditureItems)
                data["expenditureItems"].push(item.toJSON());
        }
        data["totalGrossAnticipatedExpenditure"] = this.totalGrossAnticipatedExpenditure;
        data["estimatedGrossAnnualExpenditure"] = this.estimatedGrossAnnualExpenditure;
        data["vatTotal"] = this.vatTotal;
        data["netTotal"] = this.netTotal;
        data["isVATElected"] = this.isVATElected;
        return data;
    }
}

export interface IAnticipatedExpenditureFundSchedule {
    scheduleName?: string | undefined;
    expenditureItems?: ExpenditureItem[] | undefined;
    totalGrossAnticipatedExpenditure?: number;
    estimatedGrossAnnualExpenditure?: number;
    vatTotal?: number;
    netTotal?: number;
    isVATElected?: boolean;
}

export class AnticipatedExpenditureHeader implements IAnticipatedExpenditureHeader {
    reportHeaderImageURL?: string | undefined;
    clientID?: string;
    clientName?: string | undefined;
    clientAddress?: string | undefined;
    reportDate?: string | undefined;
    accountNo?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    developmentName?: string | undefined;
    propertyAddress?: string | undefined;

    constructor(data?: IAnticipatedExpenditureHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportHeaderImageURL = _data["reportHeaderImageURL"];
            this.clientID = _data["clientID"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.reportDate = _data["reportDate"];
            this.accountNo = _data["accountNo"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.developmentName = _data["developmentName"];
            this.propertyAddress = _data["propertyAddress"];
        }
    }

    static fromJS(data: any): AnticipatedExpenditureHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipatedExpenditureHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportHeaderImageURL"] = this.reportHeaderImageURL;
        data["clientID"] = this.clientID;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["reportDate"] = this.reportDate;
        data["accountNo"] = this.accountNo;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["developmentName"] = this.developmentName;
        data["propertyAddress"] = this.propertyAddress;
        return data;
    }
}

export interface IAnticipatedExpenditureHeader {
    reportHeaderImageURL?: string | undefined;
    clientID?: string;
    clientName?: string | undefined;
    clientAddress?: string | undefined;
    reportDate?: string | undefined;
    accountNo?: string | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    developmentName?: string | undefined;
    propertyAddress?: string | undefined;
}

export class AnticipatedExpenditureReportModel implements IAnticipatedExpenditureReportModel {
    header?: AnticipatedExpenditureHeader;
    fundSchedules?: AnticipatedExpenditureFundSchedule[] | undefined;
    overallExpenditure?: number;
    coverLetter?: string | undefined;
    footer?: AnticipatedExpenditureFooter;

    constructor(data?: IAnticipatedExpenditureReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? AnticipatedExpenditureHeader.fromJS(_data["header"]) : undefined as any;
            if (Array.isArray(_data["fundSchedules"])) {
                this.fundSchedules = [] as any;
                for (let item of _data["fundSchedules"])
                    this.fundSchedules!.push(AnticipatedExpenditureFundSchedule.fromJS(item));
            }
            this.overallExpenditure = _data["overallExpenditure"];
            this.coverLetter = _data["coverLetter"];
            this.footer = _data["footer"] ? AnticipatedExpenditureFooter.fromJS(_data["footer"]) : undefined as any;
        }
    }

    static fromJS(data: any): AnticipatedExpenditureReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipatedExpenditureReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.fundSchedules)) {
            data["fundSchedules"] = [];
            for (let item of this.fundSchedules)
                data["fundSchedules"].push(item.toJSON());
        }
        data["overallExpenditure"] = this.overallExpenditure;
        data["coverLetter"] = this.coverLetter;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnticipatedExpenditureReportModel {
    header?: AnticipatedExpenditureHeader;
    fundSchedules?: AnticipatedExpenditureFundSchedule[] | undefined;
    overallExpenditure?: number;
    coverLetter?: string | undefined;
    footer?: AnticipatedExpenditureFooter;
}

export class AnticipatedExpenditureSelectionModel implements IAnticipatedExpenditureSelectionModel {
    currentStep?: number;
    isBackgroundProcessRunning?: boolean;
    fromDate?: Date;
    toDate?: Date;
    developmentIDs?: string[] | undefined;
    fundScheduleIDs?: number[] | undefined;
    blockIDs?: string[] | undefined;
    clientIDs?: string[] | undefined;
    includeCoverLetter?: boolean;
    coverLetter?: string | undefined;
    reportModels?: AnticipatedExpenditureReportModel[] | undefined;
    documentBatchID?: number | undefined;
    hasAccepted?: boolean;
    hasPrinted?: boolean;
    hasEmailed?: boolean;

    constructor(data?: IAnticipatedExpenditureSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStep = _data["currentStep"];
            this.isBackgroundProcessRunning = _data["isBackgroundProcessRunning"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            if (Array.isArray(_data["developmentIDs"])) {
                this.developmentIDs = [] as any;
                for (let item of _data["developmentIDs"])
                    this.developmentIDs!.push(item);
            }
            if (Array.isArray(_data["fundScheduleIDs"])) {
                this.fundScheduleIDs = [] as any;
                for (let item of _data["fundScheduleIDs"])
                    this.fundScheduleIDs!.push(item);
            }
            if (Array.isArray(_data["blockIDs"])) {
                this.blockIDs = [] as any;
                for (let item of _data["blockIDs"])
                    this.blockIDs!.push(item);
            }
            if (Array.isArray(_data["clientIDs"])) {
                this.clientIDs = [] as any;
                for (let item of _data["clientIDs"])
                    this.clientIDs!.push(item);
            }
            this.includeCoverLetter = _data["includeCoverLetter"];
            this.coverLetter = _data["coverLetter"];
            if (Array.isArray(_data["reportModels"])) {
                this.reportModels = [] as any;
                for (let item of _data["reportModels"])
                    this.reportModels!.push(AnticipatedExpenditureReportModel.fromJS(item));
            }
            this.documentBatchID = _data["documentBatchID"];
            this.hasAccepted = _data["hasAccepted"];
            this.hasPrinted = _data["hasPrinted"];
            this.hasEmailed = _data["hasEmailed"];
        }
    }

    static fromJS(data: any): AnticipatedExpenditureSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnticipatedExpenditureSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStep"] = this.currentStep;
        data["isBackgroundProcessRunning"] = this.isBackgroundProcessRunning;
        data["fromDate"] = this.fromDate?.isValidDate() ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate?.isValidDate() ? this.toDate.toISOString() : <any>undefined;
        if (Array.isArray(this.developmentIDs)) {
            data["developmentIDs"] = [];
            for (let item of this.developmentIDs)
                data["developmentIDs"].push(item);
        }
        if (Array.isArray(this.fundScheduleIDs)) {
            data["fundScheduleIDs"] = [];
            for (let item of this.fundScheduleIDs)
                data["fundScheduleIDs"].push(item);
        }
        if (Array.isArray(this.blockIDs)) {
            data["blockIDs"] = [];
            for (let item of this.blockIDs)
                data["blockIDs"].push(item);
        }
        if (Array.isArray(this.clientIDs)) {
            data["clientIDs"] = [];
            for (let item of this.clientIDs)
                data["clientIDs"].push(item);
        }
        data["includeCoverLetter"] = this.includeCoverLetter;
        data["coverLetter"] = this.coverLetter;
        if (Array.isArray(this.reportModels)) {
            data["reportModels"] = [];
            for (let item of this.reportModels)
                data["reportModels"].push(item.toJSON());
        }
        data["documentBatchID"] = this.documentBatchID;
        data["hasAccepted"] = this.hasAccepted;
        data["hasPrinted"] = this.hasPrinted;
        data["hasEmailed"] = this.hasEmailed;
        return data;
    }
}

export interface IAnticipatedExpenditureSelectionModel {
    currentStep?: number;
    isBackgroundProcessRunning?: boolean;
    fromDate?: Date;
    toDate?: Date;
    developmentIDs?: string[] | undefined;
    fundScheduleIDs?: number[] | undefined;
    blockIDs?: string[] | undefined;
    clientIDs?: string[] | undefined;
    includeCoverLetter?: boolean;
    coverLetter?: string | undefined;
    reportModels?: AnticipatedExpenditureReportModel[] | undefined;
    documentBatchID?: number | undefined;
    hasAccepted?: boolean;
    hasPrinted?: boolean;
    hasEmailed?: boolean;
}

export class AuthorityToActTypeModel implements IAuthorityToActTypeModel {
    authorityToActTypeID?: number;
    description?: string | undefined;

    constructor(data?: IAuthorityToActTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorityToActTypeID = _data["authorityToActTypeID"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AuthorityToActTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorityToActTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorityToActTypeID"] = this.authorityToActTypeID;
        data["description"] = this.description;
        return data;
    }
}

export interface IAuthorityToActTypeModel {
    authorityToActTypeID?: number;
    description?: string | undefined;
}

export class BlinkProcessPaymentResponseModel implements IBlinkProcessPaymentResponseModel {
    acsform?: string | undefined;

    constructor(data?: IBlinkProcessPaymentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acsform = _data["acsform"];
        }
    }

    static fromJS(data: any): BlinkProcessPaymentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlinkProcessPaymentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acsform"] = this.acsform;
        return data;
    }
}

export interface IBlinkProcessPaymentResponseModel {
    acsform?: string | undefined;
}

export class BlinkSettingsModel implements IBlinkSettingsModel {
    paymentDescription?: string | undefined;
    apiKeySupplied?: boolean;
    secretKeySupplied?: boolean;
    setupComplete?: boolean;

    constructor(data?: IBlinkSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDescription = _data["paymentDescription"];
            this.apiKeySupplied = _data["apiKeySupplied"];
            this.secretKeySupplied = _data["secretKeySupplied"];
            this.setupComplete = _data["setupComplete"];
        }
    }

    static fromJS(data: any): BlinkSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlinkSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDescription"] = this.paymentDescription;
        data["apiKeySupplied"] = this.apiKeySupplied;
        data["secretKeySupplied"] = this.secretKeySupplied;
        data["setupComplete"] = this.setupComplete;
        return data;
    }
}

export interface IBlinkSettingsModel {
    paymentDescription?: string | undefined;
    apiKeySupplied?: boolean;
    secretKeySupplied?: boolean;
    setupComplete?: boolean;
}

export enum CPL3Settings {
    ClientPortalRaiseCase = "ClientPortalRaiseCase",
    ClientPortalViewJobs = "ClientPortalViewJobs",
    ClientPortalViewCases = "ClientPortalViewCases",
    ClientPortalViewProposedWorks = "ClientPortalViewProposedWorks",
    ClientPortalViewDocuments = "ClientPortalViewDocuments",
    ClientPortalViewCreditControl = "ClientPortalViewCreditControl",
    ClientPortalViewMeetings = "ClientPortalViewMeetings",
    ClientPortalViewDevelopmentInfo = "ClientPortalViewDevelopmentInfo",
    ClientPortalViewDevelopmentNews = "ClientPortalViewDevelopmentNews",
    ClientPortalAccessPayments = "ClientPortalAccessPayments",
    ClientPortalProposedWorkVoting = "ClientPortalProposedWorkVoting",
    ClientPortalDirectDebitSetup = "ClientPortalDirectDebitSetup",
    ClientPortalViewBudgets = "ClientPortalViewBudgets",
    GetInTouchLink = "GetInTouchLink",
    ClientPortalViewJobTimeline = "ClientPortalViewJobTimeline",
    AIEconomyModelDeployment = "AIEconomyModelDeployment",
    AIAdvancedModelDeployment = "AIAdvancedModelDeployment",
    ServiceChargeInvoicingReportHeader = "ServiceChargeInvoicingReportHeader",
    ServiceChargeInvoicingReportFooter = "ServiceChargeInvoicingReportFooter",
    AIEmbeddingModelDeployment = "AIEmbeddingModelDeployment",
    JobAndEstimatesVisibility = "JobAndEstimatesVisibility",
    ClientPortalEditAddressAndEmail = "ClientPortalEditAddressAndEmail",
    AssistimoResultsLimit = "AssistimoResultsLimit",
    CustomPayNowLink = "CustomPayNowLink",
    DirectDebitAdminFeeAmount = "DirectDebitAdminFeeAmount",
    DirectDebitAdminFeePostingDestination = "DirectDebitAdminFeePostingDestination",
    DirectDebitAdminFeePostingFundHeader = "DirectDebitAdminFeePostingFundHeader",
    MajorWorksVisibility = "MajorWorksVisibility",
    AllowOverpayments = "AllowOverpayments",
}

export class CalendarEventModel implements ICalendarEventModel {
    calendarEventID?: number;
    title?: string | undefined;
    description?: string | undefined;
    start?: Date;
    end?: Date;
    createdBy?: string;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    completed?: boolean;
    deleted?: boolean;
    calendarEventTypeID?: number;
    calendarEventTypeName?: string | undefined;
    userTaskID?: number | undefined;
    meetingID?: number | undefined;
    allDay?: boolean;

    constructor(data?: ICalendarEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarEventID = _data["calendarEventID"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.completed = _data["completed"];
            this.deleted = _data["deleted"];
            this.calendarEventTypeID = _data["calendarEventTypeID"];
            this.calendarEventTypeName = _data["calendarEventTypeName"];
            this.userTaskID = _data["userTaskID"];
            this.meetingID = _data["meetingID"];
            this.allDay = _data["allDay"];
        }
    }

    static fromJS(data: any): CalendarEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarEventID"] = this.calendarEventID;
        data["title"] = this.title;
        data["description"] = this.description;
        data["start"] = this.start?.isValidDate() ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end?.isValidDate() ? this.end.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["completed"] = this.completed;
        data["deleted"] = this.deleted;
        data["calendarEventTypeID"] = this.calendarEventTypeID;
        data["calendarEventTypeName"] = this.calendarEventTypeName;
        data["userTaskID"] = this.userTaskID;
        data["meetingID"] = this.meetingID;
        data["allDay"] = this.allDay;
        return data;
    }
}

export interface ICalendarEventModel {
    calendarEventID?: number;
    title?: string | undefined;
    description?: string | undefined;
    start?: Date;
    end?: Date;
    createdBy?: string;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    completed?: boolean;
    deleted?: boolean;
    calendarEventTypeID?: number;
    calendarEventTypeName?: string | undefined;
    userTaskID?: number | undefined;
    meetingID?: number | undefined;
    allDay?: boolean;
}

export class CaseModel implements ICaseModel {
    caseID?: number;
    title?: string | undefined;
    assignedUser?: string;
    assignedUserDisplayName?: string | undefined;
    caseTypeID?: number;
    caseTypeName?: string | undefined;
    caseStatusTypeID?: number;
    caseStatusTypeName?: string | undefined;
    userTaskID?: number;
    clientID?: string | undefined;
    clientName?: string | undefined;
    clientAccountNumber?: string | undefined;
    developmentName?: string | undefined;
    propertyName?: string | undefined;
    adHocEmailAddress?: string | undefined;
    adHocRecipientName?: string | undefined;
    commentThreadID?: string;
    slaTypeID?: number;
    slaTypeName?: string | undefined;
    slaTarget?: Date;
    createdBy?: string;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    meetingID?: number | undefined;
    formattedRecipient?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;

    constructor(data?: ICaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseID = _data["caseID"];
            this.title = _data["title"];
            this.assignedUser = _data["assignedUser"];
            this.assignedUserDisplayName = _data["assignedUserDisplayName"];
            this.caseTypeID = _data["caseTypeID"];
            this.caseTypeName = _data["caseTypeName"];
            this.caseStatusTypeID = _data["caseStatusTypeID"];
            this.caseStatusTypeName = _data["caseStatusTypeName"];
            this.userTaskID = _data["userTaskID"];
            this.clientID = _data["clientID"];
            this.clientName = _data["clientName"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.developmentName = _data["developmentName"];
            this.propertyName = _data["propertyName"];
            this.adHocEmailAddress = _data["adHocEmailAddress"];
            this.adHocRecipientName = _data["adHocRecipientName"];
            this.commentThreadID = _data["commentThreadID"];
            this.slaTypeID = _data["slaTypeID"];
            this.slaTypeName = _data["slaTypeName"];
            this.slaTarget = _data["slaTarget"] ? new Date(_data["slaTarget"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.meetingID = _data["meetingID"];
            this.formattedRecipient = _data["formattedRecipient"];
            this.lastReplyDate = _data["lastReplyDate"] ? new Date(_data["lastReplyDate"].toString()) : undefined as any;
            this.hasUnreadComments = _data["hasUnreadComments"];
        }
    }

    static fromJS(data: any): CaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseID"] = this.caseID;
        data["title"] = this.title;
        data["assignedUser"] = this.assignedUser;
        data["assignedUserDisplayName"] = this.assignedUserDisplayName;
        data["caseTypeID"] = this.caseTypeID;
        data["caseTypeName"] = this.caseTypeName;
        data["caseStatusTypeID"] = this.caseStatusTypeID;
        data["caseStatusTypeName"] = this.caseStatusTypeName;
        data["userTaskID"] = this.userTaskID;
        data["clientID"] = this.clientID;
        data["clientName"] = this.clientName;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["developmentName"] = this.developmentName;
        data["propertyName"] = this.propertyName;
        data["adHocEmailAddress"] = this.adHocEmailAddress;
        data["adHocRecipientName"] = this.adHocRecipientName;
        data["commentThreadID"] = this.commentThreadID;
        data["slaTypeID"] = this.slaTypeID;
        data["slaTypeName"] = this.slaTypeName;
        data["slaTarget"] = this.slaTarget?.isValidDate() ? this.slaTarget.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["meetingID"] = this.meetingID;
        data["formattedRecipient"] = this.formattedRecipient;
        data["lastReplyDate"] = this.lastReplyDate?.isValidDate() ? this.lastReplyDate.toISOString() : <any>undefined;
        data["hasUnreadComments"] = this.hasUnreadComments;
        return data;
    }
}

export interface ICaseModel {
    caseID?: number;
    title?: string | undefined;
    assignedUser?: string;
    assignedUserDisplayName?: string | undefined;
    caseTypeID?: number;
    caseTypeName?: string | undefined;
    caseStatusTypeID?: number;
    caseStatusTypeName?: string | undefined;
    userTaskID?: number;
    clientID?: string | undefined;
    clientName?: string | undefined;
    clientAccountNumber?: string | undefined;
    developmentName?: string | undefined;
    propertyName?: string | undefined;
    adHocEmailAddress?: string | undefined;
    adHocRecipientName?: string | undefined;
    commentThreadID?: string;
    slaTypeID?: number;
    slaTypeName?: string | undefined;
    slaTarget?: Date;
    createdBy?: string;
    createdDate?: Date;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    meetingID?: number | undefined;
    formattedRecipient?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;
}

export class CaseStatusTypeModel implements ICaseStatusTypeModel {
    caseStatusTypeID?: number;
    name?: string | undefined;
    caseStatusBehaviourTypeID?: number;
    caseStatusBehaviourTypeName?: string | undefined;
    deleted?: boolean;
    systemRequired?: boolean;

    constructor(data?: ICaseStatusTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseStatusTypeID = _data["caseStatusTypeID"];
            this.name = _data["name"];
            this.caseStatusBehaviourTypeID = _data["caseStatusBehaviourTypeID"];
            this.caseStatusBehaviourTypeName = _data["caseStatusBehaviourTypeName"];
            this.deleted = _data["deleted"];
            this.systemRequired = _data["systemRequired"];
        }
    }

    static fromJS(data: any): CaseStatusTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatusTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseStatusTypeID"] = this.caseStatusTypeID;
        data["name"] = this.name;
        data["caseStatusBehaviourTypeID"] = this.caseStatusBehaviourTypeID;
        data["caseStatusBehaviourTypeName"] = this.caseStatusBehaviourTypeName;
        data["deleted"] = this.deleted;
        data["systemRequired"] = this.systemRequired;
        return data;
    }
}

export interface ICaseStatusTypeModel {
    caseStatusTypeID?: number;
    name?: string | undefined;
    caseStatusBehaviourTypeID?: number;
    caseStatusBehaviourTypeName?: string | undefined;
    deleted?: boolean;
    systemRequired?: boolean;
}

export class CaseTypeModel implements ICaseTypeModel {
    caseTypeID?: number;
    name?: string | undefined;
    systemRequired?: boolean;
    showOnPortal?: boolean;

    constructor(data?: ICaseTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseTypeID = _data["caseTypeID"];
            this.name = _data["name"];
            this.systemRequired = _data["systemRequired"];
            this.showOnPortal = _data["showOnPortal"];
        }
    }

    static fromJS(data: any): CaseTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseTypeID"] = this.caseTypeID;
        data["name"] = this.name;
        data["systemRequired"] = this.systemRequired;
        data["showOnPortal"] = this.showOnPortal;
        return data;
    }
}

export interface ICaseTypeModel {
    caseTypeID?: number;
    name?: string | undefined;
    systemRequired?: boolean;
    showOnPortal?: boolean;
}

export class ChangeTrackingModel implements IChangeTrackingModel {
    columnPropertyNameDisplayName?: { [key: string]: string; } | undefined;
    rows?: ChangeTrackingRowModel[] | undefined;

    constructor(data?: IChangeTrackingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["columnPropertyNameDisplayName"]) {
                this.columnPropertyNameDisplayName = {} as any;
                for (let key in _data["columnPropertyNameDisplayName"]) {
                    if (_data["columnPropertyNameDisplayName"].hasOwnProperty(key))
                        (this.columnPropertyNameDisplayName as any)![key] = _data["columnPropertyNameDisplayName"][key];
                }
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ChangeTrackingRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeTrackingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTrackingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.columnPropertyNameDisplayName) {
            data["columnPropertyNameDisplayName"] = {};
            for (let key in this.columnPropertyNameDisplayName) {
                if (this.columnPropertyNameDisplayName.hasOwnProperty(key))
                    (<any>data["columnPropertyNameDisplayName"])[key] = (<any>this.columnPropertyNameDisplayName)[key];
            }
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChangeTrackingModel {
    columnPropertyNameDisplayName?: { [key: string]: string; } | undefined;
    rows?: ChangeTrackingRowModel[] | undefined;
}

export class ChangeTrackingRowModel implements IChangeTrackingRowModel {
    changeDate?: Date;
    changedBy?: string | undefined;
    propertyNameCellValue?: { [key: string]: string; } | undefined;

    constructor(data?: IChangeTrackingRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : undefined as any;
            this.changedBy = _data["changedBy"];
            if (_data["propertyNameCellValue"]) {
                this.propertyNameCellValue = {} as any;
                for (let key in _data["propertyNameCellValue"]) {
                    if (_data["propertyNameCellValue"].hasOwnProperty(key))
                        (this.propertyNameCellValue as any)![key] = _data["propertyNameCellValue"][key];
                }
            }
        }
    }

    static fromJS(data: any): ChangeTrackingRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTrackingRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeDate"] = this.changeDate?.isValidDate() ? this.changeDate.toISOString() : <any>undefined;
        data["changedBy"] = this.changedBy;
        if (this.propertyNameCellValue) {
            data["propertyNameCellValue"] = {};
            for (let key in this.propertyNameCellValue) {
                if (this.propertyNameCellValue.hasOwnProperty(key))
                    (<any>data["propertyNameCellValue"])[key] = (<any>this.propertyNameCellValue)[key];
            }
        }
        return data;
    }
}

export interface IChangeTrackingRowModel {
    changeDate?: Date;
    changedBy?: string | undefined;
    propertyNameCellValue?: { [key: string]: string; } | undefined;
}

export enum ChangeTrackingTypes {
    UserTasks = "UserTasks",
    CalendarEvents = "CalendarEvents",
    Cases = "Cases",
}

export class ChatDocumentModel implements IChatDocumentModel {
    documentID?: string;
    name?: string | undefined;

    constructor(data?: IChatDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ChatDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["name"] = this.name;
        return data;
    }
}

export interface IChatDocumentModel {
    documentID?: string;
    name?: string | undefined;
}

export class ChatMessageModel implements IChatMessageModel {
    messageID?: number;
    role?: number;
    message?: string | undefined;
    timestamp?: Date;
    queryResults?: { [key: string]: QueryResultModel; } | undefined;
    feedback?: MessageFeedbackModel;
    documents?: ChatDocumentModel[] | undefined;

    constructor(data?: IChatMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageID = _data["messageID"];
            this.role = _data["role"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            if (_data["queryResults"]) {
                this.queryResults = {} as any;
                for (let key in _data["queryResults"]) {
                    if (_data["queryResults"].hasOwnProperty(key))
                        (this.queryResults as any)![key] = _data["queryResults"][key] ? QueryResultModel.fromJS(_data["queryResults"][key]) : new QueryResultModel();
                }
            }
            this.feedback = _data["feedback"] ? MessageFeedbackModel.fromJS(_data["feedback"]) : undefined as any;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ChatDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageID"] = this.messageID;
        data["role"] = this.role;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp?.isValidDate() ? this.timestamp.toISOString() : <any>undefined;
        if (this.queryResults) {
            data["queryResults"] = {};
            for (let key in this.queryResults) {
                if (this.queryResults.hasOwnProperty(key))
                    (<any>data["queryResults"])[key] = this.queryResults[key] ? this.queryResults[key].toJSON() : <any>undefined;
            }
        }
        data["feedback"] = this.feedback ? this.feedback.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatMessageModel {
    messageID?: number;
    role?: number;
    message?: string | undefined;
    timestamp?: Date;
    queryResults?: { [key: string]: QueryResultModel; } | undefined;
    feedback?: MessageFeedbackModel;
    documents?: ChatDocumentModel[] | undefined;
}

export class ChatReplyModel implements IChatReplyModel {
    chatSessionID?: string;
    reply?: ChatMessageModel;

    constructor(data?: IChatReplyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.reply = _data["reply"] ? ChatMessageModel.fromJS(_data["reply"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChatReplyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatReplyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["reply"] = this.reply ? this.reply.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatReplyModel {
    chatSessionID?: string;
    reply?: ChatMessageModel;
}

export class ChatSessionDetailModel implements IChatSessionDetailModel {
    chatSessionID?: string;
    chatName?: string | undefined;
    startedAt?: Date;
    messages?: ChatMessageModel[] | undefined;
    documents?: ChatDocumentModel[] | undefined;

    constructor(data?: IChatSessionDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.chatName = _data["chatName"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ChatMessageModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ChatDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatSessionDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatSessionDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["chatName"] = this.chatName;
        data["startedAt"] = this.startedAt?.isValidDate() ? this.startedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatSessionDetailModel {
    chatSessionID?: string;
    chatName?: string | undefined;
    startedAt?: Date;
    messages?: ChatMessageModel[] | undefined;
    documents?: ChatDocumentModel[] | undefined;
}

export class ChatSessionModel implements IChatSessionModel {
    chatSessionID?: string;
    chatName?: string | undefined;
    startedAt?: Date;

    constructor(data?: IChatSessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.chatName = _data["chatName"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ChatSessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatSessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["chatName"] = this.chatName;
        data["startedAt"] = this.startedAt?.isValidDate() ? this.startedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChatSessionModel {
    chatSessionID?: string;
    chatName?: string | undefined;
    startedAt?: Date;
}

export class ClientAccountEmailModel implements IClientAccountEmailModel {
    clientEmailID?: string;
    clientID?: string;
    emailAddress?: string | undefined;
    emailDescription?: string | undefined;
    default?: boolean;
    updatedUser?: string | undefined;
    updatedDate?: Date | undefined;
    usedForInvoice?: boolean;
    usedForDocuments?: boolean;

    constructor(data?: IClientAccountEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientEmailID = _data["clientEmailID"];
            this.clientID = _data["clientID"];
            this.emailAddress = _data["emailAddress"];
            this.emailDescription = _data["emailDescription"];
            this.default = _data["default"];
            this.updatedUser = _data["updatedUser"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.usedForInvoice = _data["usedForInvoice"];
            this.usedForDocuments = _data["usedForDocuments"];
        }
    }

    static fromJS(data: any): ClientAccountEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAccountEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientEmailID"] = this.clientEmailID;
        data["clientID"] = this.clientID;
        data["emailAddress"] = this.emailAddress;
        data["emailDescription"] = this.emailDescription;
        data["default"] = this.default;
        data["updatedUser"] = this.updatedUser;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["usedForInvoice"] = this.usedForInvoice;
        data["usedForDocuments"] = this.usedForDocuments;
        return data;
    }
}

export interface IClientAccountEmailModel {
    clientEmailID?: string;
    clientID?: string;
    emailAddress?: string | undefined;
    emailDescription?: string | undefined;
    default?: boolean;
    updatedUser?: string | undefined;
    updatedDate?: Date | undefined;
    usedForInvoice?: boolean;
    usedForDocuments?: boolean;
}

export class ClientAddressLinesModel implements IClientAddressLinesModel {
    fullAddress?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;

    constructor(data?: IClientAddressLinesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullAddress = _data["fullAddress"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.city = _data["city"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): ClientAddressLinesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAddressLinesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullAddress"] = this.fullAddress;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["city"] = this.city;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface IClientAddressLinesModel {
    fullAddress?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
}

export class ClientAddressModel implements IClientAddressModel {
    clientAddressID?: string;
    clientID?: string;
    name?: string | undefined;
    address?: ClientAddressLinesModel;
    billingAddress?: boolean;
    forwardingAddress?: boolean;
    internalBilling?: boolean;
    deleted?: boolean;
    description?: string | undefined;

    constructor(data?: IClientAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAddressID = _data["clientAddressID"];
            this.clientID = _data["clientID"];
            this.name = _data["name"];
            this.address = _data["address"] ? ClientAddressLinesModel.fromJS(_data["address"]) : undefined as any;
            this.billingAddress = _data["billingAddress"];
            this.forwardingAddress = _data["forwardingAddress"];
            this.internalBilling = _data["internalBilling"];
            this.deleted = _data["deleted"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClientAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAddressID"] = this.clientAddressID;
        data["clientID"] = this.clientID;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["billingAddress"] = this.billingAddress;
        data["forwardingAddress"] = this.forwardingAddress;
        data["internalBilling"] = this.internalBilling;
        data["deleted"] = this.deleted;
        data["description"] = this.description;
        return data;
    }
}

export interface IClientAddressModel {
    clientAddressID?: string;
    clientID?: string;
    name?: string | undefined;
    address?: ClientAddressLinesModel;
    billingAddress?: boolean;
    forwardingAddress?: boolean;
    internalBilling?: boolean;
    deleted?: boolean;
    description?: string | undefined;
}

export class ClientContactDetailsModel implements IClientContactDetailsModel {
    clientID?: string;
    accountNumber?: string | undefined;
    property?: string | undefined;
    billingAddress?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IClientContactDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.accountNumber = _data["accountNumber"];
            this.property = _data["property"];
            this.billingAddress = _data["billingAddress"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ClientContactDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientContactDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["accountNumber"] = this.accountNumber;
        data["property"] = this.property;
        data["billingAddress"] = this.billingAddress;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IClientContactDetailsModel {
    clientID?: string;
    accountNumber?: string | undefined;
    property?: string | undefined;
    billingAddress?: string | undefined;
    emailAddress?: string | undefined;
}

export enum ClientDDFrequencies {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
}

export class ClientDirectDebitDetailsModel implements IClientDirectDebitDetailsModel {
    clientID?: string;
    variable?: boolean;
    amount?: number;
    frequency?: string | undefined;
    collectionDay?: number | undefined;
    paymentSwitchoverPending?: boolean;
    normalMonthlyAmount?: number | undefined;
    paymentSwitchoverDate?: Date | undefined;

    constructor(data?: IClientDirectDebitDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.variable = _data["variable"];
            this.amount = _data["amount"];
            this.frequency = _data["frequency"];
            this.collectionDay = _data["collectionDay"];
            this.paymentSwitchoverPending = _data["paymentSwitchoverPending"];
            this.normalMonthlyAmount = _data["normalMonthlyAmount"];
            this.paymentSwitchoverDate = _data["paymentSwitchoverDate"] ? new Date(_data["paymentSwitchoverDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClientDirectDebitDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDirectDebitDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["variable"] = this.variable;
        data["amount"] = this.amount;
        data["frequency"] = this.frequency;
        data["collectionDay"] = this.collectionDay;
        data["paymentSwitchoverPending"] = this.paymentSwitchoverPending;
        data["normalMonthlyAmount"] = this.normalMonthlyAmount;
        data["paymentSwitchoverDate"] = this.paymentSwitchoverDate?.isValidDate() ? this.paymentSwitchoverDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientDirectDebitDetailsModel {
    clientID?: string;
    variable?: boolean;
    amount?: number;
    frequency?: string | undefined;
    collectionDay?: number | undefined;
    paymentSwitchoverPending?: boolean;
    normalMonthlyAmount?: number | undefined;
    paymentSwitchoverDate?: Date | undefined;
}

export class ClientNoticeSelectionModel implements IClientNoticeSelectionModel {
    batchNo?: number;
    printedOnly?: boolean;
    clientID?: string | undefined;

    constructor(data?: IClientNoticeSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNo = _data["batchNo"];
            this.printedOnly = _data["printedOnly"];
            this.clientID = _data["clientID"];
        }
    }

    static fromJS(data: any): ClientNoticeSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNoticeSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNo"] = this.batchNo;
        data["printedOnly"] = this.printedOnly;
        data["clientID"] = this.clientID;
        return data;
    }
}

export interface IClientNoticeSelectionModel {
    batchNo?: number;
    printedOnly?: boolean;
    clientID?: string | undefined;
}

export class ClientPaymentTypeModel implements IClientPaymentTypeModel {
    clientPaymentTypeID?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IClientPaymentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPaymentTypeID = _data["clientPaymentTypeID"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClientPaymentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPaymentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPaymentTypeID"] = this.clientPaymentTypeID;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IClientPaymentTypeModel {
    clientPaymentTypeID?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class ClientPortalBudgetChargeModel implements IClientPortalBudgetChargeModel {
    chargeFileID?: string | undefined;
    transactionDate?: Date;
    description?: string | undefined;
    totalAmount?: number;
    shareDivide?: string | undefined;
    shareAmount?: number;
    invoiceNumber?: string | undefined;
    transactionInvoiceID?: string | undefined;

    constructor(data?: IClientPortalBudgetChargeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeFileID = _data["chargeFileID"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.totalAmount = _data["totalAmount"];
            this.shareDivide = _data["shareDivide"];
            this.shareAmount = _data["shareAmount"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionInvoiceID = _data["transactionInvoiceID"];
        }
    }

    static fromJS(data: any): ClientPortalBudgetChargeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetChargeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeFileID"] = this.chargeFileID;
        data["transactionDate"] = this.transactionDate?.isValidDate() ? this.transactionDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["totalAmount"] = this.totalAmount;
        data["shareDivide"] = this.shareDivide;
        data["shareAmount"] = this.shareAmount;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionInvoiceID"] = this.transactionInvoiceID;
        return data;
    }
}

export interface IClientPortalBudgetChargeModel {
    chargeFileID?: string | undefined;
    transactionDate?: Date;
    description?: string | undefined;
    totalAmount?: number;
    shareDivide?: string | undefined;
    shareAmount?: number;
    invoiceNumber?: string | undefined;
    transactionInvoiceID?: string | undefined;
}

export class ClientPortalBudgetChargesModel implements IClientPortalBudgetChargesModel {
    charges?: ClientPortalBudgetChargeModel[] | undefined;

    constructor(data?: IClientPortalBudgetChargesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["charges"])) {
                this.charges = [] as any;
                for (let item of _data["charges"])
                    this.charges!.push(ClientPortalBudgetChargeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientPortalBudgetChargesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetChargesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPortalBudgetChargesModel {
    charges?: ClientPortalBudgetChargeModel[] | undefined;
}

export class ClientPortalBudgetHeaderModel implements IClientPortalBudgetHeaderModel {
    headerID?: number | undefined;
    budgetID?: number;
    header?: string | undefined;
    headerNarrative?: string | undefined;
    annualBudget?: number;
    actualToDate?: number;
    difference?: number;

    constructor(data?: IClientPortalBudgetHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerID = _data["headerID"];
            this.budgetID = _data["budgetID"];
            this.header = _data["header"];
            this.headerNarrative = _data["headerNarrative"];
            this.annualBudget = _data["annualBudget"];
            this.actualToDate = _data["actualToDate"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): ClientPortalBudgetHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerID"] = this.headerID;
        data["budgetID"] = this.budgetID;
        data["header"] = this.header;
        data["headerNarrative"] = this.headerNarrative;
        data["annualBudget"] = this.annualBudget;
        data["actualToDate"] = this.actualToDate;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IClientPortalBudgetHeaderModel {
    headerID?: number | undefined;
    budgetID?: number;
    header?: string | undefined;
    headerNarrative?: string | undefined;
    annualBudget?: number;
    actualToDate?: number;
    difference?: number;
}

export class ClientPortalBudgetHeadersModel implements IClientPortalBudgetHeadersModel {
    budgetHeaders?: ClientPortalBudgetHeaderModel[] | undefined;

    constructor(data?: IClientPortalBudgetHeadersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetHeaders"])) {
                this.budgetHeaders = [] as any;
                for (let item of _data["budgetHeaders"])
                    this.budgetHeaders!.push(ClientPortalBudgetHeaderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientPortalBudgetHeadersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetHeadersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetHeaders)) {
            data["budgetHeaders"] = [];
            for (let item of this.budgetHeaders)
                data["budgetHeaders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPortalBudgetHeadersModel {
    budgetHeaders?: ClientPortalBudgetHeaderModel[] | undefined;
}

export class ClientPortalBudgetModel implements IClientPortalBudgetModel {
    budgetID?: number;
    budgetYear?: string | undefined;
    annualBudget?: number;
    actualToDate?: number;
    difference?: number;

    constructor(data?: IClientPortalBudgetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetID = _data["budgetID"];
            this.budgetYear = _data["budgetYear"];
            this.annualBudget = _data["annualBudget"];
            this.actualToDate = _data["actualToDate"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): ClientPortalBudgetModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetID"] = this.budgetID;
        data["budgetYear"] = this.budgetYear;
        data["annualBudget"] = this.annualBudget;
        data["actualToDate"] = this.actualToDate;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IClientPortalBudgetModel {
    budgetID?: number;
    budgetYear?: string | undefined;
    annualBudget?: number;
    actualToDate?: number;
    difference?: number;
}

export class ClientPortalBudgetsModel implements IClientPortalBudgetsModel {
    budgets?: ClientPortalBudgetModel[] | undefined;

    constructor(data?: IClientPortalBudgetsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgets"])) {
                this.budgets = [] as any;
                for (let item of _data["budgets"])
                    this.budgets!.push(ClientPortalBudgetModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientPortalBudgetsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalBudgetsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgets)) {
            data["budgets"] = [];
            for (let item of this.budgets)
                data["budgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPortalBudgetsModel {
    budgets?: ClientPortalBudgetModel[] | undefined;
}

export class ClientPortalCaseDetailsModel implements IClientPortalCaseDetailsModel {
    caseID?: number;
    title?: string | undefined;
    propertyAddress?: string | undefined;
    assignedUserName?: string | undefined;
    caseTypeName?: string | undefined;
    caseStatusName?: string | undefined;
    slaType?: string | undefined;
    slaTarget?: Date;
    commentThreadID?: string;
    allowComments?: boolean;

    constructor(data?: IClientPortalCaseDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseID = _data["caseID"];
            this.title = _data["title"];
            this.propertyAddress = _data["propertyAddress"];
            this.assignedUserName = _data["assignedUserName"];
            this.caseTypeName = _data["caseTypeName"];
            this.caseStatusName = _data["caseStatusName"];
            this.slaType = _data["slaType"];
            this.slaTarget = _data["slaTarget"] ? new Date(_data["slaTarget"].toString()) : undefined as any;
            this.commentThreadID = _data["commentThreadID"];
            this.allowComments = _data["allowComments"];
        }
    }

    static fromJS(data: any): ClientPortalCaseDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalCaseDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseID"] = this.caseID;
        data["title"] = this.title;
        data["propertyAddress"] = this.propertyAddress;
        data["assignedUserName"] = this.assignedUserName;
        data["caseTypeName"] = this.caseTypeName;
        data["caseStatusName"] = this.caseStatusName;
        data["slaType"] = this.slaType;
        data["slaTarget"] = this.slaTarget?.isValidDate() ? this.slaTarget.toISOString() : <any>undefined;
        data["commentThreadID"] = this.commentThreadID;
        data["allowComments"] = this.allowComments;
        return data;
    }
}

export interface IClientPortalCaseDetailsModel {
    caseID?: number;
    title?: string | undefined;
    propertyAddress?: string | undefined;
    assignedUserName?: string | undefined;
    caseTypeName?: string | undefined;
    caseStatusName?: string | undefined;
    slaType?: string | undefined;
    slaTarget?: Date;
    commentThreadID?: string;
    allowComments?: boolean;
}

export class ClientPortalCaseFiltersModel implements IClientPortalCaseFiltersModel {
    includeArchived?: boolean;

    constructor(data?: IClientPortalCaseFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): ClientPortalCaseFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalCaseFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        return data;
    }
}

export interface IClientPortalCaseFiltersModel {
    includeArchived?: boolean;
}

export class ClientPortalCaseModel implements IClientPortalCaseModel {
    caseID?: number;
    title?: string | undefined;
    propertyAddress?: string | undefined;
    caseTypeID?: number;
    caseTypeName?: string | undefined;
    caseStatusName?: string | undefined;
    caseStatusBehaviourType?: number;
    age?: number;
    plTransactionFileId?: string | undefined;
    plChargeFileID?: string | undefined;

    constructor(data?: IClientPortalCaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseID = _data["caseID"];
            this.title = _data["title"];
            this.propertyAddress = _data["propertyAddress"];
            this.caseTypeID = _data["caseTypeID"];
            this.caseTypeName = _data["caseTypeName"];
            this.caseStatusName = _data["caseStatusName"];
            this.caseStatusBehaviourType = _data["caseStatusBehaviourType"];
            this.age = _data["age"];
            this.plTransactionFileId = _data["plTransactionFileId"];
            this.plChargeFileID = _data["plChargeFileID"];
        }
    }

    static fromJS(data: any): ClientPortalCaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalCaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseID"] = this.caseID;
        data["title"] = this.title;
        data["propertyAddress"] = this.propertyAddress;
        data["caseTypeID"] = this.caseTypeID;
        data["caseTypeName"] = this.caseTypeName;
        data["caseStatusName"] = this.caseStatusName;
        data["caseStatusBehaviourType"] = this.caseStatusBehaviourType;
        data["age"] = this.age;
        data["plTransactionFileId"] = this.plTransactionFileId;
        data["plChargeFileID"] = this.plChargeFileID;
        return data;
    }
}

export interface IClientPortalCaseModel {
    caseID?: number;
    title?: string | undefined;
    propertyAddress?: string | undefined;
    caseTypeID?: number;
    caseTypeName?: string | undefined;
    caseStatusName?: string | undefined;
    caseStatusBehaviourType?: number;
    age?: number;
    plTransactionFileId?: string | undefined;
    plChargeFileID?: string | undefined;
}

export class ClientPortalCommentModel implements IClientPortalCommentModel {
    commentID?: number;
    commentCreatorID?: string | undefined;
    commentCreatorName?: string | undefined;
    commentDate?: Date;
    message?: string | undefined;
    systemComment?: boolean;
    existingAttachments?: CommentAttachmentModel[] | undefined;
    allowEditing?: boolean;

    constructor(data?: IClientPortalCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentID = _data["commentID"];
            this.commentCreatorID = _data["commentCreatorID"];
            this.commentCreatorName = _data["commentCreatorName"];
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : undefined as any;
            this.message = _data["message"];
            this.systemComment = _data["systemComment"];
            if (Array.isArray(_data["existingAttachments"])) {
                this.existingAttachments = [] as any;
                for (let item of _data["existingAttachments"])
                    this.existingAttachments!.push(CommentAttachmentModel.fromJS(item));
            }
            this.allowEditing = _data["allowEditing"];
        }
    }

    static fromJS(data: any): ClientPortalCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentID"] = this.commentID;
        data["commentCreatorID"] = this.commentCreatorID;
        data["commentCreatorName"] = this.commentCreatorName;
        data["commentDate"] = this.commentDate?.isValidDate() ? this.commentDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["systemComment"] = this.systemComment;
        if (Array.isArray(this.existingAttachments)) {
            data["existingAttachments"] = [];
            for (let item of this.existingAttachments)
                data["existingAttachments"].push(item.toJSON());
        }
        data["allowEditing"] = this.allowEditing;
        return data;
    }
}

export interface IClientPortalCommentModel {
    commentID?: number;
    commentCreatorID?: string | undefined;
    commentCreatorName?: string | undefined;
    commentDate?: Date;
    message?: string | undefined;
    systemComment?: boolean;
    existingAttachments?: CommentAttachmentModel[] | undefined;
    allowEditing?: boolean;
}

export class ClientPortalDevelopmentInfoModel implements IClientPortalDevelopmentInfoModel {
    name?: string | undefined;
    propertyNames?: string[] | undefined;
    contacts?: DevelopmentContactInfoModel[] | undefined;

    constructor(data?: IClientPortalDevelopmentInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["propertyNames"])) {
                this.propertyNames = [] as any;
                for (let item of _data["propertyNames"])
                    this.propertyNames!.push(item);
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(DevelopmentContactInfoModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientPortalDevelopmentInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalDevelopmentInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.propertyNames)) {
            data["propertyNames"] = [];
            for (let item of this.propertyNames)
                data["propertyNames"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPortalDevelopmentInfoModel {
    name?: string | undefined;
    propertyNames?: string[] | undefined;
    contacts?: DevelopmentContactInfoModel[] | undefined;
}

export class ClientPortalDocumentFiltersModel implements IClientPortalDocumentFiltersModel {
    dateFrom?: Date | undefined;

    constructor(data?: IClientPortalDocumentFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClientPortalDocumentFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalDocumentFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFrom"] = this.dateFrom?.isValidDate() ? this.dateFrom.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientPortalDocumentFiltersModel {
    dateFrom?: Date | undefined;
}

export class ClientPortalDocumentInstanceModel implements IClientPortalDocumentInstanceModel {
    documentID?: string;
    description?: string | undefined;
    createdDate?: Date;
    propertyAddress?: string | undefined;
    clientAccountNumber?: string | undefined;
    documentType?: string | undefined;
    filePath?: string | undefined;

    constructor(data?: IClientPortalDocumentInstanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.propertyAddress = _data["propertyAddress"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.documentType = _data["documentType"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): ClientPortalDocumentInstanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalDocumentInstanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["propertyAddress"] = this.propertyAddress;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["documentType"] = this.documentType;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IClientPortalDocumentInstanceModel {
    documentID?: string;
    description?: string | undefined;
    createdDate?: Date;
    propertyAddress?: string | undefined;
    clientAccountNumber?: string | undefined;
    documentType?: string | undefined;
    filePath?: string | undefined;
}

export class ClientPortalDocumentModel implements IClientPortalDocumentModel {
    documentID?: string | undefined;
    createdDate?: Date;
    description?: string | undefined;
    developmentAddress?: string | undefined;
    propertyAddress?: string | undefined;
    documentType?: string | undefined;
    monthsTillExpire?: number | undefined;
    attachmentsCount?: number;
    instancesCount?: number;
    important?: boolean;
    clientAccountNo?: string | undefined;
    filePath?: string | undefined;

    constructor(data?: IClientPortalDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.developmentAddress = _data["developmentAddress"];
            this.propertyAddress = _data["propertyAddress"];
            this.documentType = _data["documentType"];
            this.monthsTillExpire = _data["monthsTillExpire"];
            this.attachmentsCount = _data["attachmentsCount"];
            this.instancesCount = _data["instancesCount"];
            this.important = _data["important"];
            this.clientAccountNo = _data["clientAccountNo"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): ClientPortalDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["developmentAddress"] = this.developmentAddress;
        data["propertyAddress"] = this.propertyAddress;
        data["documentType"] = this.documentType;
        data["monthsTillExpire"] = this.monthsTillExpire;
        data["attachmentsCount"] = this.attachmentsCount;
        data["instancesCount"] = this.instancesCount;
        data["important"] = this.important;
        data["clientAccountNo"] = this.clientAccountNo;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IClientPortalDocumentModel {
    documentID?: string | undefined;
    createdDate?: Date;
    description?: string | undefined;
    developmentAddress?: string | undefined;
    propertyAddress?: string | undefined;
    documentType?: string | undefined;
    monthsTillExpire?: number | undefined;
    attachmentsCount?: number;
    instancesCount?: number;
    important?: boolean;
    clientAccountNo?: string | undefined;
    filePath?: string | undefined;
}

export class ClientPortalEmailModel implements IClientPortalEmailModel {
    to?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IClientPortalEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): ClientPortalEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IClientPortalEmailModel {
    to?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class ClientPortalGlobalSearchResultModel implements IClientPortalGlobalSearchResultModel {
    type?: ClientPortalGlobalSearchResultTypes;
    recordID?: any | undefined;
    text?: string | undefined;
    label?: string | undefined;

    constructor(data?: IClientPortalGlobalSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.recordID = _data["recordID"];
            this.text = _data["text"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ClientPortalGlobalSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalGlobalSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["recordID"] = this.recordID;
        data["text"] = this.text;
        data["label"] = this.label;
        return data;
    }
}

export interface IClientPortalGlobalSearchResultModel {
    type?: ClientPortalGlobalSearchResultTypes;
    recordID?: any | undefined;
    text?: string | undefined;
    label?: string | undefined;
}

export enum ClientPortalGlobalSearchResultTypes {
    All = "All",
    Case = "Case",
    Meeting = "Meeting",
    Job = "Job",
    ProposedWorks = "ProposedWorks",
    Transaction = "Transaction",
}

export class ClientPortalJobDetailsModel implements IClientPortalJobDetailsModel {
    estimateRequestID?: string | undefined;
    jobID?: number | undefined;
    taskSeqNo?: number | undefined;
    reference?: string | undefined;
    status?: string | undefined;
    createdDate?: Date | undefined;
    estimatedArrivalDate?: Date | undefined;
    development?: string | undefined;
    properties?: string[] | undefined;
    description?: string | undefined;
    commentThreadID?: string | undefined;
    allowComments?: boolean;
    jobTimeline?: JobTimelineModel;

    constructor(data?: IClientPortalJobDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateRequestID = _data["estimateRequestID"];
            this.jobID = _data["jobID"];
            this.taskSeqNo = _data["taskSeqNo"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.estimatedArrivalDate = _data["estimatedArrivalDate"] ? new Date(_data["estimatedArrivalDate"].toString()) : undefined as any;
            this.development = _data["development"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(item);
            }
            this.description = _data["description"];
            this.commentThreadID = _data["commentThreadID"];
            this.allowComments = _data["allowComments"];
            this.jobTimeline = _data["jobTimeline"] ? JobTimelineModel.fromJS(_data["jobTimeline"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientPortalJobDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalJobDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateRequestID"] = this.estimateRequestID;
        data["jobID"] = this.jobID;
        data["taskSeqNo"] = this.taskSeqNo;
        data["reference"] = this.reference;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["estimatedArrivalDate"] = this.estimatedArrivalDate?.isValidDate() ? this.estimatedArrivalDate.toISOString() : <any>undefined;
        data["development"] = this.development;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item);
        }
        data["description"] = this.description;
        data["commentThreadID"] = this.commentThreadID;
        data["allowComments"] = this.allowComments;
        data["jobTimeline"] = this.jobTimeline ? this.jobTimeline.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientPortalJobDetailsModel {
    estimateRequestID?: string | undefined;
    jobID?: number | undefined;
    taskSeqNo?: number | undefined;
    reference?: string | undefined;
    status?: string | undefined;
    createdDate?: Date | undefined;
    estimatedArrivalDate?: Date | undefined;
    development?: string | undefined;
    properties?: string[] | undefined;
    description?: string | undefined;
    commentThreadID?: string | undefined;
    allowComments?: boolean;
    jobTimeline?: JobTimelineModel;
}

export class ClientPortalJobFiltersModel implements IClientPortalJobFiltersModel {
    includeArchived?: boolean;

    constructor(data?: IClientPortalJobFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): ClientPortalJobFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalJobFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        return data;
    }
}

export interface IClientPortalJobFiltersModel {
    includeArchived?: boolean;
}

export class ClientPortalJobOverviewModel implements IClientPortalJobOverviewModel {
    jobID?: number | undefined;
    taskSeqNo?: number | undefined;
    estimateRequestID?: string | undefined;
    reference?: string | undefined;
    status?: string | undefined;
    description?: string | undefined;
    estimatedArrivalDate?: Date | undefined;
    development?: string | undefined;
    orderByDate?: Date;

    constructor(data?: IClientPortalJobOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"];
            this.taskSeqNo = _data["taskSeqNo"];
            this.estimateRequestID = _data["estimateRequestID"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.estimatedArrivalDate = _data["estimatedArrivalDate"] ? new Date(_data["estimatedArrivalDate"].toString()) : undefined as any;
            this.development = _data["development"];
            this.orderByDate = _data["orderByDate"] ? new Date(_data["orderByDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClientPortalJobOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalJobOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID;
        data["taskSeqNo"] = this.taskSeqNo;
        data["estimateRequestID"] = this.estimateRequestID;
        data["reference"] = this.reference;
        data["status"] = this.status;
        data["description"] = this.description;
        data["estimatedArrivalDate"] = this.estimatedArrivalDate?.isValidDate() ? this.estimatedArrivalDate.toISOString() : <any>undefined;
        data["development"] = this.development;
        data["orderByDate"] = this.orderByDate?.isValidDate() ? this.orderByDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientPortalJobOverviewModel {
    jobID?: number | undefined;
    taskSeqNo?: number | undefined;
    estimateRequestID?: string | undefined;
    reference?: string | undefined;
    status?: string | undefined;
    description?: string | undefined;
    estimatedArrivalDate?: Date | undefined;
    development?: string | undefined;
    orderByDate?: Date;
}

export class ClientPortalMeetingModel implements IClientPortalMeetingModel {
    meetingID?: number;
    title?: string | undefined;
    meetingTypeID?: number;
    meetingType?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    commentThreadID?: string;

    constructor(data?: IClientPortalMeetingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingID = _data["meetingID"];
            this.title = _data["title"];
            this.meetingTypeID = _data["meetingTypeID"];
            this.meetingType = _data["meetingType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.commentThreadID = _data["commentThreadID"];
        }
    }

    static fromJS(data: any): ClientPortalMeetingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalMeetingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingID"] = this.meetingID;
        data["title"] = this.title;
        data["meetingTypeID"] = this.meetingTypeID;
        data["meetingType"] = this.meetingType;
        data["startDate"] = this.startDate?.isValidDate() ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate?.isValidDate() ? this.endDate.toISOString() : <any>undefined;
        data["commentThreadID"] = this.commentThreadID;
        return data;
    }
}

export interface IClientPortalMeetingModel {
    meetingID?: number;
    title?: string | undefined;
    meetingTypeID?: number;
    meetingType?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    commentThreadID?: string;
}

export class ClientPortalMeetingsFilterModel implements IClientPortalMeetingsFilterModel {
    includeArchived?: boolean;
    afterArchiveDate?: Date;

    constructor(data?: IClientPortalMeetingsFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
            this.afterArchiveDate = _data["afterArchiveDate"] ? new Date(_data["afterArchiveDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClientPortalMeetingsFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalMeetingsFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        data["afterArchiveDate"] = this.afterArchiveDate?.isValidDate() ? this.afterArchiveDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClientPortalMeetingsFilterModel {
    includeArchived?: boolean;
    afterArchiveDate?: Date;
}

export class ClientPortalNewCaseModel implements IClientPortalNewCaseModel {
    title?: string | undefined;
    description?: string | undefined;
    caseTypeID?: number;
    propertyID?: string;
    plTransactionFileID?: string | undefined;
    plChargeFileID?: string | undefined;

    constructor(data?: IClientPortalNewCaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.caseTypeID = _data["caseTypeID"];
            this.propertyID = _data["propertyID"];
            this.plTransactionFileID = _data["plTransactionFileID"];
            this.plChargeFileID = _data["plChargeFileID"];
        }
    }

    static fromJS(data: any): ClientPortalNewCaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalNewCaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["caseTypeID"] = this.caseTypeID;
        data["propertyID"] = this.propertyID;
        data["plTransactionFileID"] = this.plTransactionFileID;
        data["plChargeFileID"] = this.plChargeFileID;
        return data;
    }
}

export interface IClientPortalNewCaseModel {
    title?: string | undefined;
    description?: string | undefined;
    caseTypeID?: number;
    propertyID?: string;
    plTransactionFileID?: string | undefined;
    plChargeFileID?: string | undefined;
}

export class ClientPortalNewsModel implements IClientPortalNewsModel {
    developmentNewsID?: string;
    title?: string | undefined;
    body?: string | undefined;
    bodyAsPlainText?: string | undefined;
    postedOn?: Date;
    imagePath?: string | undefined;

    constructor(data?: IClientPortalNewsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentNewsID = _data["developmentNewsID"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.bodyAsPlainText = _data["bodyAsPlainText"];
            this.postedOn = _data["postedOn"] ? new Date(_data["postedOn"].toString()) : undefined as any;
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): ClientPortalNewsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalNewsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentNewsID"] = this.developmentNewsID;
        data["title"] = this.title;
        data["body"] = this.body;
        data["bodyAsPlainText"] = this.bodyAsPlainText;
        data["postedOn"] = this.postedOn?.isValidDate() ? this.postedOn.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        return data;
    }
}

export interface IClientPortalNewsModel {
    developmentNewsID?: string;
    title?: string | undefined;
    body?: string | undefined;
    bodyAsPlainText?: string | undefined;
    postedOn?: Date;
    imagePath?: string | undefined;
}

export class ClientPortalPaymentModel implements IClientPortalPaymentModel {
    paymentAmounts?: PaymentAmountModel[] | undefined;
    paymentConfirmationEmail?: string | undefined;
    reference?: number;
    proposedWorkID?: string | undefined;
    paymentProvider?: PaymentProviders;

    constructor(data?: IClientPortalPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentAmounts"])) {
                this.paymentAmounts = [] as any;
                for (let item of _data["paymentAmounts"])
                    this.paymentAmounts!.push(PaymentAmountModel.fromJS(item));
            }
            this.paymentConfirmationEmail = _data["paymentConfirmationEmail"];
            this.reference = _data["reference"];
            this.proposedWorkID = _data["proposedWorkID"];
            this.paymentProvider = _data["paymentProvider"];
        }
    }

    static fromJS(data: any): ClientPortalPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentAmounts)) {
            data["paymentAmounts"] = [];
            for (let item of this.paymentAmounts)
                data["paymentAmounts"].push(item.toJSON());
        }
        data["paymentConfirmationEmail"] = this.paymentConfirmationEmail;
        data["reference"] = this.reference;
        data["proposedWorkID"] = this.proposedWorkID;
        data["paymentProvider"] = this.paymentProvider;
        return data;
    }
}

export interface IClientPortalPaymentModel {
    paymentAmounts?: PaymentAmountModel[] | undefined;
    paymentConfirmationEmail?: string | undefined;
    reference?: number;
    proposedWorkID?: string | undefined;
    paymentProvider?: PaymentProviders;
}

export class ClientPortalProposedWorkDetailsModel implements IClientPortalProposedWorkDetailsModel {
    proposedWorkID?: string;
    reference?: number;
    createdDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    targetAmount?: number;
    achievedAmount?: number;
    workShareDetails?: ClientPortalProposedWorkShareDetails[] | undefined;
    votesFor?: number;
    votesAgainst?: number;
    votingProperties?: number;
    clientAgreed?: boolean | undefined;
    accountingBasisType?: AccountingBasisTypes;

    constructor(data?: IClientPortalProposedWorkDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposedWorkID = _data["proposedWorkID"];
            this.reference = _data["reference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.targetAmount = _data["targetAmount"];
            this.achievedAmount = _data["achievedAmount"];
            if (Array.isArray(_data["workShareDetails"])) {
                this.workShareDetails = [] as any;
                for (let item of _data["workShareDetails"])
                    this.workShareDetails!.push(ClientPortalProposedWorkShareDetails.fromJS(item));
            }
            this.votesFor = _data["votesFor"];
            this.votesAgainst = _data["votesAgainst"];
            this.votingProperties = _data["votingProperties"];
            this.clientAgreed = _data["clientAgreed"];
            this.accountingBasisType = _data["accountingBasisType"];
        }
    }

    static fromJS(data: any): ClientPortalProposedWorkDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalProposedWorkDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposedWorkID"] = this.proposedWorkID;
        data["reference"] = this.reference;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["type"] = this.type;
        data["targetAmount"] = this.targetAmount;
        data["achievedAmount"] = this.achievedAmount;
        if (Array.isArray(this.workShareDetails)) {
            data["workShareDetails"] = [];
            for (let item of this.workShareDetails)
                data["workShareDetails"].push(item.toJSON());
        }
        data["votesFor"] = this.votesFor;
        data["votesAgainst"] = this.votesAgainst;
        data["votingProperties"] = this.votingProperties;
        data["clientAgreed"] = this.clientAgreed;
        data["accountingBasisType"] = this.accountingBasisType;
        return data;
    }
}

export interface IClientPortalProposedWorkDetailsModel {
    proposedWorkID?: string;
    reference?: number;
    createdDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
    targetAmount?: number;
    achievedAmount?: number;
    workShareDetails?: ClientPortalProposedWorkShareDetails[] | undefined;
    votesFor?: number;
    votesAgainst?: number;
    votingProperties?: number;
    clientAgreed?: boolean | undefined;
    accountingBasisType?: AccountingBasisTypes;
}

export class ClientPortalProposedWorkDocumentModel implements IClientPortalProposedWorkDocumentModel {
    proposedWorkID?: string;
    documentID?: string;
    createdDate?: Date;
    description?: string | undefined;
    filePath?: string | undefined;

    constructor(data?: IClientPortalProposedWorkDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposedWorkID = _data["proposedWorkID"];
            this.documentID = _data["documentID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.filePath = _data["filePath"];
        }
    }

    static fromJS(data: any): ClientPortalProposedWorkDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalProposedWorkDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposedWorkID"] = this.proposedWorkID;
        data["documentID"] = this.documentID;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["filePath"] = this.filePath;
        return data;
    }
}

export interface IClientPortalProposedWorkDocumentModel {
    proposedWorkID?: string;
    documentID?: string;
    createdDate?: Date;
    description?: string | undefined;
    filePath?: string | undefined;
}

export class ClientPortalProposedWorkFiltersModel implements IClientPortalProposedWorkFiltersModel {
    includeArchived?: boolean;

    constructor(data?: IClientPortalProposedWorkFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): ClientPortalProposedWorkFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalProposedWorkFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        return data;
    }
}

export interface IClientPortalProposedWorkFiltersModel {
    includeArchived?: boolean;
}

export class ClientPortalProposedWorkModel implements IClientPortalProposedWorkModel {
    proposedWorkID?: string;
    reference?: number;
    createdDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    proposedWorkStatusID?: number;
    type?: string | undefined;
    targetAmount?: number;
    achievedAmount?: number;
    accountingBases?: AccountingBasisTypes[] | undefined;

    constructor(data?: IClientPortalProposedWorkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposedWorkID = _data["proposedWorkID"];
            this.reference = _data["reference"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.proposedWorkStatusID = _data["proposedWorkStatusID"];
            this.type = _data["type"];
            this.targetAmount = _data["targetAmount"];
            this.achievedAmount = _data["achievedAmount"];
            if (Array.isArray(_data["accountingBases"])) {
                this.accountingBases = [] as any;
                for (let item of _data["accountingBases"])
                    this.accountingBases!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientPortalProposedWorkModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalProposedWorkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposedWorkID"] = this.proposedWorkID;
        data["reference"] = this.reference;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["proposedWorkStatusID"] = this.proposedWorkStatusID;
        data["type"] = this.type;
        data["targetAmount"] = this.targetAmount;
        data["achievedAmount"] = this.achievedAmount;
        if (Array.isArray(this.accountingBases)) {
            data["accountingBases"] = [];
            for (let item of this.accountingBases)
                data["accountingBases"].push(item);
        }
        return data;
    }
}

export interface IClientPortalProposedWorkModel {
    proposedWorkID?: string;
    reference?: number;
    createdDate?: Date;
    name?: string | undefined;
    description?: string | undefined;
    status?: string | undefined;
    proposedWorkStatusID?: number;
    type?: string | undefined;
    targetAmount?: number;
    achievedAmount?: number;
    accountingBases?: AccountingBasisTypes[] | undefined;
}

export class ClientPortalProposedWorkShareDetails implements IClientPortalProposedWorkShareDetails {
    propertyID?: string;
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    amountPaid?: number;
    amountDue?: number;

    constructor(data?: IClientPortalProposedWorkShareDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyID = _data["propertyID"];
            this.clientID = _data["clientID"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.propertyAddress = _data["propertyAddress"];
            this.amountPaid = _data["amountPaid"];
            this.amountDue = _data["amountDue"];
        }
    }

    static fromJS(data: any): ClientPortalProposedWorkShareDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalProposedWorkShareDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyID"] = this.propertyID;
        data["clientID"] = this.clientID;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["propertyAddress"] = this.propertyAddress;
        data["amountPaid"] = this.amountPaid;
        data["amountDue"] = this.amountDue;
        return data;
    }
}

export interface IClientPortalProposedWorkShareDetails {
    propertyID?: string;
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    amountPaid?: number;
    amountDue?: number;
}

export class ClientPortalWebNarrativeModel implements IClientPortalWebNarrativeModel {
    clientPortalWebNarrativeID?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IClientPortalWebNarrativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPortalWebNarrativeID = _data["clientPortalWebNarrativeID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ClientPortalWebNarrativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalWebNarrativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPortalWebNarrativeID"] = this.clientPortalWebNarrativeID;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IClientPortalWebNarrativeModel {
    clientPortalWebNarrativeID?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class ClientPropertyBalanceItemModel implements IClientPropertyBalanceItemModel {
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    outstandingBalance?: number;
    eae?: number;
    hasTransactions?: boolean;
    isBudgeted?: boolean;
    clientDirectDebitDetails?: ClientDirectDebitDetailsModel;
    rentDirectDebitDetails?: ClientDirectDebitDetailsModel;
    isServiceChargeDevelopment?: boolean;
    accountOutstandingBalance?: number;
    rentOutstandingBalance?: number;
    groundRentValue?: number;

    constructor(data?: IClientPropertyBalanceItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.propertyAddress = _data["propertyAddress"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.eae = _data["eae"];
            this.hasTransactions = _data["hasTransactions"];
            this.isBudgeted = _data["isBudgeted"];
            this.clientDirectDebitDetails = _data["clientDirectDebitDetails"] ? ClientDirectDebitDetailsModel.fromJS(_data["clientDirectDebitDetails"]) : undefined as any;
            this.rentDirectDebitDetails = _data["rentDirectDebitDetails"] ? ClientDirectDebitDetailsModel.fromJS(_data["rentDirectDebitDetails"]) : undefined as any;
            this.isServiceChargeDevelopment = _data["isServiceChargeDevelopment"];
            this.accountOutstandingBalance = _data["accountOutstandingBalance"];
            this.rentOutstandingBalance = _data["rentOutstandingBalance"];
            this.groundRentValue = _data["groundRentValue"];
        }
    }

    static fromJS(data: any): ClientPropertyBalanceItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPropertyBalanceItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["propertyAddress"] = this.propertyAddress;
        data["outstandingBalance"] = this.outstandingBalance;
        data["eae"] = this.eae;
        data["hasTransactions"] = this.hasTransactions;
        data["isBudgeted"] = this.isBudgeted;
        data["clientDirectDebitDetails"] = this.clientDirectDebitDetails ? this.clientDirectDebitDetails.toJSON() : <any>undefined;
        data["rentDirectDebitDetails"] = this.rentDirectDebitDetails ? this.rentDirectDebitDetails.toJSON() : <any>undefined;
        data["isServiceChargeDevelopment"] = this.isServiceChargeDevelopment;
        data["accountOutstandingBalance"] = this.accountOutstandingBalance;
        data["rentOutstandingBalance"] = this.rentOutstandingBalance;
        data["groundRentValue"] = this.groundRentValue;
        return data;
    }
}

export interface IClientPropertyBalanceItemModel {
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    outstandingBalance?: number;
    eae?: number;
    hasTransactions?: boolean;
    isBudgeted?: boolean;
    clientDirectDebitDetails?: ClientDirectDebitDetailsModel;
    rentDirectDebitDetails?: ClientDirectDebitDetailsModel;
    isServiceChargeDevelopment?: boolean;
    accountOutstandingBalance?: number;
    rentOutstandingBalance?: number;
    groundRentValue?: number;
}

export class ClientPropertyBalanceListModel implements IClientPropertyBalanceListModel {
    useMaximumBalanceForDirectDebitSetup?: boolean;
    maximumBalanceForDirectDebitSetup?: number;
    allowGoCardlessDirectDebitSetup?: boolean;
    separatePayments?: boolean;
    propertyBalances?: ClientPropertyBalanceItemModel[] | undefined;

    constructor(data?: IClientPropertyBalanceListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useMaximumBalanceForDirectDebitSetup = _data["useMaximumBalanceForDirectDebitSetup"];
            this.maximumBalanceForDirectDebitSetup = _data["maximumBalanceForDirectDebitSetup"];
            this.allowGoCardlessDirectDebitSetup = _data["allowGoCardlessDirectDebitSetup"];
            this.separatePayments = _data["separatePayments"];
            if (Array.isArray(_data["propertyBalances"])) {
                this.propertyBalances = [] as any;
                for (let item of _data["propertyBalances"])
                    this.propertyBalances!.push(ClientPropertyBalanceItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientPropertyBalanceListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPropertyBalanceListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useMaximumBalanceForDirectDebitSetup"] = this.useMaximumBalanceForDirectDebitSetup;
        data["maximumBalanceForDirectDebitSetup"] = this.maximumBalanceForDirectDebitSetup;
        data["allowGoCardlessDirectDebitSetup"] = this.allowGoCardlessDirectDebitSetup;
        data["separatePayments"] = this.separatePayments;
        if (Array.isArray(this.propertyBalances)) {
            data["propertyBalances"] = [];
            for (let item of this.propertyBalances)
                data["propertyBalances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientPropertyBalanceListModel {
    useMaximumBalanceForDirectDebitSetup?: boolean;
    maximumBalanceForDirectDebitSetup?: number;
    allowGoCardlessDirectDebitSetup?: boolean;
    separatePayments?: boolean;
    propertyBalances?: ClientPropertyBalanceItemModel[] | undefined;
}

export class ClientSelectRequestModel implements IClientSelectRequestModel {
    blockIDs?: string[] | undefined;
    developmentIDs?: string[] | undefined;

    constructor(data?: IClientSelectRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["blockIDs"])) {
                this.blockIDs = [] as any;
                for (let item of _data["blockIDs"])
                    this.blockIDs!.push(item);
            }
            if (Array.isArray(_data["developmentIDs"])) {
                this.developmentIDs = [] as any;
                for (let item of _data["developmentIDs"])
                    this.developmentIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientSelectRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSelectRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blockIDs)) {
            data["blockIDs"] = [];
            for (let item of this.blockIDs)
                data["blockIDs"].push(item);
        }
        if (Array.isArray(this.developmentIDs)) {
            data["developmentIDs"] = [];
            for (let item of this.developmentIDs)
                data["developmentIDs"].push(item);
        }
        return data;
    }
}

export interface IClientSelectRequestModel {
    blockIDs?: string[] | undefined;
    developmentIDs?: string[] | undefined;
}

export class CommentAttachmentModel implements ICommentAttachmentModel {
    commentAttachmentID?: number;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    sasUri?: string | undefined;

    constructor(data?: ICommentAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentAttachmentID = _data["commentAttachmentID"];
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.sasUri = _data["sasUri"];
        }
    }

    static fromJS(data: any): CommentAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentAttachmentID"] = this.commentAttachmentID;
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["sasUri"] = this.sasUri;
        return data;
    }
}

export interface ICommentAttachmentModel {
    commentAttachmentID?: number;
    fileName?: string | undefined;
    fileSize?: number | undefined;
    sasUri?: string | undefined;
}

export class CommentModel implements ICommentModel {
    commentID?: number;
    commentCreatorID?: string | undefined;
    commentCreatorName?: string | undefined;
    commentDate?: Date;
    message?: string | undefined;
    systemComment?: boolean;
    existingAttachments?: CommentAttachmentModel[] | undefined;
    userID?: string | undefined;
    private?: boolean;
    taskNo?: number | undefined;
    jobID?: number | undefined;
    userTaskID?: number | undefined;
    caseID?: number | undefined;
    isUnread?: boolean;

    constructor(data?: ICommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentID = _data["commentID"];
            this.commentCreatorID = _data["commentCreatorID"];
            this.commentCreatorName = _data["commentCreatorName"];
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : undefined as any;
            this.message = _data["message"];
            this.systemComment = _data["systemComment"];
            if (Array.isArray(_data["existingAttachments"])) {
                this.existingAttachments = [] as any;
                for (let item of _data["existingAttachments"])
                    this.existingAttachments!.push(CommentAttachmentModel.fromJS(item));
            }
            this.userID = _data["userID"];
            this.private = _data["private"];
            this.taskNo = _data["taskNo"];
            this.jobID = _data["jobID"];
            this.userTaskID = _data["userTaskID"];
            this.caseID = _data["caseID"];
            this.isUnread = _data["isUnread"];
        }
    }

    static fromJS(data: any): CommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentID"] = this.commentID;
        data["commentCreatorID"] = this.commentCreatorID;
        data["commentCreatorName"] = this.commentCreatorName;
        data["commentDate"] = this.commentDate?.isValidDate() ? this.commentDate.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["systemComment"] = this.systemComment;
        if (Array.isArray(this.existingAttachments)) {
            data["existingAttachments"] = [];
            for (let item of this.existingAttachments)
                data["existingAttachments"].push(item.toJSON());
        }
        data["userID"] = this.userID;
        data["private"] = this.private;
        data["taskNo"] = this.taskNo;
        data["jobID"] = this.jobID;
        data["userTaskID"] = this.userTaskID;
        data["caseID"] = this.caseID;
        data["isUnread"] = this.isUnread;
        return data;
    }
}

export interface ICommentModel {
    commentID?: number;
    commentCreatorID?: string | undefined;
    commentCreatorName?: string | undefined;
    commentDate?: Date;
    message?: string | undefined;
    systemComment?: boolean;
    existingAttachments?: CommentAttachmentModel[] | undefined;
    userID?: string | undefined;
    private?: boolean;
    taskNo?: number | undefined;
    jobID?: number | undefined;
    userTaskID?: number | undefined;
    caseID?: number | undefined;
    isUnread?: boolean;
}

export class CommentThreadRecipientModel implements ICommentThreadRecipientModel {
    commentThreadRecipientID?: number;
    displayName?: string | undefined;
    isClient?: boolean;

    constructor(data?: ICommentThreadRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentThreadRecipientID = _data["commentThreadRecipientID"];
            this.displayName = _data["displayName"];
            this.isClient = _data["isClient"];
        }
    }

    static fromJS(data: any): CommentThreadRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommentThreadRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentThreadRecipientID"] = this.commentThreadRecipientID;
        data["displayName"] = this.displayName;
        data["isClient"] = this.isClient;
        return data;
    }
}

export interface ICommentThreadRecipientModel {
    commentThreadRecipientID?: number;
    displayName?: string | undefined;
    isClient?: boolean;
}

export class ConnectJobModel implements IConnectJobModel {
    jobID?: number;
    taskSequenceNumber?: number;
    orderID?: string | undefined;
    jobStatusID?: string;
    jobStatus?: string | undefined;
    estimatedArrivalDate?: Date | undefined;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    apportionmentNumber?: number | undefined;
    apportionmentDescription?: string | undefined;
    description?: string | undefined;
    commentThreadID?: string | undefined;
    jobOrOrderID?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;

    constructor(data?: IConnectJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"];
            this.taskSequenceNumber = _data["taskSequenceNumber"];
            this.orderID = _data["orderID"];
            this.jobStatusID = _data["jobStatusID"];
            this.jobStatus = _data["jobStatus"];
            this.estimatedArrivalDate = _data["estimatedArrivalDate"] ? new Date(_data["estimatedArrivalDate"].toString()) : undefined as any;
            this.developmentNumber = _data["developmentNumber"];
            this.developmentName = _data["developmentName"];
            this.apportionmentNumber = _data["apportionmentNumber"];
            this.apportionmentDescription = _data["apportionmentDescription"];
            this.description = _data["description"];
            this.commentThreadID = _data["commentThreadID"];
            this.jobOrOrderID = _data["jobOrOrderID"];
            this.lastReplyDate = _data["lastReplyDate"] ? new Date(_data["lastReplyDate"].toString()) : undefined as any;
            this.hasUnreadComments = _data["hasUnreadComments"];
        }
    }

    static fromJS(data: any): ConnectJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID;
        data["taskSequenceNumber"] = this.taskSequenceNumber;
        data["orderID"] = this.orderID;
        data["jobStatusID"] = this.jobStatusID;
        data["jobStatus"] = this.jobStatus;
        data["estimatedArrivalDate"] = this.estimatedArrivalDate?.isValidDate() ? this.estimatedArrivalDate.toISOString() : <any>undefined;
        data["developmentNumber"] = this.developmentNumber;
        data["developmentName"] = this.developmentName;
        data["apportionmentNumber"] = this.apportionmentNumber;
        data["apportionmentDescription"] = this.apportionmentDescription;
        data["description"] = this.description;
        data["commentThreadID"] = this.commentThreadID;
        data["jobOrOrderID"] = this.jobOrOrderID;
        data["lastReplyDate"] = this.lastReplyDate?.isValidDate() ? this.lastReplyDate.toISOString() : <any>undefined;
        data["hasUnreadComments"] = this.hasUnreadComments;
        return data;
    }
}

export interface IConnectJobModel {
    jobID?: number;
    taskSequenceNumber?: number;
    orderID?: string | undefined;
    jobStatusID?: string;
    jobStatus?: string | undefined;
    estimatedArrivalDate?: Date | undefined;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    apportionmentNumber?: number | undefined;
    apportionmentDescription?: string | undefined;
    description?: string | undefined;
    commentThreadID?: string | undefined;
    jobOrOrderID?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;
}

export class CountryCodeModel implements ICountryCodeModel {
    sortOrder?: number;
    commonName?: string | undefined;
    isO3166_1_2LetterCode?: string | undefined;

    constructor(data?: ICountryCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.commonName = _data["commonName"];
            this.isO3166_1_2LetterCode = _data["isO3166_1_2LetterCode"];
        }
    }

    static fromJS(data: any): CountryCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["commonName"] = this.commonName;
        data["isO3166_1_2LetterCode"] = this.isO3166_1_2LetterCode;
        return data;
    }
}

export interface ICountryCodeModel {
    sortOrder?: number;
    commonName?: string | undefined;
    isO3166_1_2LetterCode?: string | undefined;
}

export class CreatePaymentResponseModel implements ICreatePaymentResponseModel {
    clientPortalPaymentID?: string;
    goCardlessBillingRequestFlowID?: string | undefined;
    goCardlessEnvironment?: string | undefined;
    blinkCreditCardElement?: string | undefined;
    totalPaymentAmount?: number;

    constructor(data?: ICreatePaymentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPortalPaymentID = _data["clientPortalPaymentID"];
            this.goCardlessBillingRequestFlowID = _data["goCardlessBillingRequestFlowID"];
            this.goCardlessEnvironment = _data["goCardlessEnvironment"];
            this.blinkCreditCardElement = _data["blinkCreditCardElement"];
            this.totalPaymentAmount = _data["totalPaymentAmount"];
        }
    }

    static fromJS(data: any): CreatePaymentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPortalPaymentID"] = this.clientPortalPaymentID;
        data["goCardlessBillingRequestFlowID"] = this.goCardlessBillingRequestFlowID;
        data["goCardlessEnvironment"] = this.goCardlessEnvironment;
        data["blinkCreditCardElement"] = this.blinkCreditCardElement;
        data["totalPaymentAmount"] = this.totalPaymentAmount;
        return data;
    }
}

export interface ICreatePaymentResponseModel {
    clientPortalPaymentID?: string;
    goCardlessBillingRequestFlowID?: string | undefined;
    goCardlessEnvironment?: string | undefined;
    blinkCreditCardElement?: string | undefined;
    totalPaymentAmount?: number;
}

export class CreditControlDevelopmentSummaryModel implements ICreditControlDevelopmentSummaryModel {
    developmentID?: string;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    clientAccountNumber?: string | undefined;
    clientAccountName?: string | undefined;
    developmentOutstandingBalance?: number;
    yourOutstandingBalance?: number;

    constructor(data?: ICreditControlDevelopmentSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentID = _data["developmentID"];
            this.developmentNumber = _data["developmentNumber"];
            this.developmentName = _data["developmentName"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.clientAccountName = _data["clientAccountName"];
            this.developmentOutstandingBalance = _data["developmentOutstandingBalance"];
            this.yourOutstandingBalance = _data["yourOutstandingBalance"];
        }
    }

    static fromJS(data: any): CreditControlDevelopmentSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlDevelopmentSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentID"] = this.developmentID;
        data["developmentNumber"] = this.developmentNumber;
        data["developmentName"] = this.developmentName;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["clientAccountName"] = this.clientAccountName;
        data["developmentOutstandingBalance"] = this.developmentOutstandingBalance;
        data["yourOutstandingBalance"] = this.yourOutstandingBalance;
        return data;
    }
}

export interface ICreditControlDevelopmentSummaryModel {
    developmentID?: string;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    clientAccountNumber?: string | undefined;
    clientAccountName?: string | undefined;
    developmentOutstandingBalance?: number;
    yourOutstandingBalance?: number;
}

export class CreditControlStatusModel implements ICreditControlStatusModel {
    developmentName?: string | undefined;
    statusSummaries?: CreditControlStatusSummaryModel[] | undefined;
    accountingBasisType?: AccountingBasisTypes;

    constructor(data?: ICreditControlStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentName = _data["developmentName"];
            if (Array.isArray(_data["statusSummaries"])) {
                this.statusSummaries = [] as any;
                for (let item of _data["statusSummaries"])
                    this.statusSummaries!.push(CreditControlStatusSummaryModel.fromJS(item));
            }
            this.accountingBasisType = _data["accountingBasisType"];
        }
    }

    static fromJS(data: any): CreditControlStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentName"] = this.developmentName;
        if (Array.isArray(this.statusSummaries)) {
            data["statusSummaries"] = [];
            for (let item of this.statusSummaries)
                data["statusSummaries"].push(item.toJSON());
        }
        data["accountingBasisType"] = this.accountingBasisType;
        return data;
    }
}

export interface ICreditControlStatusModel {
    developmentName?: string | undefined;
    statusSummaries?: CreditControlStatusSummaryModel[] | undefined;
    accountingBasisType?: AccountingBasisTypes;
}

export class CreditControlStatusSummaryModel implements ICreditControlStatusSummaryModel {
    statusTypeID?: number;
    statusType?: string | undefined;
    allowed?: boolean;
    showClientDetails?: boolean;
    tooltip?: string | undefined;
    numberOfClients?: number;
    outstandingBalance?: number;

    constructor(data?: ICreditControlStatusSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusTypeID = _data["statusTypeID"];
            this.statusType = _data["statusType"];
            this.allowed = _data["allowed"];
            this.showClientDetails = _data["showClientDetails"];
            this.tooltip = _data["tooltip"];
            this.numberOfClients = _data["numberOfClients"];
            this.outstandingBalance = _data["outstandingBalance"];
        }
    }

    static fromJS(data: any): CreditControlStatusSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlStatusSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusTypeID"] = this.statusTypeID;
        data["statusType"] = this.statusType;
        data["allowed"] = this.allowed;
        data["showClientDetails"] = this.showClientDetails;
        data["tooltip"] = this.tooltip;
        data["numberOfClients"] = this.numberOfClients;
        data["outstandingBalance"] = this.outstandingBalance;
        return data;
    }
}

export interface ICreditControlStatusSummaryModel {
    statusTypeID?: number;
    statusType?: string | undefined;
    allowed?: boolean;
    showClientDetails?: boolean;
    tooltip?: string | undefined;
    numberOfClients?: number;
    outstandingBalance?: number;
}

export class CreditControlUnitBreakdownModel implements ICreditControlUnitBreakdownModel {
    propertyAddress?: string | undefined;
    amount?: number;

    constructor(data?: ICreditControlUnitBreakdownModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyAddress = _data["propertyAddress"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreditControlUnitBreakdownModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlUnitBreakdownModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyAddress"] = this.propertyAddress;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICreditControlUnitBreakdownModel {
    propertyAddress?: string | undefined;
    amount?: number;
}

export class CreditControlUnitModel implements ICreditControlUnitModel {
    developmentName?: string | undefined;
    status?: string | undefined;
    unitBreakdowns?: CreditControlUnitBreakdownModel[] | undefined;

    constructor(data?: ICreditControlUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentName = _data["developmentName"];
            this.status = _data["status"];
            if (Array.isArray(_data["unitBreakdowns"])) {
                this.unitBreakdowns = [] as any;
                for (let item of _data["unitBreakdowns"])
                    this.unitBreakdowns!.push(CreditControlUnitBreakdownModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreditControlUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentName"] = this.developmentName;
        data["status"] = this.status;
        if (Array.isArray(this.unitBreakdowns)) {
            data["unitBreakdowns"] = [];
            for (let item of this.unitBreakdowns)
                data["unitBreakdowns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreditControlUnitModel {
    developmentName?: string | undefined;
    status?: string | undefined;
    unitBreakdowns?: CreditControlUnitBreakdownModel[] | undefined;
}

export enum CustomURISchemeTypes {
    EstimateCreate = "EstimateCreate",
    ProposedWorkCreate = "ProposedWorkCreate",
    JobInstructionCreate = "JobInstructionCreate",
}

export class DailyItineraryItemModel implements IDailyItineraryItemModel {
    type?: DailyItineraryTypes;
    time?: string | undefined;
    title?: string | undefined;
    recordID?: number | undefined;

    constructor(data?: IDailyItineraryItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.time = _data["time"];
            this.title = _data["title"];
            this.recordID = _data["recordID"];
        }
    }

    static fromJS(data: any): DailyItineraryItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new DailyItineraryItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["time"] = this.time;
        data["title"] = this.title;
        data["recordID"] = this.recordID;
        return data;
    }
}

export interface IDailyItineraryItemModel {
    type?: DailyItineraryTypes;
    time?: string | undefined;
    title?: string | undefined;
    recordID?: number | undefined;
}

export enum DailyItineraryTypes {
    Task = "Task",
    Meeting = "Meeting",
    Event = "Event",
}

export enum DataRowVersion {
    Original = "Original",
    Current = "Current",
    Proposed = "Proposed",
    Default = "Default",
}

export enum DbType {
    AnsiString = "AnsiString",
    Binary = "Binary",
    Byte = "Byte",
    Boolean = "Boolean",
    Currency = "Currency",
    Date = "Date",
    DateTime = "DateTime",
    Decimal = "Decimal",
    Double = "Double",
    Guid = "Guid",
    Int16 = "Int16",
    Int32 = "Int32",
    Int64 = "Int64",
    Object = "Object",
    SByte = "SByte",
    Single = "Single",
    String = "String",
    Time = "Time",
    UInt16 = "UInt16",
    UInt32 = "UInt32",
    UInt64 = "UInt64",
    VarNumeric = "VarNumeric",
    AnsiStringFixedLength = "AnsiStringFixedLength",
    StringFixedLength = "StringFixedLength",
    Xml = "Xml",
    DateTime2 = "DateTime2",
    DateTimeOffset = "DateTimeOffset",
}

export class DevelopmentChargesModel implements IDevelopmentChargesModel {
    preListID?: string;
    developmentNumber?: number;
    developmentName?: string | undefined;
    propertyManager?: string | undefined;
    chargeFileIDs?: string[] | undefined;
    fundScheduleID?: number | undefined;
    isGroundRent?: boolean;
    description?: string | undefined;
    total?: number;
    fromDate?: Date;
    toDate?: Date;
    overdueDate?: Date;
    selectedForClientCharges?: boolean;
    hasMultipleBillingPeriods?: boolean;
    hasNegativeAmounts?: boolean;

    constructor(data?: IDevelopmentChargesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preListID = _data["preListID"];
            this.developmentNumber = _data["developmentNumber"];
            this.developmentName = _data["developmentName"];
            this.propertyManager = _data["propertyManager"];
            if (Array.isArray(_data["chargeFileIDs"])) {
                this.chargeFileIDs = [] as any;
                for (let item of _data["chargeFileIDs"])
                    this.chargeFileIDs!.push(item);
            }
            this.fundScheduleID = _data["fundScheduleID"];
            this.isGroundRent = _data["isGroundRent"];
            this.description = _data["description"];
            this.total = _data["total"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.overdueDate = _data["overdueDate"] ? new Date(_data["overdueDate"].toString()) : undefined as any;
            this.selectedForClientCharges = _data["selectedForClientCharges"];
            this.hasMultipleBillingPeriods = _data["hasMultipleBillingPeriods"];
            this.hasNegativeAmounts = _data["hasNegativeAmounts"];
        }
    }

    static fromJS(data: any): DevelopmentChargesModel {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentChargesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preListID"] = this.preListID;
        data["developmentNumber"] = this.developmentNumber;
        data["developmentName"] = this.developmentName;
        data["propertyManager"] = this.propertyManager;
        if (Array.isArray(this.chargeFileIDs)) {
            data["chargeFileIDs"] = [];
            for (let item of this.chargeFileIDs)
                data["chargeFileIDs"].push(item);
        }
        data["fundScheduleID"] = this.fundScheduleID;
        data["isGroundRent"] = this.isGroundRent;
        data["description"] = this.description;
        data["total"] = this.total;
        data["fromDate"] = this.fromDate?.isValidDate() ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate?.isValidDate() ? this.toDate.toISOString() : <any>undefined;
        data["overdueDate"] = this.overdueDate?.isValidDate() ? this.overdueDate.toISOString() : <any>undefined;
        data["selectedForClientCharges"] = this.selectedForClientCharges;
        data["hasMultipleBillingPeriods"] = this.hasMultipleBillingPeriods;
        data["hasNegativeAmounts"] = this.hasNegativeAmounts;
        return data;
    }
}

export interface IDevelopmentChargesModel {
    preListID?: string;
    developmentNumber?: number;
    developmentName?: string | undefined;
    propertyManager?: string | undefined;
    chargeFileIDs?: string[] | undefined;
    fundScheduleID?: number | undefined;
    isGroundRent?: boolean;
    description?: string | undefined;
    total?: number;
    fromDate?: Date;
    toDate?: Date;
    overdueDate?: Date;
    selectedForClientCharges?: boolean;
    hasMultipleBillingPeriods?: boolean;
    hasNegativeAmounts?: boolean;
}

export class DevelopmentContactInfoModel implements IDevelopmentContactInfoModel {
    name?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    profilePictureSrc?: string | undefined;
    developmentRoles?: string | undefined;

    constructor(data?: IDevelopmentContactInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.jobTitle = _data["jobTitle"];
            this.profilePictureSrc = _data["profilePictureSrc"];
            this.developmentRoles = _data["developmentRoles"];
        }
    }

    static fromJS(data: any): DevelopmentContactInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentContactInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["jobTitle"] = this.jobTitle;
        data["profilePictureSrc"] = this.profilePictureSrc;
        data["developmentRoles"] = this.developmentRoles;
        return data;
    }
}

export interface IDevelopmentContactInfoModel {
    name?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    jobTitle?: string | undefined;
    profilePictureSrc?: string | undefined;
    developmentRoles?: string | undefined;
}

export class DevelopmentModel implements IDevelopmentModel {
    developmentID?: string;

    constructor(data?: IDevelopmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentID = _data["developmentID"];
        }
    }

    static fromJS(data: any): DevelopmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DevelopmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentID"] = this.developmentID;
        return data;
    }
}

export interface IDevelopmentModel {
    developmentID?: string;
}

export class DirectDebitCollectionDayModel implements IDirectDebitCollectionDayModel {
    directDebitCollectionDayID?: number;
    dayOfMonth?: number;
    collectionAllowed?: boolean;

    constructor(data?: IDirectDebitCollectionDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directDebitCollectionDayID = _data["directDebitCollectionDayID"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.collectionAllowed = _data["collectionAllowed"];
        }
    }

    static fromJS(data: any): DirectDebitCollectionDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectDebitCollectionDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directDebitCollectionDayID"] = this.directDebitCollectionDayID;
        data["dayOfMonth"] = this.dayOfMonth;
        data["collectionAllowed"] = this.collectionAllowed;
        return data;
    }
}

export interface IDirectDebitCollectionDayModel {
    directDebitCollectionDayID?: number;
    dayOfMonth?: number;
    collectionAllowed?: boolean;
}

export class DirectDebitSetupSuccessModel implements IDirectDebitSetupSuccessModel {
    authorisationURL?: string | undefined;

    constructor(data?: IDirectDebitSetupSuccessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorisationURL = _data["authorisationURL"];
        }
    }

    static fromJS(data: any): DirectDebitSetupSuccessModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectDebitSetupSuccessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorisationURL"] = this.authorisationURL;
        return data;
    }
}

export interface IDirectDebitSetupSuccessModel {
    authorisationURL?: string | undefined;
}

export class DirectorModel implements IDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    directorID?: string;
    accountNumber?: string | undefined;
    address?: AddressModel;
    deleted?: boolean;
    linkedDevelopments?: LinkedDevelopmentModel[] | undefined;
    linkedLegalEntities?: LinkedLegalEntityModel[] | undefined;

    constructor(data?: IDirectorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.directorID = _data["directorID"];
            this.accountNumber = _data["accountNumber"];
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : undefined as any;
            this.deleted = _data["deleted"];
            if (Array.isArray(_data["linkedDevelopments"])) {
                this.linkedDevelopments = [] as any;
                for (let item of _data["linkedDevelopments"])
                    this.linkedDevelopments!.push(LinkedDevelopmentModel.fromJS(item));
            }
            if (Array.isArray(_data["linkedLegalEntities"])) {
                this.linkedLegalEntities = [] as any;
                for (let item of _data["linkedLegalEntities"])
                    this.linkedLegalEntities!.push(LinkedLegalEntityModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DirectorModel {
        data = typeof data === 'object' ? data : {};
        let result = new DirectorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["directorID"] = this.directorID;
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["deleted"] = this.deleted;
        if (Array.isArray(this.linkedDevelopments)) {
            data["linkedDevelopments"] = [];
            for (let item of this.linkedDevelopments)
                data["linkedDevelopments"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedLegalEntities)) {
            data["linkedLegalEntities"] = [];
            for (let item of this.linkedLegalEntities)
                data["linkedLegalEntities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    directorID?: string;
    accountNumber?: string | undefined;
    address?: AddressModel;
    deleted?: boolean;
    linkedDevelopments?: LinkedDevelopmentModel[] | undefined;
    linkedLegalEntities?: LinkedLegalEntityModel[] | undefined;
}

export class DocumentAttachmentModel implements IDocumentAttachmentModel {
    documentID?: string;
    subject?: string | undefined;
    attachmentID?: number;
    filePath?: string | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IDocumentAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.subject = _data["subject"];
            this.attachmentID = _data["attachmentID"];
            this.filePath = _data["filePath"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentAttachmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAttachmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["subject"] = this.subject;
        data["attachmentID"] = this.attachmentID;
        data["filePath"] = this.filePath;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDocumentAttachmentModel {
    documentID?: string;
    subject?: string | undefined;
    attachmentID?: number;
    filePath?: string | undefined;
    createdDate?: Date | undefined;
}

export class DocumentSubTypeModel implements IDocumentSubTypeModel {
    documentSubTypeID?: number;
    name?: string | undefined;
    documentTypeID?: number;
    systemRequired?: boolean;

    constructor(data?: IDocumentSubTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSubTypeID = _data["documentSubTypeID"];
            this.name = _data["name"];
            this.documentTypeID = _data["documentTypeID"];
            this.systemRequired = _data["systemRequired"];
        }
    }

    static fromJS(data: any): DocumentSubTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSubTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSubTypeID"] = this.documentSubTypeID;
        data["name"] = this.name;
        data["documentTypeID"] = this.documentTypeID;
        data["systemRequired"] = this.systemRequired;
        return data;
    }
}

export interface IDocumentSubTypeModel {
    documentSubTypeID?: number;
    name?: string | undefined;
    documentTypeID?: number;
    systemRequired?: boolean;
}

export class DocumentTypeModel implements IDocumentTypeModel {
    documentTypeID?: number;
    name?: string | undefined;
    hidden?: boolean;

    constructor(data?: IDocumentTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeID = _data["documentTypeID"];
            this.name = _data["name"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any): DocumentTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeID"] = this.documentTypeID;
        data["name"] = this.name;
        data["hidden"] = this.hidden;
        return data;
    }
}

export interface IDocumentTypeModel {
    documentTypeID?: number;
    name?: string | undefined;
    hidden?: boolean;
}

export class EstimateFiltersModel implements IEstimateFiltersModel {
    includeArchived?: boolean;

    constructor(data?: IEstimateFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): EstimateFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        return data;
    }
}

export interface IEstimateFiltersModel {
    includeArchived?: boolean;
}

export class EstimateModel implements IEstimateModel {
    estimateID?: string;
    referenceNumber?: number;
    statusID?: number;
    status?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    commentThreadID?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;

    constructor(data?: IEstimateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateID = _data["estimateID"];
            this.referenceNumber = _data["referenceNumber"];
            this.statusID = _data["statusID"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.developmentNumber = _data["developmentNumber"];
            this.developmentName = _data["developmentName"];
            this.commentThreadID = _data["commentThreadID"];
            this.lastReplyDate = _data["lastReplyDate"] ? new Date(_data["lastReplyDate"].toString()) : undefined as any;
            this.hasUnreadComments = _data["hasUnreadComments"];
        }
    }

    static fromJS(data: any): EstimateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EstimateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateID"] = this.estimateID;
        data["referenceNumber"] = this.referenceNumber;
        data["statusID"] = this.statusID;
        data["status"] = this.status;
        data["description"] = this.description;
        data["name"] = this.name;
        data["developmentNumber"] = this.developmentNumber;
        data["developmentName"] = this.developmentName;
        data["commentThreadID"] = this.commentThreadID;
        data["lastReplyDate"] = this.lastReplyDate?.isValidDate() ? this.lastReplyDate.toISOString() : <any>undefined;
        data["hasUnreadComments"] = this.hasUnreadComments;
        return data;
    }
}

export interface IEstimateModel {
    estimateID?: string;
    referenceNumber?: number;
    statusID?: number;
    status?: string | undefined;
    description?: string | undefined;
    name?: string | undefined;
    developmentNumber?: string | undefined;
    developmentName?: string | undefined;
    commentThreadID?: string | undefined;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;
}

export class Event implements IEvent {
    action?: string | undefined;
    createdAt?: Date | undefined;
    customerNotifications?: EventCustomerNotification[] | undefined;
    details?: EventDetails;
    id?: string | undefined;
    links?: EventLinks;
    metadata?: { [key: string]: string; } | undefined;
    resourceMetadata?: { [key: string]: string; } | undefined;
    resourceType?: EventResourceType;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (Array.isArray(_data["customerNotifications"])) {
                this.customerNotifications = [] as any;
                for (let item of _data["customerNotifications"])
                    this.customerNotifications!.push(EventCustomerNotification.fromJS(item));
            }
            this.details = _data["details"] ? EventDetails.fromJS(_data["details"]) : undefined as any;
            this.id = _data["id"];
            this.links = _data["links"] ? EventLinks.fromJS(_data["links"]) : undefined as any;
            if (_data["metadata"]) {
                this.metadata = {} as any;
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        (this.metadata as any)![key] = _data["metadata"][key];
                }
            }
            if (_data["resourceMetadata"]) {
                this.resourceMetadata = {} as any;
                for (let key in _data["resourceMetadata"]) {
                    if (_data["resourceMetadata"].hasOwnProperty(key))
                        (this.resourceMetadata as any)![key] = _data["resourceMetadata"][key];
                }
            }
            this.resourceType = _data["resourceType"];
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action;
        data["createdAt"] = this.createdAt?.isValidDate() ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.customerNotifications)) {
            data["customerNotifications"] = [];
            for (let item of this.customerNotifications)
                data["customerNotifications"].push(item.toJSON());
        }
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["links"] = this.links ? this.links.toJSON() : <any>undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (<any>data["metadata"])[key] = (<any>this.metadata)[key];
            }
        }
        if (this.resourceMetadata) {
            data["resourceMetadata"] = {};
            for (let key in this.resourceMetadata) {
                if (this.resourceMetadata.hasOwnProperty(key))
                    (<any>data["resourceMetadata"])[key] = (<any>this.resourceMetadata)[key];
            }
        }
        data["resourceType"] = this.resourceType;
        return data;
    }
}

export interface IEvent {
    action?: string | undefined;
    createdAt?: Date | undefined;
    customerNotifications?: EventCustomerNotification[] | undefined;
    details?: EventDetails;
    id?: string | undefined;
    links?: EventLinks;
    metadata?: { [key: string]: string; } | undefined;
    resourceMetadata?: { [key: string]: string; } | undefined;
    resourceType?: EventResourceType;
}

export class EventCustomerNotification implements IEventCustomerNotification {
    deadline?: string | undefined;
    id?: string | undefined;
    mandatory?: boolean | undefined;
    type?: string | undefined;

    constructor(data?: IEventCustomerNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deadline = _data["deadline"];
            this.id = _data["id"];
            this.mandatory = _data["mandatory"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EventCustomerNotification {
        data = typeof data === 'object' ? data : {};
        let result = new EventCustomerNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deadline"] = this.deadline;
        data["id"] = this.id;
        data["mandatory"] = this.mandatory;
        data["type"] = this.type;
        return data;
    }
}

export interface IEventCustomerNotification {
    deadline?: string | undefined;
    id?: string | undefined;
    mandatory?: boolean | undefined;
    type?: string | undefined;
}

export class EventDetails implements IEventDetails {
    bankAccountId?: string | undefined;
    cause?: string | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    notRetriedReason?: string | undefined;
    origin?: EventDetailsOrigin;
    property?: string | undefined;
    reasonCode?: string | undefined;
    scheme?: EventDetailsScheme;
    willAttemptRetry?: boolean | undefined;

    constructor(data?: IEventDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccountId = _data["bankAccountId"];
            this.cause = _data["cause"];
            this.currency = _data["currency"];
            this.description = _data["description"];
            this.notRetriedReason = _data["notRetriedReason"];
            this.origin = _data["origin"];
            this.property = _data["property"];
            this.reasonCode = _data["reasonCode"];
            this.scheme = _data["scheme"];
            this.willAttemptRetry = _data["willAttemptRetry"];
        }
    }

    static fromJS(data: any): EventDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EventDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccountId"] = this.bankAccountId;
        data["cause"] = this.cause;
        data["currency"] = this.currency;
        data["description"] = this.description;
        data["notRetriedReason"] = this.notRetriedReason;
        data["origin"] = this.origin;
        data["property"] = this.property;
        data["reasonCode"] = this.reasonCode;
        data["scheme"] = this.scheme;
        data["willAttemptRetry"] = this.willAttemptRetry;
        return data;
    }
}

export interface IEventDetails {
    bankAccountId?: string | undefined;
    cause?: string | undefined;
    currency?: string | undefined;
    description?: string | undefined;
    notRetriedReason?: string | undefined;
    origin?: EventDetailsOrigin;
    property?: string | undefined;
    reasonCode?: string | undefined;
    scheme?: EventDetailsScheme;
    willAttemptRetry?: boolean | undefined;
}

export enum EventDetailsOrigin {
    Unknown = "Unknown",
    Bank = "Bank",
    Api = "Api",
    Gocardless = "Gocardless",
    Customer = "Customer",
    Payer = "Payer",
}

export enum EventDetailsScheme {
    Unknown = "Unknown",
    Ach = "Ach",
    Autogiro = "Autogiro",
    Bacs = "Bacs",
    Becs = "Becs",
    BecsNz = "BecsNz",
    Betalingsservice = "Betalingsservice",
    FasterPayments = "FasterPayments",
    Pad = "Pad",
    PayTo = "PayTo",
    SepaCore = "SepaCore",
    SepaCor1 = "SepaCor1",
}

export class EventLinks implements IEventLinks {
    bankAuthorisation?: string | undefined;
    billingRequest?: string | undefined;
    billingRequestFlow?: string | undefined;
    creditor?: string | undefined;
    customer?: string | undefined;
    customerBankAccount?: string | undefined;
    instalmentSchedule?: string | undefined;
    mandate?: string | undefined;
    mandateRequestMandate?: string | undefined;
    newCustomerBankAccount?: string | undefined;
    newMandate?: string | undefined;
    organisation?: string | undefined;
    parentEvent?: string | undefined;
    payerAuthorisation?: string | undefined;
    payment?: string | undefined;
    paymentRequestPayment?: string | undefined;
    payout?: string | undefined;
    previousCustomerBankAccount?: string | undefined;
    refund?: string | undefined;
    schemeIdentifier?: string | undefined;
    subscription?: string | undefined;

    constructor(data?: IEventLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAuthorisation = _data["bankAuthorisation"];
            this.billingRequest = _data["billingRequest"];
            this.billingRequestFlow = _data["billingRequestFlow"];
            this.creditor = _data["creditor"];
            this.customer = _data["customer"];
            this.customerBankAccount = _data["customerBankAccount"];
            this.instalmentSchedule = _data["instalmentSchedule"];
            this.mandate = _data["mandate"];
            this.mandateRequestMandate = _data["mandateRequestMandate"];
            this.newCustomerBankAccount = _data["newCustomerBankAccount"];
            this.newMandate = _data["newMandate"];
            this.organisation = _data["organisation"];
            this.parentEvent = _data["parentEvent"];
            this.payerAuthorisation = _data["payerAuthorisation"];
            this.payment = _data["payment"];
            this.paymentRequestPayment = _data["paymentRequestPayment"];
            this.payout = _data["payout"];
            this.previousCustomerBankAccount = _data["previousCustomerBankAccount"];
            this.refund = _data["refund"];
            this.schemeIdentifier = _data["schemeIdentifier"];
            this.subscription = _data["subscription"];
        }
    }

    static fromJS(data: any): EventLinks {
        data = typeof data === 'object' ? data : {};
        let result = new EventLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAuthorisation"] = this.bankAuthorisation;
        data["billingRequest"] = this.billingRequest;
        data["billingRequestFlow"] = this.billingRequestFlow;
        data["creditor"] = this.creditor;
        data["customer"] = this.customer;
        data["customerBankAccount"] = this.customerBankAccount;
        data["instalmentSchedule"] = this.instalmentSchedule;
        data["mandate"] = this.mandate;
        data["mandateRequestMandate"] = this.mandateRequestMandate;
        data["newCustomerBankAccount"] = this.newCustomerBankAccount;
        data["newMandate"] = this.newMandate;
        data["organisation"] = this.organisation;
        data["parentEvent"] = this.parentEvent;
        data["payerAuthorisation"] = this.payerAuthorisation;
        data["payment"] = this.payment;
        data["paymentRequestPayment"] = this.paymentRequestPayment;
        data["payout"] = this.payout;
        data["previousCustomerBankAccount"] = this.previousCustomerBankAccount;
        data["refund"] = this.refund;
        data["schemeIdentifier"] = this.schemeIdentifier;
        data["subscription"] = this.subscription;
        return data;
    }
}

export interface IEventLinks {
    bankAuthorisation?: string | undefined;
    billingRequest?: string | undefined;
    billingRequestFlow?: string | undefined;
    creditor?: string | undefined;
    customer?: string | undefined;
    customerBankAccount?: string | undefined;
    instalmentSchedule?: string | undefined;
    mandate?: string | undefined;
    mandateRequestMandate?: string | undefined;
    newCustomerBankAccount?: string | undefined;
    newMandate?: string | undefined;
    organisation?: string | undefined;
    parentEvent?: string | undefined;
    payerAuthorisation?: string | undefined;
    payment?: string | undefined;
    paymentRequestPayment?: string | undefined;
    payout?: string | undefined;
    previousCustomerBankAccount?: string | undefined;
    refund?: string | undefined;
    schemeIdentifier?: string | undefined;
    subscription?: string | undefined;
}

export enum EventResourceType {
    Unknown = "Unknown",
    BillingRequests = "BillingRequests",
    Creditors = "Creditors",
    InstalmentSchedules = "InstalmentSchedules",
    Mandates = "Mandates",
    Organisations = "Organisations",
    PayerAuthorisations = "PayerAuthorisations",
    Payments = "Payments",
    Payouts = "Payouts",
    Refunds = "Refunds",
    SchemeIdentifiers = "SchemeIdentifiers",
    Subscriptions = "Subscriptions",
}

export class ExpenditureItem implements IExpenditureItem {
    expenditureHeading?: string | undefined;
    grossAnticipatedExpenditure?: number;
    apportionment?: string | undefined;
    net?: number;
    vat?: number;
    apportionmentNumerator?: number;
    apportionmentDenominator?: number;
    grossAnticipatedShareDue?: number;

    constructor(data?: IExpenditureItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenditureHeading = _data["expenditureHeading"];
            this.grossAnticipatedExpenditure = _data["grossAnticipatedExpenditure"];
            this.apportionment = _data["apportionment"];
            this.net = _data["net"];
            this.vat = _data["vat"];
            this.apportionmentNumerator = _data["apportionmentNumerator"];
            this.apportionmentDenominator = _data["apportionmentDenominator"];
            this.grossAnticipatedShareDue = _data["grossAnticipatedShareDue"];
        }
    }

    static fromJS(data: any): ExpenditureItem {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenditureItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenditureHeading"] = this.expenditureHeading;
        data["grossAnticipatedExpenditure"] = this.grossAnticipatedExpenditure;
        data["apportionment"] = this.apportionment;
        data["net"] = this.net;
        data["vat"] = this.vat;
        data["apportionmentNumerator"] = this.apportionmentNumerator;
        data["apportionmentDenominator"] = this.apportionmentDenominator;
        data["grossAnticipatedShareDue"] = this.grossAnticipatedShareDue;
        return data;
    }
}

export interface IExpenditureItem {
    expenditureHeading?: string | undefined;
    grossAnticipatedExpenditure?: number;
    apportionment?: string | undefined;
    net?: number;
    vat?: number;
    apportionmentNumerator?: number;
    apportionmentDenominator?: number;
    grossAnticipatedShareDue?: number;
}

export class ExtractedInvoiceModel implements IExtractedInvoiceModel {
    description?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceDueDate?: string | undefined;
    invoiceNumber?: string | undefined;
    totalAmount?: number | undefined;
    goodsAmount?: number | undefined;
    vatAmount?: number | undefined;
    orderNumber?: string | undefined;
    purchaseLedgerData?: PLAccountMatchFields;

    constructor(data?: IExtractedInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.invoiceDate = _data["invoiceDate"];
            this.invoiceDueDate = _data["invoiceDueDate"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalAmount = _data["totalAmount"];
            this.goodsAmount = _data["goodsAmount"];
            this.vatAmount = _data["vatAmount"];
            this.orderNumber = _data["orderNumber"];
            this.purchaseLedgerData = _data["purchaseLedgerData"] ? PLAccountMatchFields.fromJS(_data["purchaseLedgerData"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExtractedInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractedInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["invoiceDate"] = this.invoiceDate;
        data["invoiceDueDate"] = this.invoiceDueDate;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalAmount"] = this.totalAmount;
        data["goodsAmount"] = this.goodsAmount;
        data["vatAmount"] = this.vatAmount;
        data["orderNumber"] = this.orderNumber;
        data["purchaseLedgerData"] = this.purchaseLedgerData ? this.purchaseLedgerData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtractedInvoiceModel {
    description?: string | undefined;
    invoiceDate?: string | undefined;
    invoiceDueDate?: string | undefined;
    invoiceNumber?: string | undefined;
    totalAmount?: number | undefined;
    goodsAmount?: number | undefined;
    vatAmount?: number | undefined;
    orderNumber?: string | undefined;
    purchaseLedgerData?: PLAccountMatchFields;
}

export enum FeedbackReason {
    WrongData = "WrongData",
    MisunderstoodQuestion = "MisunderstoodQuestion",
    IncompleteAnswer = "IncompleteAnswer",
    NoAnswer = "NoAnswer",
    TooSlow = "TooSlow",
    Other = "Other",
}

export class FreeholderCommissionRateTypeModel implements IFreeholderCommissionRateTypeModel {
    freeholderCommissionRateTypeID?: number;
    name?: string | undefined;

    constructor(data?: IFreeholderCommissionRateTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freeholderCommissionRateTypeID = _data["freeholderCommissionRateTypeID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FreeholderCommissionRateTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreeholderCommissionRateTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freeholderCommissionRateTypeID"] = this.freeholderCommissionRateTypeID;
        data["name"] = this.name;
        return data;
    }
}

export interface IFreeholderCommissionRateTypeModel {
    freeholderCommissionRateTypeID?: number;
    name?: string | undefined;
}

export class FreeholderPaymentPrelistFilterModel implements IFreeholderPaymentPrelistFilterModel {
    chargeDateCodeID?: string;
    runToDate?: Date;
    fromDevelopmentNo?: number;
    toDevelopmentNo?: number;
    fromPropertyNo?: number;
    toPropertyNo?: number;
    propertyManagerID?: string;

    constructor(data?: IFreeholderPaymentPrelistFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeDateCodeID = _data["chargeDateCodeID"];
            this.runToDate = _data["runToDate"] ? new Date(_data["runToDate"].toString()) : undefined as any;
            this.fromDevelopmentNo = _data["fromDevelopmentNo"];
            this.toDevelopmentNo = _data["toDevelopmentNo"];
            this.fromPropertyNo = _data["fromPropertyNo"];
            this.toPropertyNo = _data["toPropertyNo"];
            this.propertyManagerID = _data["propertyManagerID"];
        }
    }

    static fromJS(data: any): FreeholderPaymentPrelistFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreeholderPaymentPrelistFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeDateCodeID"] = this.chargeDateCodeID;
        data["runToDate"] = this.runToDate?.isValidDate() ? this.runToDate.toISOString() : <any>undefined;
        data["fromDevelopmentNo"] = this.fromDevelopmentNo;
        data["toDevelopmentNo"] = this.toDevelopmentNo;
        data["fromPropertyNo"] = this.fromPropertyNo;
        data["toPropertyNo"] = this.toPropertyNo;
        data["propertyManagerID"] = this.propertyManagerID;
        return data;
    }
}

export interface IFreeholderPaymentPrelistFilterModel {
    chargeDateCodeID?: string;
    runToDate?: Date;
    fromDevelopmentNo?: number;
    toDevelopmentNo?: number;
    fromPropertyNo?: number;
    toPropertyNo?: number;
    propertyManagerID?: string;
}

export class FreeholderPaymentPrelistModel implements IFreeholderPaymentPrelistModel {
    debitFreeholderTransactionID?: string;
    freeholderName?: string | undefined;
    freeholderID?: string;
    fundScheduleDescription?: string | undefined;
    fundScheduleID?: number;
    fundScheduleBankNominalCodeID?: string;
    developmentName?: string | undefined;
    developmentID?: string;
    developmentBankNominalCodeID?: string;
    amount?: number;
    commissionAmount?: number;
    batchNo?: number;

    constructor(data?: IFreeholderPaymentPrelistModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.debitFreeholderTransactionID = _data["debitFreeholderTransactionID"];
            this.freeholderName = _data["freeholderName"];
            this.freeholderID = _data["freeholderID"];
            this.fundScheduleDescription = _data["fundScheduleDescription"];
            this.fundScheduleID = _data["fundScheduleID"];
            this.fundScheduleBankNominalCodeID = _data["fundScheduleBankNominalCodeID"];
            this.developmentName = _data["developmentName"];
            this.developmentID = _data["developmentID"];
            this.developmentBankNominalCodeID = _data["developmentBankNominalCodeID"];
            this.amount = _data["amount"];
            this.commissionAmount = _data["commissionAmount"];
            this.batchNo = _data["batchNo"];
        }
    }

    static fromJS(data: any): FreeholderPaymentPrelistModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreeholderPaymentPrelistModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["debitFreeholderTransactionID"] = this.debitFreeholderTransactionID;
        data["freeholderName"] = this.freeholderName;
        data["freeholderID"] = this.freeholderID;
        data["fundScheduleDescription"] = this.fundScheduleDescription;
        data["fundScheduleID"] = this.fundScheduleID;
        data["fundScheduleBankNominalCodeID"] = this.fundScheduleBankNominalCodeID;
        data["developmentName"] = this.developmentName;
        data["developmentID"] = this.developmentID;
        data["developmentBankNominalCodeID"] = this.developmentBankNominalCodeID;
        data["amount"] = this.amount;
        data["commissionAmount"] = this.commissionAmount;
        data["batchNo"] = this.batchNo;
        return data;
    }
}

export interface IFreeholderPaymentPrelistModel {
    debitFreeholderTransactionID?: string;
    freeholderName?: string | undefined;
    freeholderID?: string;
    fundScheduleDescription?: string | undefined;
    fundScheduleID?: number;
    fundScheduleBankNominalCodeID?: string;
    developmentName?: string | undefined;
    developmentID?: string;
    developmentBankNominalCodeID?: string;
    amount?: number;
    commissionAmount?: number;
    batchNo?: number;
}

export class FreeholderStatementSelectionModel implements IFreeholderStatementSelectionModel {
    paymentBatchNo?: number;
    fromDate?: Date;
    toDate?: Date;
    forEmail?: boolean;

    constructor(data?: IFreeholderStatementSelectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentBatchNo = _data["paymentBatchNo"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.forEmail = _data["forEmail"];
        }
    }

    static fromJS(data: any): FreeholderStatementSelectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new FreeholderStatementSelectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentBatchNo"] = this.paymentBatchNo;
        data["fromDate"] = this.fromDate?.isValidDate() ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate?.isValidDate() ? this.toDate.toISOString() : <any>undefined;
        data["forEmail"] = this.forEmail;
        return data;
    }
}

export interface IFreeholderStatementSelectionModel {
    paymentBatchNo?: number;
    fromDate?: Date;
    toDate?: Date;
    forEmail?: boolean;
}

export enum FundScheduleChargeCategories {
    NoEntity = "NoEntity",
    ServiceCharge = "ServiceCharge",
    FreeHolderCharge = "FreeHolderCharge",
    Recharge = "Recharge",
}

export class FundScheduleChargeTypeModel implements IFundScheduleChargeTypeModel {
    fundScheduleChargeTypeID?: number;
    name?: string | undefined;

    constructor(data?: IFundScheduleChargeTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundScheduleChargeTypeID = _data["fundScheduleChargeTypeID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FundScheduleChargeTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new FundScheduleChargeTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundScheduleChargeTypeID"] = this.fundScheduleChargeTypeID;
        data["name"] = this.name;
        return data;
    }
}

export interface IFundScheduleChargeTypeModel {
    fundScheduleChargeTypeID?: number;
    name?: string | undefined;
}

export class FundScheduleProcessedModel implements IFundScheduleProcessedModel {
    fundScheduleID?: number;
    toDate?: Date;

    constructor(data?: IFundScheduleProcessedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundScheduleID = _data["fundScheduleID"];
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FundScheduleProcessedModel {
        data = typeof data === 'object' ? data : {};
        let result = new FundScheduleProcessedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundScheduleID"] = this.fundScheduleID;
        data["toDate"] = this.toDate?.isValidDate() ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFundScheduleProcessedModel {
    fundScheduleID?: number;
    toDate?: Date;
}

export class GlobalClientPortalSettingsModel implements IGlobalClientPortalSettingsModel {
    showJobs?: boolean;
    showCases?: boolean;
    showProposedWorks?: boolean;
    showDocuments?: boolean;
    showCreditControl?: boolean;
    showMeetings?: boolean;
    showDevelopmentInfo?: boolean;
    showDevelopmentNews?: boolean;
    showPayments?: boolean;
    showRaiseCasesButton?: boolean;
    showProposedWorkVoting?: boolean;
    showDirectDebitSetup?: boolean;
    showBudgets?: boolean;
    showEmailAddressEdit?: boolean;
    getInTouchLink?: string | undefined;
    showJobTimeline?: boolean;
    customPayNowLink?: string | undefined;
    jobsAndEstimatesVisibility?: number | undefined;
    majorWorksVisibility?: number | undefined;
    allowOverpayments?: boolean;

    constructor(data?: IGlobalClientPortalSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.showJobs = _data["showJobs"];
            this.showCases = _data["showCases"];
            this.showProposedWorks = _data["showProposedWorks"];
            this.showDocuments = _data["showDocuments"];
            this.showCreditControl = _data["showCreditControl"];
            this.showMeetings = _data["showMeetings"];
            this.showDevelopmentInfo = _data["showDevelopmentInfo"];
            this.showDevelopmentNews = _data["showDevelopmentNews"];
            this.showPayments = _data["showPayments"];
            this.showRaiseCasesButton = _data["showRaiseCasesButton"];
            this.showProposedWorkVoting = _data["showProposedWorkVoting"];
            this.showDirectDebitSetup = _data["showDirectDebitSetup"];
            this.showBudgets = _data["showBudgets"];
            this.showEmailAddressEdit = _data["showEmailAddressEdit"];
            this.getInTouchLink = _data["getInTouchLink"];
            this.showJobTimeline = _data["showJobTimeline"];
            this.customPayNowLink = _data["customPayNowLink"];
            this.jobsAndEstimatesVisibility = _data["jobsAndEstimatesVisibility"];
            this.majorWorksVisibility = _data["majorWorksVisibility"];
            this.allowOverpayments = _data["allowOverpayments"];
        }
    }

    static fromJS(data: any): GlobalClientPortalSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalClientPortalSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showJobs"] = this.showJobs;
        data["showCases"] = this.showCases;
        data["showProposedWorks"] = this.showProposedWorks;
        data["showDocuments"] = this.showDocuments;
        data["showCreditControl"] = this.showCreditControl;
        data["showMeetings"] = this.showMeetings;
        data["showDevelopmentInfo"] = this.showDevelopmentInfo;
        data["showDevelopmentNews"] = this.showDevelopmentNews;
        data["showPayments"] = this.showPayments;
        data["showRaiseCasesButton"] = this.showRaiseCasesButton;
        data["showProposedWorkVoting"] = this.showProposedWorkVoting;
        data["showDirectDebitSetup"] = this.showDirectDebitSetup;
        data["showBudgets"] = this.showBudgets;
        data["showEmailAddressEdit"] = this.showEmailAddressEdit;
        data["getInTouchLink"] = this.getInTouchLink;
        data["showJobTimeline"] = this.showJobTimeline;
        data["customPayNowLink"] = this.customPayNowLink;
        data["jobsAndEstimatesVisibility"] = this.jobsAndEstimatesVisibility;
        data["majorWorksVisibility"] = this.majorWorksVisibility;
        data["allowOverpayments"] = this.allowOverpayments;
        return data;
    }
}

export interface IGlobalClientPortalSettingsModel {
    showJobs?: boolean;
    showCases?: boolean;
    showProposedWorks?: boolean;
    showDocuments?: boolean;
    showCreditControl?: boolean;
    showMeetings?: boolean;
    showDevelopmentInfo?: boolean;
    showDevelopmentNews?: boolean;
    showPayments?: boolean;
    showRaiseCasesButton?: boolean;
    showProposedWorkVoting?: boolean;
    showDirectDebitSetup?: boolean;
    showBudgets?: boolean;
    showEmailAddressEdit?: boolean;
    getInTouchLink?: string | undefined;
    showJobTimeline?: boolean;
    customPayNowLink?: string | undefined;
    jobsAndEstimatesVisibility?: number | undefined;
    majorWorksVisibility?: number | undefined;
    allowOverpayments?: boolean;
}

export class GoCardlessAccessToken implements IGoCardlessAccessToken {
    access_token?: string | undefined;
    scope?: string | undefined;
    token_type?: string | undefined;
    organisation_id?: string | undefined;
    email?: string | undefined;
    active?: boolean;

    constructor(data?: IGoCardlessAccessToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.scope = _data["scope"];
            this.token_type = _data["token_type"];
            this.organisation_id = _data["organisation_id"];
            this.email = _data["email"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): GoCardlessAccessToken {
        data = typeof data === 'object' ? data : {};
        let result = new GoCardlessAccessToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["scope"] = this.scope;
        data["token_type"] = this.token_type;
        data["organisation_id"] = this.organisation_id;
        data["email"] = this.email;
        data["active"] = this.active;
        return data;
    }
}

export interface IGoCardlessAccessToken {
    access_token?: string | undefined;
    scope?: string | undefined;
    token_type?: string | undefined;
    organisation_id?: string | undefined;
    email?: string | undefined;
    active?: boolean;
}

export class GoCardlessSettingsModel implements IGoCardlessSettingsModel {
    emailAddress?: string | undefined;
    paymentDescription?: string | undefined;

    constructor(data?: IGoCardlessSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.paymentDescription = _data["paymentDescription"];
        }
    }

    static fromJS(data: any): GoCardlessSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoCardlessSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["paymentDescription"] = this.paymentDescription;
        return data;
    }
}

export interface IGoCardlessSettingsModel {
    emailAddress?: string | undefined;
    paymentDescription?: string | undefined;
}

export class GuidSelectModel implements IGuidSelectModel {
    value?: string;
    label?: string | undefined;

    constructor(data?: IGuidSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): GuidSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuidSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IGuidSelectModel {
    value?: string;
    label?: string | undefined;
}

export class ImageUploadResultModel implements IImageUploadResultModel {
    documentID?: number;
    savePath?: string | undefined;

    constructor(data?: IImageUploadResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.savePath = _data["savePath"];
        }
    }

    static fromJS(data: any): ImageUploadResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageUploadResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["savePath"] = this.savePath;
        return data;
    }
}

export interface IImageUploadResultModel {
    documentID?: number;
    savePath?: string | undefined;
}

export enum ImportStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Complete = "Complete",
    Failed = "Failed",
}

export class IntSelectModel implements IIntSelectModel {
    value?: number;
    label?: string | undefined;

    constructor(data?: IIntSelectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): IntSelectModel {
        data = typeof data === 'object' ? data : {};
        let result = new IntSelectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IIntSelectModel {
    value?: number;
    label?: string | undefined;
}

export class JobFiltersModel implements IJobFiltersModel {
    includeArchived?: boolean;

    constructor(data?: IJobFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeArchived = _data["includeArchived"];
        }
    }

    static fromJS(data: any): JobFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeArchived"] = this.includeArchived;
        return data;
    }
}

export interface IJobFiltersModel {
    includeArchived?: boolean;
}

export class JobTimelineModel implements IJobTimelineModel {
    published?: JobTimelineStep;
    bidsEvaluated?: JobTimelineStep;
    contractAwarded?: JobTimelineStep;
    deliveryDateAgreed?: JobTimelineStep;
    contractorOnSite?: JobTimelineStep;
    workCompleted?: JobTimelineStep;

    constructor(data?: IJobTimelineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.published = _data["published"] ? JobTimelineStep.fromJS(_data["published"]) : undefined as any;
            this.bidsEvaluated = _data["bidsEvaluated"] ? JobTimelineStep.fromJS(_data["bidsEvaluated"]) : undefined as any;
            this.contractAwarded = _data["contractAwarded"] ? JobTimelineStep.fromJS(_data["contractAwarded"]) : undefined as any;
            this.deliveryDateAgreed = _data["deliveryDateAgreed"] ? JobTimelineStep.fromJS(_data["deliveryDateAgreed"]) : undefined as any;
            this.contractorOnSite = _data["contractorOnSite"] ? JobTimelineStep.fromJS(_data["contractorOnSite"]) : undefined as any;
            this.workCompleted = _data["workCompleted"] ? JobTimelineStep.fromJS(_data["workCompleted"]) : undefined as any;
        }
    }

    static fromJS(data: any): JobTimelineModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobTimelineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["published"] = this.published ? this.published.toJSON() : <any>undefined;
        data["bidsEvaluated"] = this.bidsEvaluated ? this.bidsEvaluated.toJSON() : <any>undefined;
        data["contractAwarded"] = this.contractAwarded ? this.contractAwarded.toJSON() : <any>undefined;
        data["deliveryDateAgreed"] = this.deliveryDateAgreed ? this.deliveryDateAgreed.toJSON() : <any>undefined;
        data["contractorOnSite"] = this.contractorOnSite ? this.contractorOnSite.toJSON() : <any>undefined;
        data["workCompleted"] = this.workCompleted ? this.workCompleted.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobTimelineModel {
    published?: JobTimelineStep;
    bidsEvaluated?: JobTimelineStep;
    contractAwarded?: JobTimelineStep;
    deliveryDateAgreed?: JobTimelineStep;
    contractorOnSite?: JobTimelineStep;
    workCompleted?: JobTimelineStep;
}

export class JobTimelineStep implements IJobTimelineStep {
    checked?: boolean;
    date?: Date | undefined;

    constructor(data?: IJobTimelineStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checked = _data["checked"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): JobTimelineStep {
        data = typeof data === 'object' ? data : {};
        let result = new JobTimelineStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checked"] = this.checked;
        data["date"] = this.date?.isValidDate() ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobTimelineStep {
    checked?: boolean;
    date?: Date | undefined;
}

export class LegalEntityDevelopmentModel implements ILegalEntityDevelopmentModel {
    developmentID?: string;
    developmentNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: ILegalEntityDevelopmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentID = _data["developmentID"];
            this.developmentNumber = _data["developmentNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LegalEntityDevelopmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new LegalEntityDevelopmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentID"] = this.developmentID;
        data["developmentNumber"] = this.developmentNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface ILegalEntityDevelopmentModel {
    developmentID?: string;
    developmentNumber?: string | undefined;
    name?: string | undefined;
}

export class LegalEntityModel implements ILegalEntityModel {
    legalEntityID?: string;
    legalEntityAccountNo?: number;
    name?: string | undefined;
    addressID?: string;
    vatNo?: string | undefined;
    deleted?: boolean;
    developments?: LegalEntityDevelopmentModel[] | undefined;

    constructor(data?: ILegalEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalEntityID = _data["legalEntityID"];
            this.legalEntityAccountNo = _data["legalEntityAccountNo"];
            this.name = _data["name"];
            this.addressID = _data["addressID"];
            this.vatNo = _data["vatNo"];
            this.deleted = _data["deleted"];
            if (Array.isArray(_data["developments"])) {
                this.developments = [] as any;
                for (let item of _data["developments"])
                    this.developments!.push(LegalEntityDevelopmentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LegalEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new LegalEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalEntityID"] = this.legalEntityID;
        data["legalEntityAccountNo"] = this.legalEntityAccountNo;
        data["name"] = this.name;
        data["addressID"] = this.addressID;
        data["vatNo"] = this.vatNo;
        data["deleted"] = this.deleted;
        if (Array.isArray(this.developments)) {
            data["developments"] = [];
            for (let item of this.developments)
                data["developments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILegalEntityModel {
    legalEntityID?: string;
    legalEntityAccountNo?: number;
    name?: string | undefined;
    addressID?: string;
    vatNo?: string | undefined;
    deleted?: boolean;
    developments?: LegalEntityDevelopmentModel[] | undefined;
}

export class LinkedDevelopmentModel implements ILinkedDevelopmentModel {
    developmentNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: ILinkedDevelopmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.developmentNumber = _data["developmentNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LinkedDevelopmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedDevelopmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["developmentNumber"] = this.developmentNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface ILinkedDevelopmentModel {
    developmentNumber?: string | undefined;
    name?: string | undefined;
}

export class LinkedLegalEntityModel implements ILinkedLegalEntityModel {
    legalEntityID?: string;
    name?: string | undefined;

    constructor(data?: ILinkedLegalEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalEntityID = _data["legalEntityID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LinkedLegalEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedLegalEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalEntityID"] = this.legalEntityID;
        data["name"] = this.name;
        return data;
    }
}

export interface ILinkedLegalEntityModel {
    legalEntityID?: string;
    name?: string | undefined;
}

export class ListedTypeModel implements IListedTypeModel {
    listedTypeID?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IListedTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listedTypeID = _data["listedTypeID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ListedTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListedTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listedTypeID"] = this.listedTypeID;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IListedTypeModel {
    listedTypeID?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class MeetingFiltersModel implements IMeetingFiltersModel {
    includePastMeetings?: boolean;
    includeAllMeetings?: boolean;

    constructor(data?: IMeetingFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includePastMeetings = _data["includePastMeetings"];
            this.includeAllMeetings = _data["includeAllMeetings"];
        }
    }

    static fromJS(data: any): MeetingFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includePastMeetings"] = this.includePastMeetings;
        data["includeAllMeetings"] = this.includeAllMeetings;
        return data;
    }
}

export interface IMeetingFiltersModel {
    includePastMeetings?: boolean;
    includeAllMeetings?: boolean;
}

export class MeetingModel implements IMeetingModel {
    meetingID?: number;
    meetingTypeID?: number;
    meetingTypeName?: string | undefined;
    developmentID?: string | undefined;
    developmentName?: string | undefined;
    developmentNumber?: string | undefined;
    purchaseAccountID?: string | undefined;
    purchaseAccountName?: string | undefined;
    purchaseAccountNumber?: string | undefined;
    clientID?: string | undefined;
    clientName?: string | undefined;
    clientAccountNumber?: string | undefined;
    title?: string | undefined;
    commentThreadID?: string;
    meetingDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    deleted?: boolean;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;

    constructor(data?: IMeetingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingID = _data["meetingID"];
            this.meetingTypeID = _data["meetingTypeID"];
            this.meetingTypeName = _data["meetingTypeName"];
            this.developmentID = _data["developmentID"];
            this.developmentName = _data["developmentName"];
            this.developmentNumber = _data["developmentNumber"];
            this.purchaseAccountID = _data["purchaseAccountID"];
            this.purchaseAccountName = _data["purchaseAccountName"];
            this.purchaseAccountNumber = _data["purchaseAccountNumber"];
            this.clientID = _data["clientID"];
            this.clientName = _data["clientName"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.title = _data["title"];
            this.commentThreadID = _data["commentThreadID"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.deleted = _data["deleted"];
            this.lastReplyDate = _data["lastReplyDate"] ? new Date(_data["lastReplyDate"].toString()) : undefined as any;
            this.hasUnreadComments = _data["hasUnreadComments"];
        }
    }

    static fromJS(data: any): MeetingModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingID"] = this.meetingID;
        data["meetingTypeID"] = this.meetingTypeID;
        data["meetingTypeName"] = this.meetingTypeName;
        data["developmentID"] = this.developmentID;
        data["developmentName"] = this.developmentName;
        data["developmentNumber"] = this.developmentNumber;
        data["purchaseAccountID"] = this.purchaseAccountID;
        data["purchaseAccountName"] = this.purchaseAccountName;
        data["purchaseAccountNumber"] = this.purchaseAccountNumber;
        data["clientID"] = this.clientID;
        data["clientName"] = this.clientName;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["title"] = this.title;
        data["commentThreadID"] = this.commentThreadID;
        data["meetingDate"] = this.meetingDate?.isValidDate() ? this.meetingDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate?.isValidDate() ? this.endDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["deleted"] = this.deleted;
        data["lastReplyDate"] = this.lastReplyDate?.isValidDate() ? this.lastReplyDate.toISOString() : <any>undefined;
        data["hasUnreadComments"] = this.hasUnreadComments;
        return data;
    }
}

export interface IMeetingModel {
    meetingID?: number;
    meetingTypeID?: number;
    meetingTypeName?: string | undefined;
    developmentID?: string | undefined;
    developmentName?: string | undefined;
    developmentNumber?: string | undefined;
    purchaseAccountID?: string | undefined;
    purchaseAccountName?: string | undefined;
    purchaseAccountNumber?: string | undefined;
    clientID?: string | undefined;
    clientName?: string | undefined;
    clientAccountNumber?: string | undefined;
    title?: string | undefined;
    commentThreadID?: string;
    meetingDate?: Date;
    endDate?: Date;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    deleted?: boolean;
    lastReplyDate?: Date | undefined;
    hasUnreadComments?: boolean;
}

export class MeetingTypeModel implements IMeetingTypeModel {
    meetingTypeID?: number;
    name?: string | undefined;
    systemRequired?: boolean;

    constructor(data?: IMeetingTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingTypeID = _data["meetingTypeID"];
            this.name = _data["name"];
            this.systemRequired = _data["systemRequired"];
        }
    }

    static fromJS(data: any): MeetingTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingTypeID"] = this.meetingTypeID;
        data["name"] = this.name;
        data["systemRequired"] = this.systemRequired;
        return data;
    }
}

export interface IMeetingTypeModel {
    meetingTypeID?: number;
    name?: string | undefined;
    systemRequired?: boolean;
}

export class MessageFeedbackModel implements IMessageFeedbackModel {
    isPositive?: boolean;
    reason?: FeedbackReason;
    comment?: string | undefined;

    constructor(data?: IMessageFeedbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPositive = _data["isPositive"];
            this.reason = _data["reason"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): MessageFeedbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageFeedbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPositive"] = this.isPositive;
        data["reason"] = this.reason;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IMessageFeedbackModel {
    isPositive?: boolean;
    reason?: FeedbackReason;
    comment?: string | undefined;
}

export class MissedPaymentsModel implements IMissedPaymentsModel {
    missedPayments?: number;
    missedInvoicePayments?: number;
    missedInvoices?: number;

    constructor(data?: IMissedPaymentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.missedPayments = _data["missedPayments"];
            this.missedInvoicePayments = _data["missedInvoicePayments"];
            this.missedInvoices = _data["missedInvoices"];
        }
    }

    static fromJS(data: any): MissedPaymentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedPaymentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["missedPayments"] = this.missedPayments;
        data["missedInvoicePayments"] = this.missedInvoicePayments;
        data["missedInvoices"] = this.missedInvoices;
        return data;
    }
}

export interface IMissedPaymentsModel {
    missedPayments?: number;
    missedInvoicePayments?: number;
    missedInvoices?: number;
}

export class MonthlyDirectDebitCalculationModel implements IMonthlyDirectDebitCalculationModel {
    monthlyCollectionAmount?: number;
    nextCollectionDate?: Date;
    totalAmountDue?: number;
    currentBalance?: number;
    unbilledAmountForPeriod?: number;
    eae?: number;
    floatBalance?: number;
    directDebitAdminFee?: number;
    elevatedMonthlyPayment?: number | undefined;
    missedPayments?: MissedPaymentsModel;

    constructor(data?: IMonthlyDirectDebitCalculationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyCollectionAmount = _data["monthlyCollectionAmount"];
            this.nextCollectionDate = _data["nextCollectionDate"] ? new Date(_data["nextCollectionDate"].toString()) : undefined as any;
            this.totalAmountDue = _data["totalAmountDue"];
            this.currentBalance = _data["currentBalance"];
            this.unbilledAmountForPeriod = _data["unbilledAmountForPeriod"];
            this.eae = _data["eae"];
            this.floatBalance = _data["floatBalance"];
            this.directDebitAdminFee = _data["directDebitAdminFee"];
            this.elevatedMonthlyPayment = _data["elevatedMonthlyPayment"];
            this.missedPayments = _data["missedPayments"] ? MissedPaymentsModel.fromJS(_data["missedPayments"]) : undefined as any;
        }
    }

    static fromJS(data: any): MonthlyDirectDebitCalculationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyDirectDebitCalculationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyCollectionAmount"] = this.monthlyCollectionAmount;
        data["nextCollectionDate"] = this.nextCollectionDate?.isValidDate() ? this.nextCollectionDate.toISOString() : <any>undefined;
        data["totalAmountDue"] = this.totalAmountDue;
        data["currentBalance"] = this.currentBalance;
        data["unbilledAmountForPeriod"] = this.unbilledAmountForPeriod;
        data["eae"] = this.eae;
        data["floatBalance"] = this.floatBalance;
        data["directDebitAdminFee"] = this.directDebitAdminFee;
        data["elevatedMonthlyPayment"] = this.elevatedMonthlyPayment;
        data["missedPayments"] = this.missedPayments ? this.missedPayments.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMonthlyDirectDebitCalculationModel {
    monthlyCollectionAmount?: number;
    nextCollectionDate?: Date;
    totalAmountDue?: number;
    currentBalance?: number;
    unbilledAmountForPeriod?: number;
    eae?: number;
    floatBalance?: number;
    directDebitAdminFee?: number;
    elevatedMonthlyPayment?: number | undefined;
    missedPayments?: MissedPaymentsModel;
}

export class NewAddressModel implements INewAddressModel {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;

    constructor(data?: INewAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.addressLine4 = _data["addressLine4"];
            this.addressLine5 = _data["addressLine5"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postCode = _data["postCode"];
            this.countryCodeID = _data["countryCodeID"];
        }
    }

    static fromJS(data: any): NewAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["addressLine4"] = this.addressLine4;
        data["addressLine5"] = this.addressLine5;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postCode"] = this.postCode;
        data["countryCodeID"] = this.countryCodeID;
        return data;
    }
}

export interface INewAddressModel {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;
}

export class NewCalendarEventModel implements INewCalendarEventModel {
    title?: string | undefined;
    description?: string | undefined;
    start?: Date;
    end?: Date;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    completed?: boolean;
    allDay?: boolean;

    constructor(data?: INewCalendarEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.assignedUserID = _data["assignedUserID"];
            this.assignedUserGroupID = _data["assignedUserGroupID"];
            this.completed = _data["completed"];
            this.allDay = _data["allDay"];
        }
    }

    static fromJS(data: any): NewCalendarEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewCalendarEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["start"] = this.start?.isValidDate() ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end?.isValidDate() ? this.end.toISOString() : <any>undefined;
        data["assignedUserID"] = this.assignedUserID;
        data["assignedUserGroupID"] = this.assignedUserGroupID;
        data["completed"] = this.completed;
        data["allDay"] = this.allDay;
        return data;
    }
}

export interface INewCalendarEventModel {
    title?: string | undefined;
    description?: string | undefined;
    start?: Date;
    end?: Date;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    completed?: boolean;
    allDay?: boolean;
}

export class NewCaseModel implements INewCaseModel {
    title?: string | undefined;
    description?: string | undefined;
    assignedUser?: string;
    caseTypeID?: number;
    caseStatusTypeID?: number;
    clientID?: string | undefined;
    adHocEmailAddress?: string | undefined;
    adHocRecipientName?: string | undefined;
    slaTypeID?: number;
    meetingID?: number | undefined;

    constructor(data?: INewCaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.assignedUser = _data["assignedUser"];
            this.caseTypeID = _data["caseTypeID"];
            this.caseStatusTypeID = _data["caseStatusTypeID"];
            this.clientID = _data["clientID"];
            this.adHocEmailAddress = _data["adHocEmailAddress"];
            this.adHocRecipientName = _data["adHocRecipientName"];
            this.slaTypeID = _data["slaTypeID"];
            this.meetingID = _data["meetingID"];
        }
    }

    static fromJS(data: any): NewCaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewCaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["assignedUser"] = this.assignedUser;
        data["caseTypeID"] = this.caseTypeID;
        data["caseStatusTypeID"] = this.caseStatusTypeID;
        data["clientID"] = this.clientID;
        data["adHocEmailAddress"] = this.adHocEmailAddress;
        data["adHocRecipientName"] = this.adHocRecipientName;
        data["slaTypeID"] = this.slaTypeID;
        data["meetingID"] = this.meetingID;
        return data;
    }
}

export interface INewCaseModel {
    title?: string | undefined;
    description?: string | undefined;
    assignedUser?: string;
    caseTypeID?: number;
    caseStatusTypeID?: number;
    clientID?: string | undefined;
    adHocEmailAddress?: string | undefined;
    adHocRecipientName?: string | undefined;
    slaTypeID?: number;
    meetingID?: number | undefined;
}

export class NewCaseStatusTypeModel implements INewCaseStatusTypeModel {
    name?: string | undefined;
    caseStatusBehaviourTypeID?: number;

    constructor(data?: INewCaseStatusTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.caseStatusBehaviourTypeID = _data["caseStatusBehaviourTypeID"];
        }
    }

    static fromJS(data: any): NewCaseStatusTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewCaseStatusTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["caseStatusBehaviourTypeID"] = this.caseStatusBehaviourTypeID;
        return data;
    }
}

export interface INewCaseStatusTypeModel {
    name?: string | undefined;
    caseStatusBehaviourTypeID?: number;
}

export class NewChatMessageModel implements INewChatMessageModel {
    chatSessionID?: string | undefined;
    message?: string | undefined;
    runID?: string | undefined;

    constructor(data?: INewChatMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.message = _data["message"];
            this.runID = _data["runID"];
        }
    }

    static fromJS(data: any): NewChatMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewChatMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["message"] = this.message;
        data["runID"] = this.runID;
        return data;
    }
}

export interface INewChatMessageModel {
    chatSessionID?: string | undefined;
    message?: string | undefined;
    runID?: string | undefined;
}

export class NewClientAddressModel implements INewClientAddressModel {
    clientAccountNumber?: string;
    address?: string | undefined;
    postCode?: string | undefined;
    isBilling?: boolean;
    isInternalBilling?: boolean;
    isForwarding?: boolean;
    description?: string | undefined;

    constructor(data?: INewClientAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.address = _data["address"];
            this.postCode = _data["postCode"];
            this.isBilling = _data["isBilling"];
            this.isInternalBilling = _data["isInternalBilling"];
            this.isForwarding = _data["isForwarding"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NewClientAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewClientAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["address"] = this.address;
        data["postCode"] = this.postCode;
        data["isBilling"] = this.isBilling;
        data["isInternalBilling"] = this.isInternalBilling;
        data["isForwarding"] = this.isForwarding;
        data["description"] = this.description;
        return data;
    }
}

export interface INewClientAddressModel {
    clientAccountNumber?: string;
    address?: string | undefined;
    postCode?: string | undefined;
    isBilling?: boolean;
    isInternalBilling?: boolean;
    isForwarding?: boolean;
    description?: string | undefined;
}

export class NewClientEmailModel implements INewClientEmailModel {
    clientAccountNumber?: string;
    emailAddress?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    useForDocuments?: boolean;
    useForInvoices?: boolean;

    constructor(data?: INewClientEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.emailAddress = _data["emailAddress"];
            this.description = _data["description"];
            this.isDefault = _data["isDefault"];
            this.useForDocuments = _data["useForDocuments"];
            this.useForInvoices = _data["useForInvoices"];
        }
    }

    static fromJS(data: any): NewClientEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewClientEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["emailAddress"] = this.emailAddress;
        data["description"] = this.description;
        data["isDefault"] = this.isDefault;
        data["useForDocuments"] = this.useForDocuments;
        data["useForInvoices"] = this.useForInvoices;
        return data;
    }
}

export interface INewClientEmailModel {
    clientAccountNumber?: string;
    emailAddress?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    useForDocuments?: boolean;
    useForInvoices?: boolean;
}

export class NewCommentRecipientModel implements INewCommentRecipientModel {
    commentThreadID?: string;
    recipientClientID?: string | undefined;
    recipientEmail?: string | undefined;
    recipientName?: string | undefined;

    constructor(data?: INewCommentRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentThreadID = _data["commentThreadID"];
            this.recipientClientID = _data["recipientClientID"];
            this.recipientEmail = _data["recipientEmail"];
            this.recipientName = _data["recipientName"];
        }
    }

    static fromJS(data: any): NewCommentRecipientModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewCommentRecipientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentThreadID"] = this.commentThreadID;
        data["recipientClientID"] = this.recipientClientID;
        data["recipientEmail"] = this.recipientEmail;
        data["recipientName"] = this.recipientName;
        return data;
    }
}

export interface INewCommentRecipientModel {
    commentThreadID?: string;
    recipientClientID?: string | undefined;
    recipientEmail?: string | undefined;
    recipientName?: string | undefined;
}

export class NewDirectorModel implements INewDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    address?: NewAddressModel;
    legalEntityIDs?: string[] | undefined;

    constructor(data?: INewDirectorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"] ? NewAddressModel.fromJS(_data["address"]) : undefined as any;
            if (Array.isArray(_data["legalEntityIDs"])) {
                this.legalEntityIDs = [] as any;
                for (let item of _data["legalEntityIDs"])
                    this.legalEntityIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): NewDirectorModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewDirectorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.legalEntityIDs)) {
            data["legalEntityIDs"] = [];
            for (let item of this.legalEntityIDs)
                data["legalEntityIDs"].push(item);
        }
        return data;
    }
}

export interface INewDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    address?: NewAddressModel;
    legalEntityIDs?: string[] | undefined;
}

export class NewEstimateCommentThreadModel implements INewEstimateCommentThreadModel {
    estimateID?: string;
    clientRecipientIDs?: string[] | undefined;
    adHocRecipients?: AdHocRecipientModel[] | undefined;

    constructor(data?: INewEstimateCommentThreadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimateID = _data["estimateID"];
            if (Array.isArray(_data["clientRecipientIDs"])) {
                this.clientRecipientIDs = [] as any;
                for (let item of _data["clientRecipientIDs"])
                    this.clientRecipientIDs!.push(item);
            }
            if (Array.isArray(_data["adHocRecipients"])) {
                this.adHocRecipients = [] as any;
                for (let item of _data["adHocRecipients"])
                    this.adHocRecipients!.push(AdHocRecipientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewEstimateCommentThreadModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewEstimateCommentThreadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimateID"] = this.estimateID;
        if (Array.isArray(this.clientRecipientIDs)) {
            data["clientRecipientIDs"] = [];
            for (let item of this.clientRecipientIDs)
                data["clientRecipientIDs"].push(item);
        }
        if (Array.isArray(this.adHocRecipients)) {
            data["adHocRecipients"] = [];
            for (let item of this.adHocRecipients)
                data["adHocRecipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewEstimateCommentThreadModel {
    estimateID?: string;
    clientRecipientIDs?: string[] | undefined;
    adHocRecipients?: AdHocRecipientModel[] | undefined;
}

export class NewJobCommentThreadModel implements INewJobCommentThreadModel {
    jobID?: number;
    taskSeqNo?: number;
    clientRecipientIDs?: string[] | undefined;
    adHocRecipients?: AdHocRecipientModel[] | undefined;

    constructor(data?: INewJobCommentThreadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobID = _data["jobID"];
            this.taskSeqNo = _data["taskSeqNo"];
            if (Array.isArray(_data["clientRecipientIDs"])) {
                this.clientRecipientIDs = [] as any;
                for (let item of _data["clientRecipientIDs"])
                    this.clientRecipientIDs!.push(item);
            }
            if (Array.isArray(_data["adHocRecipients"])) {
                this.adHocRecipients = [] as any;
                for (let item of _data["adHocRecipients"])
                    this.adHocRecipients!.push(AdHocRecipientModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewJobCommentThreadModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewJobCommentThreadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobID"] = this.jobID;
        data["taskSeqNo"] = this.taskSeqNo;
        if (Array.isArray(this.clientRecipientIDs)) {
            data["clientRecipientIDs"] = [];
            for (let item of this.clientRecipientIDs)
                data["clientRecipientIDs"].push(item);
        }
        if (Array.isArray(this.adHocRecipients)) {
            data["adHocRecipients"] = [];
            for (let item of this.adHocRecipients)
                data["adHocRecipients"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewJobCommentThreadModel {
    jobID?: number;
    taskSeqNo?: number;
    clientRecipientIDs?: string[] | undefined;
    adHocRecipients?: AdHocRecipientModel[] | undefined;
}

export class NewMeetingModel implements INewMeetingModel {
    meetingTypeID?: number;
    developmentID?: string | undefined;
    purchaseAccountID?: string | undefined;
    clientID?: string | undefined;
    title?: string | undefined;
    meetingDate?: Date;
    endDate?: Date;

    constructor(data?: INewMeetingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meetingTypeID = _data["meetingTypeID"];
            this.developmentID = _data["developmentID"];
            this.purchaseAccountID = _data["purchaseAccountID"];
            this.clientID = _data["clientID"];
            this.title = _data["title"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NewMeetingModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewMeetingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meetingTypeID"] = this.meetingTypeID;
        data["developmentID"] = this.developmentID;
        data["purchaseAccountID"] = this.purchaseAccountID;
        data["clientID"] = this.clientID;
        data["title"] = this.title;
        data["meetingDate"] = this.meetingDate?.isValidDate() ? this.meetingDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate?.isValidDate() ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface INewMeetingModel {
    meetingTypeID?: number;
    developmentID?: string | undefined;
    purchaseAccountID?: string | undefined;
    clientID?: string | undefined;
    title?: string | undefined;
    meetingDate?: Date;
    endDate?: Date;
}

export class NewSelfServeDataImportSubmissionColumnMappingModel implements INewSelfServeDataImportSubmissionColumnMappingModel {
    targetColumnName?: string | undefined;
    sourceColumnName?: string | undefined;
    sourceColumnIndex?: number | undefined;
    sourceHeaderRow?: number | undefined;
    displayOrder?: number;
    rowIdentifierOrder?: number | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionColumnMappingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetColumnName = _data["targetColumnName"];
            this.sourceColumnName = _data["sourceColumnName"];
            this.sourceColumnIndex = _data["sourceColumnIndex"];
            this.sourceHeaderRow = _data["sourceHeaderRow"];
            this.displayOrder = _data["displayOrder"];
            this.rowIdentifierOrder = _data["rowIdentifierOrder"];
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionColumnMappingModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionColumnMappingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetColumnName"] = this.targetColumnName;
        data["sourceColumnName"] = this.sourceColumnName;
        data["sourceColumnIndex"] = this.sourceColumnIndex;
        data["sourceHeaderRow"] = this.sourceHeaderRow;
        data["displayOrder"] = this.displayOrder;
        data["rowIdentifierOrder"] = this.rowIdentifierOrder;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionColumnMappingModel {
    targetColumnName?: string | undefined;
    sourceColumnName?: string | undefined;
    sourceColumnIndex?: number | undefined;
    sourceHeaderRow?: number | undefined;
    displayOrder?: number;
    rowIdentifierOrder?: number | undefined;
}

export class NewSelfServeDataImportSubmissionColumnMappingsBulkModel implements INewSelfServeDataImportSubmissionColumnMappingsBulkModel {
    submissionID?: string;
    sheetMappings?: NewSelfServeDataImportSubmissionColumnMappingsModel[] | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionColumnMappingsBulkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            if (Array.isArray(_data["sheetMappings"])) {
                this.sheetMappings = [] as any;
                for (let item of _data["sheetMappings"])
                    this.sheetMappings!.push(NewSelfServeDataImportSubmissionColumnMappingsModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionColumnMappingsBulkModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionColumnMappingsBulkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        if (Array.isArray(this.sheetMappings)) {
            data["sheetMappings"] = [];
            for (let item of this.sheetMappings)
                data["sheetMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionColumnMappingsBulkModel {
    submissionID?: string;
    sheetMappings?: NewSelfServeDataImportSubmissionColumnMappingsModel[] | undefined;
}

export class NewSelfServeDataImportSubmissionColumnMappingsModel implements INewSelfServeDataImportSubmissionColumnMappingsModel {
    submissionSheetMappingID?: string;
    columnMappingsConfirmed?: boolean;
    columnMappings?: NewSelfServeDataImportSubmissionColumnMappingModel[] | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionColumnMappingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionSheetMappingID = _data["submissionSheetMappingID"];
            this.columnMappingsConfirmed = _data["columnMappingsConfirmed"];
            if (Array.isArray(_data["columnMappings"])) {
                this.columnMappings = [] as any;
                for (let item of _data["columnMappings"])
                    this.columnMappings!.push(NewSelfServeDataImportSubmissionColumnMappingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionColumnMappingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionColumnMappingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionSheetMappingID"] = this.submissionSheetMappingID;
        data["columnMappingsConfirmed"] = this.columnMappingsConfirmed;
        if (Array.isArray(this.columnMappings)) {
            data["columnMappings"] = [];
            for (let item of this.columnMappings)
                data["columnMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionColumnMappingsModel {
    submissionSheetMappingID?: string;
    columnMappingsConfirmed?: boolean;
    columnMappings?: NewSelfServeDataImportSubmissionColumnMappingModel[] | undefined;
}

export class NewSelfServeDataImportSubmissionEditBatchModel implements INewSelfServeDataImportSubmissionEditBatchModel {
    version?: number;
    entries?: NewSelfServeDataImportSubmissionEditModel[] | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionEditBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(NewSelfServeDataImportSubmissionEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionEditBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionEditBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionEditBatchModel {
    version?: number;
    entries?: NewSelfServeDataImportSubmissionEditModel[] | undefined;
}

export class NewSelfServeDataImportSubmissionEditModel implements INewSelfServeDataImportSubmissionEditModel {
    editSequenceNumber?: number;
    worksheet?: string | undefined;
    rowNumber?: number;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editSequenceNumber = _data["editSequenceNumber"];
            this.worksheet = _data["worksheet"];
            this.rowNumber = _data["rowNumber"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editSequenceNumber"] = this.editSequenceNumber;
        data["worksheet"] = this.worksheet;
        data["rowNumber"] = this.rowNumber;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionEditModel {
    editSequenceNumber?: number;
    worksheet?: string | undefined;
    rowNumber?: number;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class NewSelfServeDataImportSubmissionEditsModel implements INewSelfServeDataImportSubmissionEditsModel {
    submissionID?: string;
    edits?: NewSelfServeDataImportSubmissionEditBatchModel;

    constructor(data?: INewSelfServeDataImportSubmissionEditsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.edits = _data["edits"] ? NewSelfServeDataImportSubmissionEditBatchModel.fromJS(_data["edits"]) : undefined as any;
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionEditsModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionEditsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["edits"] = this.edits ? this.edits.toJSON() : <any>undefined;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionEditsModel {
    submissionID?: string;
    edits?: NewSelfServeDataImportSubmissionEditBatchModel;
}

export class NewSelfServeDataImportSubmissionModel implements INewSelfServeDataImportSubmissionModel {
    templateType?: TemplateType;
    parentSubmissionID?: string | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateType = _data["templateType"];
            this.parentSubmissionID = _data["parentSubmissionID"];
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateType"] = this.templateType;
        data["parentSubmissionID"] = this.parentSubmissionID;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionModel {
    templateType?: TemplateType;
    parentSubmissionID?: string | undefined;
}

export class NewSelfServeDataImportSubmissionSheetMappingModel implements INewSelfServeDataImportSubmissionSheetMappingModel {
    submissionFileID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    sourceSheetName?: string | undefined;
    dataRowCount?: number | undefined;
    sourceOrder?: number;
    joinKeyColumnName?: string | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionSheetMappingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionFileID = _data["submissionFileID"];
            this.selfServeDataImportWorksheetTypeID = _data["selfServeDataImportWorksheetTypeID"];
            this.sourceSheetName = _data["sourceSheetName"];
            this.dataRowCount = _data["dataRowCount"];
            this.sourceOrder = _data["sourceOrder"];
            this.joinKeyColumnName = _data["joinKeyColumnName"];
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionSheetMappingModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionSheetMappingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionFileID"] = this.submissionFileID;
        data["selfServeDataImportWorksheetTypeID"] = this.selfServeDataImportWorksheetTypeID;
        data["sourceSheetName"] = this.sourceSheetName;
        data["dataRowCount"] = this.dataRowCount;
        data["sourceOrder"] = this.sourceOrder;
        data["joinKeyColumnName"] = this.joinKeyColumnName;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionSheetMappingModel {
    submissionFileID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    sourceSheetName?: string | undefined;
    dataRowCount?: number | undefined;
    sourceOrder?: number;
    joinKeyColumnName?: string | undefined;
}

export class NewSelfServeDataImportSubmissionSheetMappingsModel implements INewSelfServeDataImportSubmissionSheetMappingsModel {
    submissionID?: string;
    sheetMappings?: NewSelfServeDataImportSubmissionSheetMappingModel[] | undefined;

    constructor(data?: INewSelfServeDataImportSubmissionSheetMappingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            if (Array.isArray(_data["sheetMappings"])) {
                this.sheetMappings = [] as any;
                for (let item of _data["sheetMappings"])
                    this.sheetMappings!.push(NewSelfServeDataImportSubmissionSheetMappingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionSheetMappingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionSheetMappingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        if (Array.isArray(this.sheetMappings)) {
            data["sheetMappings"] = [];
            for (let item of this.sheetMappings)
                data["sheetMappings"].push(item.toJSON());
        }
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionSheetMappingsModel {
    submissionID?: string;
    sheetMappings?: NewSelfServeDataImportSubmissionSheetMappingModel[] | undefined;
}

export class NewSelfServeDataImportSubmissionValidationResultModel implements INewSelfServeDataImportSubmissionValidationResultModel {
    submissionID?: string;
    resultVersion?: number;
    totalRows?: number;
    validRows?: number;
    errorRows?: number;
    errorCount?: number;
    validationResult?: any;

    constructor(data?: INewSelfServeDataImportSubmissionValidationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.resultVersion = _data["resultVersion"];
            this.totalRows = _data["totalRows"];
            this.validRows = _data["validRows"];
            this.errorRows = _data["errorRows"];
            this.errorCount = _data["errorCount"];
            this.validationResult = _data["validationResult"];
        }
    }

    static fromJS(data: any): NewSelfServeDataImportSubmissionValidationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewSelfServeDataImportSubmissionValidationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["resultVersion"] = this.resultVersion;
        data["totalRows"] = this.totalRows;
        data["validRows"] = this.validRows;
        data["errorRows"] = this.errorRows;
        data["errorCount"] = this.errorCount;
        data["validationResult"] = this.validationResult;
        return data;
    }
}

export interface INewSelfServeDataImportSubmissionValidationResultModel {
    submissionID?: string;
    resultVersion?: number;
    totalRows?: number;
    validRows?: number;
    errorRows?: number;
    errorCount?: number;
    validationResult?: any;
}

export class NewUserModel implements INewUserModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;

    constructor(data?: INewUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.telephoneNumber = _data["telephoneNumber"];
        }
    }

    static fromJS(data: any): NewUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["telephoneNumber"] = this.telephoneNumber;
        return data;
    }
}

export interface INewUserModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;
}

export class NewUserTaskModel implements INewUserTaskModel {
    title?: string | undefined;
    description?: string | undefined;
    userTaskTypeID?: number;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    slaTypeID?: number;
    startDate?: Date;
    meetingID?: number | undefined;
    caseID?: number | undefined;

    constructor(data?: INewUserTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.userTaskTypeID = _data["userTaskTypeID"];
            this.assignedUserID = _data["assignedUserID"];
            this.assignedUserGroupID = _data["assignedUserGroupID"];
            this.slaTypeID = _data["slaTypeID"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.meetingID = _data["meetingID"];
            this.caseID = _data["caseID"];
        }
    }

    static fromJS(data: any): NewUserTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["userTaskTypeID"] = this.userTaskTypeID;
        data["assignedUserID"] = this.assignedUserID;
        data["assignedUserGroupID"] = this.assignedUserGroupID;
        data["slaTypeID"] = this.slaTypeID;
        data["startDate"] = this.startDate?.isValidDate() ? this.startDate.toISOString() : <any>undefined;
        data["meetingID"] = this.meetingID;
        data["caseID"] = this.caseID;
        return data;
    }
}

export interface INewUserTaskModel {
    title?: string | undefined;
    description?: string | undefined;
    userTaskTypeID?: number;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    slaTypeID?: number;
    startDate?: Date;
    meetingID?: number | undefined;
    caseID?: number | undefined;
}

export enum NotificationStyles {
    Success = "Success",
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger",
}

export enum NotificationTypes {
    Toast = "Toast",
    Alert = "Alert",
}

export class OverrideWorkingHoursModel implements IOverrideWorkingHoursModel {
    overrideWorkingHourID?: number;
    overrideStartDate?: Date;
    overrideEndDate?: Date;
    isOpen?: boolean;
    openTime?: string | undefined;
    closeTime?: string | undefined;

    constructor(data?: IOverrideWorkingHoursModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overrideWorkingHourID = _data["overrideWorkingHourID"];
            this.overrideStartDate = _data["overrideStartDate"] ? new Date(_data["overrideStartDate"].toString()) : undefined as any;
            this.overrideEndDate = _data["overrideEndDate"] ? new Date(_data["overrideEndDate"].toString()) : undefined as any;
            this.isOpen = _data["isOpen"];
            this.openTime = _data["openTime"];
            this.closeTime = _data["closeTime"];
        }
    }

    static fromJS(data: any): OverrideWorkingHoursModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverrideWorkingHoursModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overrideWorkingHourID"] = this.overrideWorkingHourID;
        data["overrideStartDate"] = this.overrideStartDate?.isValidDate() ? this.overrideStartDate.toISOString() : <any>undefined;
        data["overrideEndDate"] = this.overrideEndDate?.isValidDate() ? this.overrideEndDate.toISOString() : <any>undefined;
        data["isOpen"] = this.isOpen;
        data["openTime"] = this.openTime;
        data["closeTime"] = this.closeTime;
        return data;
    }
}

export interface IOverrideWorkingHoursModel {
    overrideWorkingHourID?: number;
    overrideStartDate?: Date;
    overrideEndDate?: Date;
    isOpen?: boolean;
    openTime?: string | undefined;
    closeTime?: string | undefined;
}

export class PLAccountMatchCandidate implements IPLAccountMatchCandidate {
    plAccountID?: string;
    matchedOn?: string[] | undefined;
    score?: number;

    constructor(data?: IPLAccountMatchCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plAccountID = _data["plAccountID"];
            if (Array.isArray(_data["matchedOn"])) {
                this.matchedOn = [] as any;
                for (let item of _data["matchedOn"])
                    this.matchedOn!.push(item);
            }
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): PLAccountMatchCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new PLAccountMatchCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plAccountID"] = this.plAccountID;
        if (Array.isArray(this.matchedOn)) {
            data["matchedOn"] = [];
            for (let item of this.matchedOn)
                data["matchedOn"].push(item);
        }
        data["score"] = this.score;
        return data;
    }
}

export interface IPLAccountMatchCandidate {
    plAccountID?: string;
    matchedOn?: string[] | undefined;
    score?: number;
}

export class PLAccountMatchFields implements IPLAccountMatchFields {
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
    emailAddress?: string | undefined;
    postCode?: string | undefined;
    companyName?: string | undefined;

    constructor(data?: IPLAccountMatchFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vatNumber = _data["vatNumber"];
            this.accountNumber = _data["accountNumber"];
            this.sortCode = _data["sortCode"];
            this.emailAddress = _data["emailAddress"];
            this.postCode = _data["postCode"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): PLAccountMatchFields {
        data = typeof data === 'object' ? data : {};
        let result = new PLAccountMatchFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vatNumber"] = this.vatNumber;
        data["accountNumber"] = this.accountNumber;
        data["sortCode"] = this.sortCode;
        data["emailAddress"] = this.emailAddress;
        data["postCode"] = this.postCode;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface IPLAccountMatchFields {
    vatNumber?: string | undefined;
    accountNumber?: string | undefined;
    sortCode?: string | undefined;
    emailAddress?: string | undefined;
    postCode?: string | undefined;
    companyName?: string | undefined;
}

export class PLAccountMatchResult implements IPLAccountMatchResult {
    confidence?: PLMatchConfidence;
    candidates?: PLAccountMatchCandidate[] | undefined;

    constructor(data?: IPLAccountMatchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confidence = _data["confidence"];
            if (Array.isArray(_data["candidates"])) {
                this.candidates = [] as any;
                for (let item of _data["candidates"])
                    this.candidates!.push(PLAccountMatchCandidate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PLAccountMatchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PLAccountMatchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidence"] = this.confidence;
        if (Array.isArray(this.candidates)) {
            data["candidates"] = [];
            for (let item of this.candidates)
                data["candidates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPLAccountMatchResult {
    confidence?: PLMatchConfidence;
    candidates?: PLAccountMatchCandidate[] | undefined;
}

export class PLClientTransactionFileModel implements IPLClientTransactionFileModel {
    transactionFileID?: string;
    transactionDate?: Date | undefined;
    invoiceNumber?: number | undefined;
    description?: string | undefined;
    amount?: number;
    propertyID?: string;
    hasChargeFiles?: boolean;
    queryCaseID?: number | undefined;

    constructor(data?: IPLClientTransactionFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionFileID = _data["transactionFileID"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.propertyID = _data["propertyID"];
            this.hasChargeFiles = _data["hasChargeFiles"];
            this.queryCaseID = _data["queryCaseID"];
        }
    }

    static fromJS(data: any): PLClientTransactionFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PLClientTransactionFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionFileID"] = this.transactionFileID;
        data["transactionDate"] = this.transactionDate?.isValidDate() ? this.transactionDate.toISOString() : <any>undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["propertyID"] = this.propertyID;
        data["hasChargeFiles"] = this.hasChargeFiles;
        data["queryCaseID"] = this.queryCaseID;
        return data;
    }
}

export interface IPLClientTransactionFileModel {
    transactionFileID?: string;
    transactionDate?: Date | undefined;
    invoiceNumber?: number | undefined;
    description?: string | undefined;
    amount?: number;
    propertyID?: string;
    hasChargeFiles?: boolean;
    queryCaseID?: number | undefined;
}

export class PLClientTransactionModel implements IPLClientTransactionModel {
    accountNumber?: string | undefined;
    address?: string | undefined;
    plClientTransactionFiles?: PLClientTransactionFileModel[] | undefined;

    constructor(data?: IPLClientTransactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.address = _data["address"];
            if (Array.isArray(_data["plClientTransactionFiles"])) {
                this.plClientTransactionFiles = [] as any;
                for (let item of _data["plClientTransactionFiles"])
                    this.plClientTransactionFiles!.push(PLClientTransactionFileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PLClientTransactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PLClientTransactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address;
        if (Array.isArray(this.plClientTransactionFiles)) {
            data["plClientTransactionFiles"] = [];
            for (let item of this.plClientTransactionFiles)
                data["plClientTransactionFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPLClientTransactionModel {
    accountNumber?: string | undefined;
    address?: string | undefined;
    plClientTransactionFiles?: PLClientTransactionFileModel[] | undefined;
}

export class PLInvoiceChargeFileModel implements IPLInvoiceChargeFileModel {
    chargeFileID?: string;
    invoiceNumber?: string | undefined;
    transactionDate?: Date;
    description?: string | undefined;
    invoiceAmount?: number;
    yourShare?: string | undefined;
    yourAmount?: number;
    propertyID?: string;
    queryCaseID?: number | undefined;
    standardDescriptionID?: number | undefined;
    plAccountID?: string | undefined;
    isGroupedCharge?: boolean;

    constructor(data?: IPLInvoiceChargeFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeFileID = _data["chargeFileID"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.yourShare = _data["yourShare"];
            this.yourAmount = _data["yourAmount"];
            this.propertyID = _data["propertyID"];
            this.queryCaseID = _data["queryCaseID"];
            this.standardDescriptionID = _data["standardDescriptionID"];
            this.plAccountID = _data["plAccountID"];
            this.isGroupedCharge = _data["isGroupedCharge"];
        }
    }

    static fromJS(data: any): PLInvoiceChargeFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PLInvoiceChargeFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeFileID"] = this.chargeFileID;
        data["invoiceNumber"] = this.invoiceNumber;
        data["transactionDate"] = this.transactionDate?.isValidDate() ? this.transactionDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["invoiceAmount"] = this.invoiceAmount;
        data["yourShare"] = this.yourShare;
        data["yourAmount"] = this.yourAmount;
        data["propertyID"] = this.propertyID;
        data["queryCaseID"] = this.queryCaseID;
        data["standardDescriptionID"] = this.standardDescriptionID;
        data["plAccountID"] = this.plAccountID;
        data["isGroupedCharge"] = this.isGroupedCharge;
        return data;
    }
}

export interface IPLInvoiceChargeFileModel {
    chargeFileID?: string;
    invoiceNumber?: string | undefined;
    transactionDate?: Date;
    description?: string | undefined;
    invoiceAmount?: number;
    yourShare?: string | undefined;
    yourAmount?: number;
    propertyID?: string;
    queryCaseID?: number | undefined;
    standardDescriptionID?: number | undefined;
    plAccountID?: string | undefined;
    isGroupedCharge?: boolean;
}

export class PLInvoiceChargeModel implements IPLInvoiceChargeModel {
    accountNumber?: string | undefined;
    address?: string | undefined;
    invoiceNumber?: number | undefined;
    invoiceCharges?: PLInvoiceChargeFileModel[] | undefined;

    constructor(data?: IPLInvoiceChargeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["accountNumber"];
            this.address = _data["address"];
            this.invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["invoiceCharges"])) {
                this.invoiceCharges = [] as any;
                for (let item of _data["invoiceCharges"])
                    this.invoiceCharges!.push(PLInvoiceChargeFileModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PLInvoiceChargeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PLInvoiceChargeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["address"] = this.address;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.invoiceCharges)) {
            data["invoiceCharges"] = [];
            for (let item of this.invoiceCharges)
                data["invoiceCharges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPLInvoiceChargeModel {
    accountNumber?: string | undefined;
    address?: string | undefined;
    invoiceNumber?: number | undefined;
    invoiceCharges?: PLInvoiceChargeFileModel[] | undefined;
}

export enum PLMatchConfidence {
    NotFound = "NotFound",
    LowConfidence = "LowConfidence",
    MediumConfidence = "MediumConfidence",
    HighConfidence = "HighConfidence",
    Ambiguous = "Ambiguous",
}

export enum ParameterDirection {
    Input = "Input",
    Output = "Output",
    InputOutput = "InputOutput",
    ReturnValue = "ReturnValue",
}

export class PaymentAmountModel implements IPaymentAmountModel {
    paymentAmount?: number;
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    fundScheduleChargeCategory?: FundScheduleChargeCategories;

    constructor(data?: IPaymentAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentAmount = _data["paymentAmount"];
            this.clientID = _data["clientID"];
            this.clientAccountNumber = _data["clientAccountNumber"];
            this.propertyAddress = _data["propertyAddress"];
            this.fundScheduleChargeCategory = _data["fundScheduleChargeCategory"];
        }
    }

    static fromJS(data: any): PaymentAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentAmount"] = this.paymentAmount;
        data["clientID"] = this.clientID;
        data["clientAccountNumber"] = this.clientAccountNumber;
        data["propertyAddress"] = this.propertyAddress;
        data["fundScheduleChargeCategory"] = this.fundScheduleChargeCategory;
        return data;
    }
}

export interface IPaymentAmountModel {
    paymentAmount?: number;
    clientID?: string;
    clientAccountNumber?: string | undefined;
    propertyAddress?: string | undefined;
    fundScheduleChargeCategory?: FundScheduleChargeCategories;
}

export class PaymentConfirmationModel implements IPaymentConfirmationModel {
    email?: string | undefined;
    clientPortalPaymentID?: string;

    constructor(data?: IPaymentConfirmationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.clientPortalPaymentID = _data["clientPortalPaymentID"];
        }
    }

    static fromJS(data: any): PaymentConfirmationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfirmationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["clientPortalPaymentID"] = this.clientPortalPaymentID;
        return data;
    }
}

export interface IPaymentConfirmationModel {
    email?: string | undefined;
    clientPortalPaymentID?: string;
}

export class PaymentProviderModel implements IPaymentProviderModel {
    paymentProviderID?: number;
    name?: string | undefined;
    setupComplete?: boolean;
    enabled?: boolean;

    constructor(data?: IPaymentProviderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentProviderID = _data["paymentProviderID"];
            this.name = _data["name"];
            this.setupComplete = _data["setupComplete"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): PaymentProviderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProviderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentProviderID"] = this.paymentProviderID;
        data["name"] = this.name;
        data["setupComplete"] = this.setupComplete;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IPaymentProviderModel {
    paymentProviderID?: number;
    name?: string | undefined;
    setupComplete?: boolean;
    enabled?: boolean;
}

export enum PaymentProviders {
    Blink = "Blink",
    GoCardless = "GoCardless",
}

export class PaymentRequestModel implements IPaymentRequestModel {
    proposedWorkID?: string | undefined;
    paymentAmounts?: PaymentAmountModel[] | undefined;

    constructor(data?: IPaymentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposedWorkID = _data["proposedWorkID"];
            if (Array.isArray(_data["paymentAmounts"])) {
                this.paymentAmounts = [] as any;
                for (let item of _data["paymentAmounts"])
                    this.paymentAmounts!.push(PaymentAmountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposedWorkID"] = this.proposedWorkID;
        if (Array.isArray(this.paymentAmounts)) {
            data["paymentAmounts"] = [];
            for (let item of this.paymentAmounts)
                data["paymentAmounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaymentRequestModel {
    proposedWorkID?: string | undefined;
    paymentAmounts?: PaymentAmountModel[] | undefined;
}

export class PowerBIReportModel implements IPowerBIReportModel {
    reportDataID?: string | undefined;
    name?: string | undefined;
    embedUrl?: string | undefined;
    token?: string | undefined;

    constructor(data?: IPowerBIReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportDataID = _data["reportDataID"];
            this.name = _data["name"];
            this.embedUrl = _data["embedUrl"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): PowerBIReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBIReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportDataID"] = this.reportDataID;
        data["name"] = this.name;
        data["embedUrl"] = this.embedUrl;
        data["token"] = this.token;
        return data;
    }
}

export interface IPowerBIReportModel {
    reportDataID?: string | undefined;
    name?: string | undefined;
    embedUrl?: string | undefined;
    token?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProcessFreeholderPaymentsModel implements IProcessFreeholderPaymentsModel {
    batchNo?: number;
    transferBatchNo?: number;

    constructor(data?: IProcessFreeholderPaymentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNo = _data["batchNo"];
            this.transferBatchNo = _data["transferBatchNo"];
        }
    }

    static fromJS(data: any): ProcessFreeholderPaymentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessFreeholderPaymentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNo"] = this.batchNo;
        data["transferBatchNo"] = this.transferBatchNo;
        return data;
    }
}

export interface IProcessFreeholderPaymentsModel {
    batchNo?: number;
    transferBatchNo?: number;
}

export class ProcessedInvoiceModel implements IProcessedInvoiceModel {
    invoice?: ExtractedInvoiceModel;
    purchaseLedgerMatch?: PLAccountMatchResult;

    constructor(data?: IProcessedInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoice = _data["invoice"] ? ExtractedInvoiceModel.fromJS(_data["invoice"]) : undefined as any;
            this.purchaseLedgerMatch = _data["purchaseLedgerMatch"] ? PLAccountMatchResult.fromJS(_data["purchaseLedgerMatch"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProcessedInvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessedInvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["purchaseLedgerMatch"] = this.purchaseLedgerMatch ? this.purchaseLedgerMatch.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProcessedInvoiceModel {
    invoice?: ExtractedInvoiceModel;
    purchaseLedgerMatch?: PLAccountMatchResult;
}

export class PropertyServiceChargeTypeModel implements IPropertyServiceChargeTypeModel {
    propertyServiceChargeTypeID?: number;
    name?: string | undefined;

    constructor(data?: IPropertyServiceChargeTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyServiceChargeTypeID = _data["propertyServiceChargeTypeID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PropertyServiceChargeTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyServiceChargeTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyServiceChargeTypeID"] = this.propertyServiceChargeTypeID;
        data["name"] = this.name;
        return data;
    }
}

export interface IPropertyServiceChargeTypeModel {
    propertyServiceChargeTypeID?: number;
    name?: string | undefined;
}

export class PropertyTypeModel implements IPropertyTypeModel {
    propertyTypeID?: string;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPropertyTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyTypeID = _data["propertyTypeID"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PropertyTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyTypeID"] = this.propertyTypeID;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IPropertyTypeModel {
    propertyTypeID?: string;
    code?: string | undefined;
    description?: string | undefined;
}

export class QuarterlyDirectDebitCalculationModel implements IQuarterlyDirectDebitCalculationModel {
    nextQuarterlyCollection?: Date;
    currentBalance?: number;
    collectionMonths?: string[] | undefined;
    useSpecificQuarterlyPaymentMonths?: boolean;
    collectOutstandingBalanceASAP?: boolean;
    nextASAPCollection?: Date;
    directDebitAdminFee?: number;
    variable?: boolean;
    includeFloatForVariable?: boolean;
    floatBalance?: number;
    quarterlyCollectionAmount?: number;
    totalAmountDue?: number;
    unbilledAmountForPeriod?: number;

    constructor(data?: IQuarterlyDirectDebitCalculationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextQuarterlyCollection = _data["nextQuarterlyCollection"] ? new Date(_data["nextQuarterlyCollection"].toString()) : undefined as any;
            this.currentBalance = _data["currentBalance"];
            if (Array.isArray(_data["collectionMonths"])) {
                this.collectionMonths = [] as any;
                for (let item of _data["collectionMonths"])
                    this.collectionMonths!.push(item);
            }
            this.useSpecificQuarterlyPaymentMonths = _data["useSpecificQuarterlyPaymentMonths"];
            this.collectOutstandingBalanceASAP = _data["collectOutstandingBalanceASAP"];
            this.nextASAPCollection = _data["nextASAPCollection"] ? new Date(_data["nextASAPCollection"].toString()) : undefined as any;
            this.directDebitAdminFee = _data["directDebitAdminFee"];
            this.variable = _data["variable"];
            this.includeFloatForVariable = _data["includeFloatForVariable"];
            this.floatBalance = _data["floatBalance"];
            this.quarterlyCollectionAmount = _data["quarterlyCollectionAmount"];
            this.totalAmountDue = _data["totalAmountDue"];
            this.unbilledAmountForPeriod = _data["unbilledAmountForPeriod"];
        }
    }

    static fromJS(data: any): QuarterlyDirectDebitCalculationModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuarterlyDirectDebitCalculationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextQuarterlyCollection"] = this.nextQuarterlyCollection?.isValidDate() ? this.nextQuarterlyCollection.toISOString() : <any>undefined;
        data["currentBalance"] = this.currentBalance;
        if (Array.isArray(this.collectionMonths)) {
            data["collectionMonths"] = [];
            for (let item of this.collectionMonths)
                data["collectionMonths"].push(item);
        }
        data["useSpecificQuarterlyPaymentMonths"] = this.useSpecificQuarterlyPaymentMonths;
        data["collectOutstandingBalanceASAP"] = this.collectOutstandingBalanceASAP;
        data["nextASAPCollection"] = this.nextASAPCollection?.isValidDate() ? this.nextASAPCollection.toISOString() : <any>undefined;
        data["directDebitAdminFee"] = this.directDebitAdminFee;
        data["variable"] = this.variable;
        data["includeFloatForVariable"] = this.includeFloatForVariable;
        data["floatBalance"] = this.floatBalance;
        data["quarterlyCollectionAmount"] = this.quarterlyCollectionAmount;
        data["totalAmountDue"] = this.totalAmountDue;
        data["unbilledAmountForPeriod"] = this.unbilledAmountForPeriod;
        return data;
    }
}

export interface IQuarterlyDirectDebitCalculationModel {
    nextQuarterlyCollection?: Date;
    currentBalance?: number;
    collectionMonths?: string[] | undefined;
    useSpecificQuarterlyPaymentMonths?: boolean;
    collectOutstandingBalanceASAP?: boolean;
    nextASAPCollection?: Date;
    directDebitAdminFee?: number;
    variable?: boolean;
    includeFloatForVariable?: boolean;
    floatBalance?: number;
    quarterlyCollectionAmount?: number;
    totalAmountDue?: number;
    unbilledAmountForPeriod?: number;
}

export class QueryResultColumnModel implements IQueryResultColumnModel {
    name?: string | undefined;
    typeName?: string | undefined;

    constructor(data?: IQueryResultColumnModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeName = _data["typeName"];
        }
    }

    static fromJS(data: any): QueryResultColumnModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultColumnModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeName"] = this.typeName;
        return data;
    }
}

export interface IQueryResultColumnModel {
    name?: string | undefined;
    typeName?: string | undefined;
}

export class QueryResultModel implements IQueryResultModel {
    columns?: QueryResultColumnModel[] | undefined;
    rows?: any[][] | undefined;
    isTruncated?: boolean;

    constructor(data?: IQueryResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(QueryResultColumnModel.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.isTruncated = _data["isTruncated"];
        }
    }

    static fromJS(data: any): QueryResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["isTruncated"] = this.isTruncated;
        return data;
    }
}

export interface IQueryResultModel {
    columns?: QueryResultColumnModel[] | undefined;
    rows?: any[][] | undefined;
    isTruncated?: boolean;
}

export class RPMUserVerificationModel implements IRPMUserVerificationModel {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IRPMUserVerificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RPMUserVerificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new RPMUserVerificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

export interface IRPMUserVerificationModel {
    username?: string | undefined;
    password?: string | undefined;
}

export class ReportPreviewModel implements IReportPreviewModel {
    previewURL?: string | undefined;

    constructor(data?: IReportPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previewURL = _data["previewURL"];
        }
    }

    static fromJS(data: any): ReportPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previewURL"] = this.previewURL;
        return data;
    }
}

export interface IReportPreviewModel {
    previewURL?: string | undefined;
}

export class ReportURLResponseModel implements IReportURLResponseModel {
    printedExternally?: boolean;
    previewURL?: string | undefined;
    message?: string | undefined;

    constructor(data?: IReportURLResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.printedExternally = _data["printedExternally"];
            this.previewURL = _data["previewURL"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReportURLResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportURLResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printedExternally"] = this.printedExternally;
        data["previewURL"] = this.previewURL;
        data["message"] = this.message;
        return data;
    }
}

export interface IReportURLResponseModel {
    printedExternally?: boolean;
    previewURL?: string | undefined;
    message?: string | undefined;
}

export class ResumableProcessModel implements IResumableProcessModel {
    resumableProcessModelID?: number;
    resumableProcessType?: UserResumableProcessType;
    data?: string | undefined;

    constructor(data?: IResumableProcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resumableProcessModelID = _data["resumableProcessModelID"];
            this.resumableProcessType = _data["resumableProcessType"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ResumableProcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResumableProcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resumableProcessModelID"] = this.resumableProcessModelID;
        data["resumableProcessType"] = this.resumableProcessType;
        data["data"] = this.data;
        return data;
    }
}

export interface IResumableProcessModel {
    resumableProcessModelID?: number;
    resumableProcessType?: UserResumableProcessType;
    data?: string | undefined;
}

export class SLATypeModel implements ISLATypeModel {
    slaTypeID?: number;
    name?: string | undefined;
    targetMinutes?: number;
    systemRequired?: boolean;

    constructor(data?: ISLATypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slaTypeID = _data["slaTypeID"];
            this.name = _data["name"];
            this.targetMinutes = _data["targetMinutes"];
            this.systemRequired = _data["systemRequired"];
        }
    }

    static fromJS(data: any): SLATypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SLATypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slaTypeID"] = this.slaTypeID;
        data["name"] = this.name;
        data["targetMinutes"] = this.targetMinutes;
        data["systemRequired"] = this.systemRequired;
        return data;
    }
}

export interface ISLATypeModel {
    slaTypeID?: number;
    name?: string | undefined;
    targetMinutes?: number;
    systemRequired?: boolean;
}

export class Section166DemandReportModel implements ISection166DemandReportModel {
    leaseholderName?: string | undefined;
    leaseholderAddress?: string | undefined;
    rentAmount?: number;
    rentDueDate?: Date;
    rentalPeriod?: string | undefined;
    oneOffRentAmount?: number | undefined;
    oneOffRentDueDate?: Date | undefined;
    payeeName?: string | undefined;
    payeeAddress?: string | undefined;
    payeeIsLandlord?: boolean;
    landlordName?: string | undefined;
    landlordAddress?: string | undefined;

    constructor(data?: ISection166DemandReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaseholderName = _data["leaseholderName"];
            this.leaseholderAddress = _data["leaseholderAddress"];
            this.rentAmount = _data["rentAmount"];
            this.rentDueDate = _data["rentDueDate"] ? new Date(_data["rentDueDate"].toString()) : undefined as any;
            this.rentalPeriod = _data["rentalPeriod"];
            this.oneOffRentAmount = _data["oneOffRentAmount"];
            this.oneOffRentDueDate = _data["oneOffRentDueDate"] ? new Date(_data["oneOffRentDueDate"].toString()) : undefined as any;
            this.payeeName = _data["payeeName"];
            this.payeeAddress = _data["payeeAddress"];
            this.payeeIsLandlord = _data["payeeIsLandlord"];
            this.landlordName = _data["landlordName"];
            this.landlordAddress = _data["landlordAddress"];
        }
    }

    static fromJS(data: any): Section166DemandReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new Section166DemandReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaseholderName"] = this.leaseholderName;
        data["leaseholderAddress"] = this.leaseholderAddress;
        data["rentAmount"] = this.rentAmount;
        data["rentDueDate"] = this.rentDueDate?.isValidDate() ? this.rentDueDate.toISOString() : <any>undefined;
        data["rentalPeriod"] = this.rentalPeriod;
        data["oneOffRentAmount"] = this.oneOffRentAmount;
        data["oneOffRentDueDate"] = this.oneOffRentDueDate?.isValidDate() ? this.oneOffRentDueDate.toISOString() : <any>undefined;
        data["payeeName"] = this.payeeName;
        data["payeeAddress"] = this.payeeAddress;
        data["payeeIsLandlord"] = this.payeeIsLandlord;
        data["landlordName"] = this.landlordName;
        data["landlordAddress"] = this.landlordAddress;
        return data;
    }
}

export interface ISection166DemandReportModel {
    leaseholderName?: string | undefined;
    leaseholderAddress?: string | undefined;
    rentAmount?: number;
    rentDueDate?: Date;
    rentalPeriod?: string | undefined;
    oneOffRentAmount?: number | undefined;
    oneOffRentDueDate?: Date | undefined;
    payeeName?: string | undefined;
    payeeAddress?: string | undefined;
    payeeIsLandlord?: boolean;
    landlordName?: string | undefined;
    landlordAddress?: string | undefined;
}

export class SelfServeDataImportSubmissionColumnMappingModel implements ISelfServeDataImportSubmissionColumnMappingModel {
    submissionColumnMappingID?: string;
    submissionSheetMappingID?: string;
    targetColumnName?: string | undefined;
    sourceColumnName?: string | undefined;
    sourceColumnIndex?: number | undefined;
    sourceHeaderRow?: number | undefined;
    displayOrder?: number;
    rowIdentifierOrder?: number | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;

    constructor(data?: ISelfServeDataImportSubmissionColumnMappingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionColumnMappingID = _data["submissionColumnMappingID"];
            this.submissionSheetMappingID = _data["submissionSheetMappingID"];
            this.targetColumnName = _data["targetColumnName"];
            this.sourceColumnName = _data["sourceColumnName"];
            this.sourceColumnIndex = _data["sourceColumnIndex"];
            this.sourceHeaderRow = _data["sourceHeaderRow"];
            this.displayOrder = _data["displayOrder"];
            this.rowIdentifierOrder = _data["rowIdentifierOrder"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionColumnMappingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionColumnMappingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionColumnMappingID"] = this.submissionColumnMappingID;
        data["submissionSheetMappingID"] = this.submissionSheetMappingID;
        data["targetColumnName"] = this.targetColumnName;
        data["sourceColumnName"] = this.sourceColumnName;
        data["sourceColumnIndex"] = this.sourceColumnIndex;
        data["sourceHeaderRow"] = this.sourceHeaderRow;
        data["displayOrder"] = this.displayOrder;
        data["rowIdentifierOrder"] = this.rowIdentifierOrder;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionColumnMappingModel {
    submissionColumnMappingID?: string;
    submissionSheetMappingID?: string;
    targetColumnName?: string | undefined;
    sourceColumnName?: string | undefined;
    sourceColumnIndex?: number | undefined;
    sourceHeaderRow?: number | undefined;
    displayOrder?: number;
    rowIdentifierOrder?: number | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
}

export class SelfServeDataImportSubmissionEditModel implements ISelfServeDataImportSubmissionEditModel {
    submissionEditID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    editSequenceNumber?: number;
    worksheet?: string | undefined;
    rowNumber?: number;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;

    constructor(data?: ISelfServeDataImportSubmissionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionEditID = _data["submissionEditID"];
            this.selfServeDataImportWorksheetTypeID = _data["selfServeDataImportWorksheetTypeID"];
            this.editSequenceNumber = _data["editSequenceNumber"];
            this.worksheet = _data["worksheet"];
            this.rowNumber = _data["rowNumber"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionEditID"] = this.submissionEditID;
        data["selfServeDataImportWorksheetTypeID"] = this.selfServeDataImportWorksheetTypeID;
        data["editSequenceNumber"] = this.editSequenceNumber;
        data["worksheet"] = this.worksheet;
        data["rowNumber"] = this.rowNumber;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionEditModel {
    submissionEditID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    editSequenceNumber?: number;
    worksheet?: string | undefined;
    rowNumber?: number;
    field?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
}

export class SelfServeDataImportSubmissionEditsModel implements ISelfServeDataImportSubmissionEditsModel {
    submissionID?: string;
    version?: number;
    latestEditSequenceNumber?: number;
    entries?: SelfServeDataImportSubmissionEditModel[] | undefined;

    constructor(data?: ISelfServeDataImportSubmissionEditsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.version = _data["version"];
            this.latestEditSequenceNumber = _data["latestEditSequenceNumber"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(SelfServeDataImportSubmissionEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionEditsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionEditsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["version"] = this.version;
        data["latestEditSequenceNumber"] = this.latestEditSequenceNumber;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISelfServeDataImportSubmissionEditsModel {
    submissionID?: string;
    version?: number;
    latestEditSequenceNumber?: number;
    entries?: SelfServeDataImportSubmissionEditModel[] | undefined;
}

export class SelfServeDataImportSubmissionFileModel implements ISelfServeDataImportSubmissionFileModel {
    submissionFileID?: string;
    submissionID?: string;
    fileName?: string | undefined;
    fileSizeBytes?: number;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;

    constructor(data?: ISelfServeDataImportSubmissionFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionFileID = _data["submissionFileID"];
            this.submissionID = _data["submissionID"];
            this.fileName = _data["fileName"];
            this.fileSizeBytes = _data["fileSizeBytes"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionFileID"] = this.submissionFileID;
        data["submissionID"] = this.submissionID;
        data["fileName"] = this.fileName;
        data["fileSizeBytes"] = this.fileSizeBytes;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionFileModel {
    submissionFileID?: string;
    submissionID?: string;
    fileName?: string | undefined;
    fileSizeBytes?: number;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
}

export class SelfServeDataImportSubmissionLockModel implements ISelfServeDataImportSubmissionLockModel {
    submissionID?: string;
    heldByUser?: string | undefined;
    heldByUserName?: string | undefined;
    acquiredDate?: Date | undefined;
    expiresDate?: Date | undefined;
    updatedDate?: Date | undefined;
    isExpired?: boolean;
    isHeldByCurrentUser?: boolean;

    constructor(data?: ISelfServeDataImportSubmissionLockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.heldByUser = _data["heldByUser"];
            this.heldByUserName = _data["heldByUserName"];
            this.acquiredDate = _data["acquiredDate"] ? new Date(_data["acquiredDate"].toString()) : undefined as any;
            this.expiresDate = _data["expiresDate"] ? new Date(_data["expiresDate"].toString()) : undefined as any;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.isExpired = _data["isExpired"];
            this.isHeldByCurrentUser = _data["isHeldByCurrentUser"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionLockModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionLockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["heldByUser"] = this.heldByUser;
        data["heldByUserName"] = this.heldByUserName;
        data["acquiredDate"] = this.acquiredDate?.isValidDate() ? this.acquiredDate.toISOString() : <any>undefined;
        data["expiresDate"] = this.expiresDate?.isValidDate() ? this.expiresDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["isExpired"] = this.isExpired;
        data["isHeldByCurrentUser"] = this.isHeldByCurrentUser;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionLockModel {
    submissionID?: string;
    heldByUser?: string | undefined;
    heldByUserName?: string | undefined;
    acquiredDate?: Date | undefined;
    expiresDate?: Date | undefined;
    updatedDate?: Date | undefined;
    isExpired?: boolean;
    isHeldByCurrentUser?: boolean;
}

export class SelfServeDataImportSubmissionModel implements ISelfServeDataImportSubmissionModel {
    submissionID?: string;
    templateType?: TemplateType;
    templateTypeName?: string | undefined;
    submissionStatus?: SubmissionStatus;
    submissionStatusName?: string | undefined;
    importStatus?: ImportStatus;
    importStatusName?: string | undefined;
    currentStep?: number;
    referenceNo?: string | undefined;
    parentSubmissionID?: string | undefined;
    parentReferenceNo?: string | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
    updatedDate?: Date | undefined;
    updatedUser?: string | undefined;
    updatedUserName?: string | undefined;
    lockHeldByUser?: string | undefined;
    lockHeldByUserName?: string | undefined;
    lockExpiresDate?: Date | undefined;
    isLockExpired?: boolean;
    isLockHeldByCurrentUser?: boolean;

    constructor(data?: ISelfServeDataImportSubmissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.templateType = _data["templateType"];
            this.templateTypeName = _data["templateTypeName"];
            this.submissionStatus = _data["submissionStatus"];
            this.submissionStatusName = _data["submissionStatusName"];
            this.importStatus = _data["importStatus"];
            this.importStatusName = _data["importStatusName"];
            this.currentStep = _data["currentStep"];
            this.referenceNo = _data["referenceNo"];
            this.parentSubmissionID = _data["parentSubmissionID"];
            this.parentReferenceNo = _data["parentReferenceNo"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.updatedUser = _data["updatedUser"];
            this.updatedUserName = _data["updatedUserName"];
            this.lockHeldByUser = _data["lockHeldByUser"];
            this.lockHeldByUserName = _data["lockHeldByUserName"];
            this.lockExpiresDate = _data["lockExpiresDate"] ? new Date(_data["lockExpiresDate"].toString()) : undefined as any;
            this.isLockExpired = _data["isLockExpired"];
            this.isLockHeldByCurrentUser = _data["isLockHeldByCurrentUser"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["templateType"] = this.templateType;
        data["templateTypeName"] = this.templateTypeName;
        data["submissionStatus"] = this.submissionStatus;
        data["submissionStatusName"] = this.submissionStatusName;
        data["importStatus"] = this.importStatus;
        data["importStatusName"] = this.importStatusName;
        data["currentStep"] = this.currentStep;
        data["referenceNo"] = this.referenceNo;
        data["parentSubmissionID"] = this.parentSubmissionID;
        data["parentReferenceNo"] = this.parentReferenceNo;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedUser"] = this.updatedUser;
        data["updatedUserName"] = this.updatedUserName;
        data["lockHeldByUser"] = this.lockHeldByUser;
        data["lockHeldByUserName"] = this.lockHeldByUserName;
        data["lockExpiresDate"] = this.lockExpiresDate?.isValidDate() ? this.lockExpiresDate.toISOString() : <any>undefined;
        data["isLockExpired"] = this.isLockExpired;
        data["isLockHeldByCurrentUser"] = this.isLockHeldByCurrentUser;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionModel {
    submissionID?: string;
    templateType?: TemplateType;
    templateTypeName?: string | undefined;
    submissionStatus?: SubmissionStatus;
    submissionStatusName?: string | undefined;
    importStatus?: ImportStatus;
    importStatusName?: string | undefined;
    currentStep?: number;
    referenceNo?: string | undefined;
    parentSubmissionID?: string | undefined;
    parentReferenceNo?: string | undefined;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
    updatedDate?: Date | undefined;
    updatedUser?: string | undefined;
    updatedUserName?: string | undefined;
    lockHeldByUser?: string | undefined;
    lockHeldByUserName?: string | undefined;
    lockExpiresDate?: Date | undefined;
    isLockExpired?: boolean;
    isLockHeldByCurrentUser?: boolean;
}

export class SelfServeDataImportSubmissionSheetMappingModel implements ISelfServeDataImportSubmissionSheetMappingModel {
    submissionSheetMappingID?: string;
    submissionID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    worksheetName?: string | undefined;
    submissionFileID?: string;
    fileName?: string | undefined;
    sourceSheetName?: string | undefined;
    dataRowCount?: number | undefined;
    sourceOrder?: number;
    joinKeyColumnName?: string | undefined;
    columnMappingsConfirmed?: boolean;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;

    constructor(data?: ISelfServeDataImportSubmissionSheetMappingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionSheetMappingID = _data["submissionSheetMappingID"];
            this.submissionID = _data["submissionID"];
            this.selfServeDataImportWorksheetTypeID = _data["selfServeDataImportWorksheetTypeID"];
            this.worksheetName = _data["worksheetName"];
            this.submissionFileID = _data["submissionFileID"];
            this.fileName = _data["fileName"];
            this.sourceSheetName = _data["sourceSheetName"];
            this.dataRowCount = _data["dataRowCount"];
            this.sourceOrder = _data["sourceOrder"];
            this.joinKeyColumnName = _data["joinKeyColumnName"];
            this.columnMappingsConfirmed = _data["columnMappingsConfirmed"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionSheetMappingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionSheetMappingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionSheetMappingID"] = this.submissionSheetMappingID;
        data["submissionID"] = this.submissionID;
        data["selfServeDataImportWorksheetTypeID"] = this.selfServeDataImportWorksheetTypeID;
        data["worksheetName"] = this.worksheetName;
        data["submissionFileID"] = this.submissionFileID;
        data["fileName"] = this.fileName;
        data["sourceSheetName"] = this.sourceSheetName;
        data["dataRowCount"] = this.dataRowCount;
        data["sourceOrder"] = this.sourceOrder;
        data["joinKeyColumnName"] = this.joinKeyColumnName;
        data["columnMappingsConfirmed"] = this.columnMappingsConfirmed;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionSheetMappingModel {
    submissionSheetMappingID?: string;
    submissionID?: string;
    selfServeDataImportWorksheetTypeID?: number;
    worksheetName?: string | undefined;
    submissionFileID?: string;
    fileName?: string | undefined;
    sourceSheetName?: string | undefined;
    dataRowCount?: number | undefined;
    sourceOrder?: number;
    joinKeyColumnName?: string | undefined;
    columnMappingsConfirmed?: boolean;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
}

export class SelfServeDataImportSubmissionValidationResultModel implements ISelfServeDataImportSubmissionValidationResultModel {
    submissionValidationResultID?: string;
    submissionID?: string;
    resultVersion?: number;
    totalRows?: number;
    validRows?: number;
    errorRows?: number;
    errorCount?: number;
    validationResult?: any;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
    updatedDate?: Date | undefined;
    updatedUser?: string | undefined;

    constructor(data?: ISelfServeDataImportSubmissionValidationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionValidationResultID = _data["submissionValidationResultID"];
            this.submissionID = _data["submissionID"];
            this.resultVersion = _data["resultVersion"];
            this.totalRows = _data["totalRows"];
            this.validRows = _data["validRows"];
            this.errorRows = _data["errorRows"];
            this.errorCount = _data["errorCount"];
            this.validationResult = _data["validationResult"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdUser = _data["createdUser"];
            this.createdUserName = _data["createdUserName"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.updatedUser = _data["updatedUser"];
        }
    }

    static fromJS(data: any): SelfServeDataImportSubmissionValidationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportSubmissionValidationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionValidationResultID"] = this.submissionValidationResultID;
        data["submissionID"] = this.submissionID;
        data["resultVersion"] = this.resultVersion;
        data["totalRows"] = this.totalRows;
        data["validRows"] = this.validRows;
        data["errorRows"] = this.errorRows;
        data["errorCount"] = this.errorCount;
        data["validationResult"] = this.validationResult;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser;
        data["createdUserName"] = this.createdUserName;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedUser"] = this.updatedUser;
        return data;
    }
}

export interface ISelfServeDataImportSubmissionValidationResultModel {
    submissionValidationResultID?: string;
    submissionID?: string;
    resultVersion?: number;
    totalRows?: number;
    validRows?: number;
    errorRows?: number;
    errorCount?: number;
    validationResult?: any;
    createdDate?: Date;
    createdUser?: string;
    createdUserName?: string | undefined;
    updatedDate?: Date | undefined;
    updatedUser?: string | undefined;
}

export class SelfServeDataImportTemplateUrlModel implements ISelfServeDataImportTemplateUrlModel {
    staticDataImportTemplateURL?: string | undefined;
    balanceImportTemplateURL?: string | undefined;

    constructor(data?: ISelfServeDataImportTemplateUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staticDataImportTemplateURL = _data["staticDataImportTemplateURL"];
            this.balanceImportTemplateURL = _data["balanceImportTemplateURL"];
        }
    }

    static fromJS(data: any): SelfServeDataImportTemplateUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportTemplateUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staticDataImportTemplateURL"] = this.staticDataImportTemplateURL;
        data["balanceImportTemplateURL"] = this.balanceImportTemplateURL;
        return data;
    }
}

export interface ISelfServeDataImportTemplateUrlModel {
    staticDataImportTemplateURL?: string | undefined;
    balanceImportTemplateURL?: string | undefined;
}

export class SelfServeDataImportWorksheetTypeModel implements ISelfServeDataImportWorksheetTypeModel {
    selfServeDataImportWorksheetTypeID?: number;
    selfServeDataImportTemplateTypeID?: number;
    name?: string | undefined;
    displayOrder?: number;

    constructor(data?: ISelfServeDataImportWorksheetTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfServeDataImportWorksheetTypeID = _data["selfServeDataImportWorksheetTypeID"];
            this.selfServeDataImportTemplateTypeID = _data["selfServeDataImportTemplateTypeID"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): SelfServeDataImportWorksheetTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SelfServeDataImportWorksheetTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfServeDataImportWorksheetTypeID"] = this.selfServeDataImportWorksheetTypeID;
        data["selfServeDataImportTemplateTypeID"] = this.selfServeDataImportTemplateTypeID;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ISelfServeDataImportWorksheetTypeModel {
    selfServeDataImportWorksheetTypeID?: number;
    selfServeDataImportTemplateTypeID?: number;
    name?: string | undefined;
    displayOrder?: number;
}

export class ServiceChargeInvoice implements IServiceChargeInvoice {
    reportData?: ServiceChargeInvoiceReportModel;
    nonReportData?: ServiceChargeInvoiceNonReportDataModel;

    constructor(data?: IServiceChargeInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportData = _data["reportData"] ? ServiceChargeInvoiceReportModel.fromJS(_data["reportData"]) : undefined as any;
            this.nonReportData = _data["nonReportData"] ? ServiceChargeInvoiceNonReportDataModel.fromJS(_data["nonReportData"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceChargeInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportData"] = this.reportData ? this.reportData.toJSON() : <any>undefined;
        data["nonReportData"] = this.nonReportData ? this.nonReportData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceChargeInvoice {
    reportData?: ServiceChargeInvoiceReportModel;
    nonReportData?: ServiceChargeInvoiceNonReportDataModel;
}

export class ServiceChargeInvoiceBreakdownModel implements IServiceChargeInvoiceBreakdownModel {
    breakdownID?: number;
    clientName?: string | undefined;
    accountNumber?: string | undefined;
    invoiceAmount?: string | undefined;
    developmentName?: string | undefined;
    propertyManagerName?: string | undefined;
    shouldEmail?: boolean;
    shouldPrint?: boolean;
    emailSucceededDate?: Date | undefined;
    emailFailedDate?: Date | undefined;
    printSucceededDate?: Date | undefined;
    printFailedDate?: Date | undefined;
    attachmentDocumentsBatchID?: number;

    constructor(data?: IServiceChargeInvoiceBreakdownModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.breakdownID = _data["breakdownID"];
            this.clientName = _data["clientName"];
            this.accountNumber = _data["accountNumber"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.developmentName = _data["developmentName"];
            this.propertyManagerName = _data["propertyManagerName"];
            this.shouldEmail = _data["shouldEmail"];
            this.shouldPrint = _data["shouldPrint"];
            this.emailSucceededDate = _data["emailSucceededDate"] ? new Date(_data["emailSucceededDate"].toString()) : undefined as any;
            this.emailFailedDate = _data["emailFailedDate"] ? new Date(_data["emailFailedDate"].toString()) : undefined as any;
            this.printSucceededDate = _data["printSucceededDate"] ? new Date(_data["printSucceededDate"].toString()) : undefined as any;
            this.printFailedDate = _data["printFailedDate"] ? new Date(_data["printFailedDate"].toString()) : undefined as any;
            this.attachmentDocumentsBatchID = _data["attachmentDocumentsBatchID"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceBreakdownModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceBreakdownModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["breakdownID"] = this.breakdownID;
        data["clientName"] = this.clientName;
        data["accountNumber"] = this.accountNumber;
        data["invoiceAmount"] = this.invoiceAmount;
        data["developmentName"] = this.developmentName;
        data["propertyManagerName"] = this.propertyManagerName;
        data["shouldEmail"] = this.shouldEmail;
        data["shouldPrint"] = this.shouldPrint;
        data["emailSucceededDate"] = this.emailSucceededDate?.isValidDate() ? this.emailSucceededDate.toISOString() : <any>undefined;
        data["emailFailedDate"] = this.emailFailedDate?.isValidDate() ? this.emailFailedDate.toISOString() : <any>undefined;
        data["printSucceededDate"] = this.printSucceededDate?.isValidDate() ? this.printSucceededDate.toISOString() : <any>undefined;
        data["printFailedDate"] = this.printFailedDate?.isValidDate() ? this.printFailedDate.toISOString() : <any>undefined;
        data["attachmentDocumentsBatchID"] = this.attachmentDocumentsBatchID;
        return data;
    }
}

export interface IServiceChargeInvoiceBreakdownModel {
    breakdownID?: number;
    clientName?: string | undefined;
    accountNumber?: string | undefined;
    invoiceAmount?: string | undefined;
    developmentName?: string | undefined;
    propertyManagerName?: string | undefined;
    shouldEmail?: boolean;
    shouldPrint?: boolean;
    emailSucceededDate?: Date | undefined;
    emailFailedDate?: Date | undefined;
    printSucceededDate?: Date | undefined;
    printFailedDate?: Date | undefined;
    attachmentDocumentsBatchID?: number;
}

export class ServiceChargeInvoiceDetailsModel implements IServiceChargeInvoiceDetailsModel {
    requestedDate?: Date;
    requestedByUser?: string | undefined;
    completedDate?: Date | undefined;
    developments?: string[] | undefined;
    propertyManagers?: string[] | undefined;
    batchNumber?: number;
    status?: string | undefined;
    breakdowns?: ServiceChargeInvoiceBreakdownModel[] | undefined;

    constructor(data?: IServiceChargeInvoiceDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined as any;
            this.requestedByUser = _data["requestedByUser"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            if (Array.isArray(_data["developments"])) {
                this.developments = [] as any;
                for (let item of _data["developments"])
                    this.developments!.push(item);
            }
            if (Array.isArray(_data["propertyManagers"])) {
                this.propertyManagers = [] as any;
                for (let item of _data["propertyManagers"])
                    this.propertyManagers!.push(item);
            }
            this.batchNumber = _data["batchNumber"];
            this.status = _data["status"];
            if (Array.isArray(_data["breakdowns"])) {
                this.breakdowns = [] as any;
                for (let item of _data["breakdowns"])
                    this.breakdowns!.push(ServiceChargeInvoiceBreakdownModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedDate"] = this.requestedDate?.isValidDate() ? this.requestedDate.toISOString() : <any>undefined;
        data["requestedByUser"] = this.requestedByUser;
        data["completedDate"] = this.completedDate?.isValidDate() ? this.completedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.developments)) {
            data["developments"] = [];
            for (let item of this.developments)
                data["developments"].push(item);
        }
        if (Array.isArray(this.propertyManagers)) {
            data["propertyManagers"] = [];
            for (let item of this.propertyManagers)
                data["propertyManagers"].push(item);
        }
        data["batchNumber"] = this.batchNumber;
        data["status"] = this.status;
        if (Array.isArray(this.breakdowns)) {
            data["breakdowns"] = [];
            for (let item of this.breakdowns)
                data["breakdowns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceChargeInvoiceDetailsModel {
    requestedDate?: Date;
    requestedByUser?: string | undefined;
    completedDate?: Date | undefined;
    developments?: string[] | undefined;
    propertyManagers?: string[] | undefined;
    batchNumber?: number;
    status?: string | undefined;
    breakdowns?: ServiceChargeInvoiceBreakdownModel[] | undefined;
}

export class ServiceChargeInvoiceFooter implements IServiceChargeInvoiceFooter {
    reportFooterImageURL?: string | undefined;
    legalEntityName?: string | undefined;
    legalEntityAddress?: string | undefined;
    freeholderName?: string | undefined;
    freeholderAddress?: string | undefined;
    amountDue?: number;
    paymentReference?: string | undefined;
    bankName?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankAccountSortCode?: string | undefined;

    constructor(data?: IServiceChargeInvoiceFooter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportFooterImageURL = _data["reportFooterImageURL"];
            this.legalEntityName = _data["legalEntityName"];
            this.legalEntityAddress = _data["legalEntityAddress"];
            this.freeholderName = _data["freeholderName"];
            this.freeholderAddress = _data["freeholderAddress"];
            this.amountDue = _data["amountDue"];
            this.paymentReference = _data["paymentReference"];
            this.bankName = _data["bankName"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.bankAccountSortCode = _data["bankAccountSortCode"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceFooter {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceFooter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportFooterImageURL"] = this.reportFooterImageURL;
        data["legalEntityName"] = this.legalEntityName;
        data["legalEntityAddress"] = this.legalEntityAddress;
        data["freeholderName"] = this.freeholderName;
        data["freeholderAddress"] = this.freeholderAddress;
        data["amountDue"] = this.amountDue;
        data["paymentReference"] = this.paymentReference;
        data["bankName"] = this.bankName;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["bankAccountSortCode"] = this.bankAccountSortCode;
        return data;
    }
}

export interface IServiceChargeInvoiceFooter {
    reportFooterImageURL?: string | undefined;
    legalEntityName?: string | undefined;
    legalEntityAddress?: string | undefined;
    freeholderName?: string | undefined;
    freeholderAddress?: string | undefined;
    amountDue?: number;
    paymentReference?: string | undefined;
    bankName?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankAccountSortCode?: string | undefined;
}

export class ServiceChargeInvoiceLogoModel implements IServiceChargeInvoiceLogoModel {
    fileName?: string | undefined;
    fileSize?: number | undefined;
    previewUrl?: string | undefined;

    constructor(data?: IServiceChargeInvoiceLogoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileSize = _data["fileSize"];
            this.previewUrl = _data["previewUrl"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceLogoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceLogoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileSize"] = this.fileSize;
        data["previewUrl"] = this.previewUrl;
        return data;
    }
}

export interface IServiceChargeInvoiceLogoModel {
    fileName?: string | undefined;
    fileSize?: number | undefined;
    previewUrl?: string | undefined;
}

export class ServiceChargeInvoiceNonReportDataModel implements IServiceChargeInvoiceNonReportDataModel {
    clientID?: string;
    propertyID?: string;
    apportionID?: string | undefined;
    developmentID?: string;
    share?: string | undefined;
    previousPaymentsForPeriod?: number;
    printInvoice?: boolean;
    documentSavePath?: string | undefined;
    emailInvoice?: boolean;
    emailAddresses?: string[] | undefined;
    doNotSendInvoice?: boolean;
    fundSchedulesProcessed?: FundScheduleProcessedModel[] | undefined;

    constructor(data?: IServiceChargeInvoiceNonReportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.propertyID = _data["propertyID"];
            this.apportionID = _data["apportionID"];
            this.developmentID = _data["developmentID"];
            this.share = _data["share"];
            this.previousPaymentsForPeriod = _data["previousPaymentsForPeriod"];
            this.printInvoice = _data["printInvoice"];
            this.documentSavePath = _data["documentSavePath"];
            this.emailInvoice = _data["emailInvoice"];
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [] as any;
                for (let item of _data["emailAddresses"])
                    this.emailAddresses!.push(item);
            }
            this.doNotSendInvoice = _data["doNotSendInvoice"];
            if (Array.isArray(_data["fundSchedulesProcessed"])) {
                this.fundSchedulesProcessed = [] as any;
                for (let item of _data["fundSchedulesProcessed"])
                    this.fundSchedulesProcessed!.push(FundScheduleProcessedModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceNonReportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceNonReportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["propertyID"] = this.propertyID;
        data["apportionID"] = this.apportionID;
        data["developmentID"] = this.developmentID;
        data["share"] = this.share;
        data["previousPaymentsForPeriod"] = this.previousPaymentsForPeriod;
        data["printInvoice"] = this.printInvoice;
        data["documentSavePath"] = this.documentSavePath;
        data["emailInvoice"] = this.emailInvoice;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        data["doNotSendInvoice"] = this.doNotSendInvoice;
        if (Array.isArray(this.fundSchedulesProcessed)) {
            data["fundSchedulesProcessed"] = [];
            for (let item of this.fundSchedulesProcessed)
                data["fundSchedulesProcessed"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceChargeInvoiceNonReportDataModel {
    clientID?: string;
    propertyID?: string;
    apportionID?: string | undefined;
    developmentID?: string;
    share?: string | undefined;
    previousPaymentsForPeriod?: number;
    printInvoice?: boolean;
    documentSavePath?: string | undefined;
    emailInvoice?: boolean;
    emailAddresses?: string[] | undefined;
    doNotSendInvoice?: boolean;
    fundSchedulesProcessed?: FundScheduleProcessedModel[] | undefined;
}

export class ServiceChargeInvoiceProcessSelectionsModel implements IServiceChargeInvoiceProcessSelectionsModel {
    currentStep?: number;
    isBackgroundProcessRunning?: boolean;
    chargeDateCodes?: string[] | undefined;
    chargesTo?: Date;
    developments?: string[] | undefined;
    propertyManagers?: string[] | undefined;
    fundScheduleChargeTypes?: number[] | undefined;
    graceDays?: number;
    developmentChargesPreList?: DevelopmentChargesModel[] | undefined;
    invoiceReportModels?: ServiceChargeInvoice[] | undefined;
    batchNumber?: number | undefined;

    constructor(data?: IServiceChargeInvoiceProcessSelectionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStep = _data["currentStep"];
            this.isBackgroundProcessRunning = _data["isBackgroundProcessRunning"];
            if (Array.isArray(_data["chargeDateCodes"])) {
                this.chargeDateCodes = [] as any;
                for (let item of _data["chargeDateCodes"])
                    this.chargeDateCodes!.push(item);
            }
            this.chargesTo = _data["chargesTo"] ? new Date(_data["chargesTo"].toString()) : undefined as any;
            if (Array.isArray(_data["developments"])) {
                this.developments = [] as any;
                for (let item of _data["developments"])
                    this.developments!.push(item);
            }
            if (Array.isArray(_data["propertyManagers"])) {
                this.propertyManagers = [] as any;
                for (let item of _data["propertyManagers"])
                    this.propertyManagers!.push(item);
            }
            if (Array.isArray(_data["fundScheduleChargeTypes"])) {
                this.fundScheduleChargeTypes = [] as any;
                for (let item of _data["fundScheduleChargeTypes"])
                    this.fundScheduleChargeTypes!.push(item);
            }
            this.graceDays = _data["graceDays"];
            if (Array.isArray(_data["developmentChargesPreList"])) {
                this.developmentChargesPreList = [] as any;
                for (let item of _data["developmentChargesPreList"])
                    this.developmentChargesPreList!.push(DevelopmentChargesModel.fromJS(item));
            }
            if (Array.isArray(_data["invoiceReportModels"])) {
                this.invoiceReportModels = [] as any;
                for (let item of _data["invoiceReportModels"])
                    this.invoiceReportModels!.push(ServiceChargeInvoice.fromJS(item));
            }
            this.batchNumber = _data["batchNumber"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceProcessSelectionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceProcessSelectionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStep"] = this.currentStep;
        data["isBackgroundProcessRunning"] = this.isBackgroundProcessRunning;
        if (Array.isArray(this.chargeDateCodes)) {
            data["chargeDateCodes"] = [];
            for (let item of this.chargeDateCodes)
                data["chargeDateCodes"].push(item);
        }
        data["chargesTo"] = this.chargesTo?.isValidDate() ? this.chargesTo.toISOString() : <any>undefined;
        if (Array.isArray(this.developments)) {
            data["developments"] = [];
            for (let item of this.developments)
                data["developments"].push(item);
        }
        if (Array.isArray(this.propertyManagers)) {
            data["propertyManagers"] = [];
            for (let item of this.propertyManagers)
                data["propertyManagers"].push(item);
        }
        if (Array.isArray(this.fundScheduleChargeTypes)) {
            data["fundScheduleChargeTypes"] = [];
            for (let item of this.fundScheduleChargeTypes)
                data["fundScheduleChargeTypes"].push(item);
        }
        data["graceDays"] = this.graceDays;
        if (Array.isArray(this.developmentChargesPreList)) {
            data["developmentChargesPreList"] = [];
            for (let item of this.developmentChargesPreList)
                data["developmentChargesPreList"].push(item.toJSON());
        }
        if (Array.isArray(this.invoiceReportModels)) {
            data["invoiceReportModels"] = [];
            for (let item of this.invoiceReportModels)
                data["invoiceReportModels"].push(item.toJSON());
        }
        data["batchNumber"] = this.batchNumber;
        return data;
    }
}

export interface IServiceChargeInvoiceProcessSelectionsModel {
    currentStep?: number;
    isBackgroundProcessRunning?: boolean;
    chargeDateCodes?: string[] | undefined;
    chargesTo?: Date;
    developments?: string[] | undefined;
    propertyManagers?: string[] | undefined;
    fundScheduleChargeTypes?: number[] | undefined;
    graceDays?: number;
    developmentChargesPreList?: DevelopmentChargesModel[] | undefined;
    invoiceReportModels?: ServiceChargeInvoice[] | undefined;
    batchNumber?: number | undefined;
}

export class ServiceChargeInvoiceReportHeader implements IServiceChargeInvoiceReportHeader {
    clientID?: string;
    reportHeaderImageURL?: string | undefined;
    clientName?: string | undefined;
    clientAddress?: string | undefined;
    propertyFactorName?: string | undefined;
    propertyFactorAddress?: string | undefined;
    propertyFactorContactNumber?: string | undefined;
    propertyAddress?: string | undefined;
    invoiceNumber?: number;
    invoiceDate?: Date;
    clientVATNumber?: string | undefined;
    reference?: string | undefined;

    constructor(data?: IServiceChargeInvoiceReportHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.reportHeaderImageURL = _data["reportHeaderImageURL"];
            this.clientName = _data["clientName"];
            this.clientAddress = _data["clientAddress"];
            this.propertyFactorName = _data["propertyFactorName"];
            this.propertyFactorAddress = _data["propertyFactorAddress"];
            this.propertyFactorContactNumber = _data["propertyFactorContactNumber"];
            this.propertyAddress = _data["propertyAddress"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.clientVATNumber = _data["clientVATNumber"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceReportHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceReportHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["reportHeaderImageURL"] = this.reportHeaderImageURL;
        data["clientName"] = this.clientName;
        data["clientAddress"] = this.clientAddress;
        data["propertyFactorName"] = this.propertyFactorName;
        data["propertyFactorAddress"] = this.propertyFactorAddress;
        data["propertyFactorContactNumber"] = this.propertyFactorContactNumber;
        data["propertyAddress"] = this.propertyAddress;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate?.isValidDate() ? this.invoiceDate.toISOString() : <any>undefined;
        data["clientVATNumber"] = this.clientVATNumber;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IServiceChargeInvoiceReportHeader {
    clientID?: string;
    reportHeaderImageURL?: string | undefined;
    clientName?: string | undefined;
    clientAddress?: string | undefined;
    propertyFactorName?: string | undefined;
    propertyFactorAddress?: string | undefined;
    propertyFactorContactNumber?: string | undefined;
    propertyAddress?: string | undefined;
    invoiceNumber?: number;
    invoiceDate?: Date;
    clientVATNumber?: string | undefined;
    reference?: string | undefined;
}

export class ServiceChargeInvoiceReportModel implements IServiceChargeInvoiceReportModel {
    reportTitle?: string | undefined;
    header?: ServiceChargeInvoiceReportHeader;
    rows?: ServiceChargeInvoiceRow[] | undefined;
    outstandingBalance?: number;
    footer?: ServiceChargeInvoiceFooter;
    includeSection166?: boolean;
    section166?: Section166DemandReportModel;
    includeTenantsRightsNotice?: boolean;
    includeRightsAndObligationsNotice?: boolean;

    constructor(data?: IServiceChargeInvoiceReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTitle = _data["reportTitle"];
            this.header = _data["header"] ? ServiceChargeInvoiceReportHeader.fromJS(_data["header"]) : undefined as any;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServiceChargeInvoiceRow.fromJS(item));
            }
            this.outstandingBalance = _data["outstandingBalance"];
            this.footer = _data["footer"] ? ServiceChargeInvoiceFooter.fromJS(_data["footer"]) : undefined as any;
            this.includeSection166 = _data["includeSection166"];
            this.section166 = _data["section166"] ? Section166DemandReportModel.fromJS(_data["section166"]) : undefined as any;
            this.includeTenantsRightsNotice = _data["includeTenantsRightsNotice"];
            this.includeRightsAndObligationsNotice = _data["includeRightsAndObligationsNotice"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTitle"] = this.reportTitle;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["outstandingBalance"] = this.outstandingBalance;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        data["includeSection166"] = this.includeSection166;
        data["section166"] = this.section166 ? this.section166.toJSON() : <any>undefined;
        data["includeTenantsRightsNotice"] = this.includeTenantsRightsNotice;
        data["includeRightsAndObligationsNotice"] = this.includeRightsAndObligationsNotice;
        return data;
    }
}

export interface IServiceChargeInvoiceReportModel {
    reportTitle?: string | undefined;
    header?: ServiceChargeInvoiceReportHeader;
    rows?: ServiceChargeInvoiceRow[] | undefined;
    outstandingBalance?: number;
    footer?: ServiceChargeInvoiceFooter;
    includeSection166?: boolean;
    section166?: Section166DemandReportModel;
    includeTenantsRightsNotice?: boolean;
    includeRightsAndObligationsNotice?: boolean;
}

export class ServiceChargeInvoiceRow implements IServiceChargeInvoiceRow {
    fundScheduleID?: number;
    chargeFileID?: string | undefined;
    nominalCodeID?: string;
    dueDate?: Date;
    overdueDate?: Date;
    description?: string | undefined;
    fiscalPeriod?: string | undefined;
    fromDate?: Date;
    toDate?: Date;
    isVATElected?: boolean;
    netAmount?: number;
    vatAmount?: number;
    grossAmount?: number;

    constructor(data?: IServiceChargeInvoiceRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundScheduleID = _data["fundScheduleID"];
            this.chargeFileID = _data["chargeFileID"];
            this.nominalCodeID = _data["nominalCodeID"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.overdueDate = _data["overdueDate"] ? new Date(_data["overdueDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.fiscalPeriod = _data["fiscalPeriod"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.isVATElected = _data["isVATElected"];
            this.netAmount = _data["netAmount"];
            this.vatAmount = _data["vatAmount"];
            this.grossAmount = _data["grossAmount"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceRow {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundScheduleID"] = this.fundScheduleID;
        data["chargeFileID"] = this.chargeFileID;
        data["nominalCodeID"] = this.nominalCodeID;
        data["dueDate"] = this.dueDate?.isValidDate() ? this.dueDate.toISOString() : <any>undefined;
        data["overdueDate"] = this.overdueDate?.isValidDate() ? this.overdueDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["fiscalPeriod"] = this.fiscalPeriod;
        data["fromDate"] = this.fromDate?.isValidDate() ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate?.isValidDate() ? this.toDate.toISOString() : <any>undefined;
        data["isVATElected"] = this.isVATElected;
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["grossAmount"] = this.grossAmount;
        return data;
    }
}

export interface IServiceChargeInvoiceRow {
    fundScheduleID?: number;
    chargeFileID?: string | undefined;
    nominalCodeID?: string;
    dueDate?: Date;
    overdueDate?: Date;
    description?: string | undefined;
    fiscalPeriod?: string | undefined;
    fromDate?: Date;
    toDate?: Date;
    isVATElected?: boolean;
    netAmount?: number;
    vatAmount?: number;
    grossAmount?: number;
}

export class ServiceChargeInvoiceSettingsModel implements IServiceChargeInvoiceSettingsModel {
    header?: ServiceChargeInvoiceLogoModel;
    footer?: ServiceChargeInvoiceLogoModel;

    constructor(data?: IServiceChargeInvoiceSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? ServiceChargeInvoiceLogoModel.fromJS(_data["header"]) : undefined as any;
            this.footer = _data["footer"] ? ServiceChargeInvoiceLogoModel.fromJS(_data["footer"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceChargeInvoiceSettingsModel {
    header?: ServiceChargeInvoiceLogoModel;
    footer?: ServiceChargeInvoiceLogoModel;
}

export class ServiceChargeInvoiceSummaryModel implements IServiceChargeInvoiceSummaryModel {
    logID?: number;
    requestedDate?: Date;
    completedDate?: Date | undefined;
    batchNumber?: number;
    status?: string | undefined;

    constructor(data?: IServiceChargeInvoiceSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logID = _data["logID"];
            this.requestedDate = _data["requestedDate"] ? new Date(_data["requestedDate"].toString()) : undefined as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : undefined as any;
            this.batchNumber = _data["batchNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ServiceChargeInvoiceSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceChargeInvoiceSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logID"] = this.logID;
        data["requestedDate"] = this.requestedDate?.isValidDate() ? this.requestedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate?.isValidDate() ? this.completedDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["status"] = this.status;
        return data;
    }
}

export interface IServiceChargeInvoiceSummaryModel {
    logID?: number;
    requestedDate?: Date;
    completedDate?: Date | undefined;
    batchNumber?: number;
    status?: string | undefined;
}

export class SetMessageFeedbackModel implements ISetMessageFeedbackModel {
    isPositive?: boolean;
    reason?: FeedbackReason;
    comment?: string | undefined;
    messageID?: number;

    constructor(data?: ISetMessageFeedbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPositive = _data["isPositive"];
            this.reason = _data["reason"];
            this.comment = _data["comment"];
            this.messageID = _data["messageID"];
        }
    }

    static fromJS(data: any): SetMessageFeedbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessageFeedbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPositive"] = this.isPositive;
        data["reason"] = this.reason;
        data["comment"] = this.comment;
        data["messageID"] = this.messageID;
        return data;
    }
}

export interface ISetMessageFeedbackModel {
    isPositive?: boolean;
    reason?: FeedbackReason;
    comment?: string | undefined;
    messageID?: number;
}

export enum SqlCompareOptions {
    None = "None",
    IgnoreCase = "IgnoreCase",
    IgnoreNonSpace = "IgnoreNonSpace",
    IgnoreKanaType = "IgnoreKanaType",
    IgnoreWidth = "IgnoreWidth",
    BinarySort2 = "BinarySort2",
    BinarySort = "BinarySort",
}

export enum SqlDbType {
    BigInt = "BigInt",
    Binary = "Binary",
    Bit = "Bit",
    Char = "Char",
    DateTime = "DateTime",
    Decimal = "Decimal",
    Float = "Float",
    Image = "Image",
    Int = "Int",
    Money = "Money",
    NChar = "NChar",
    NText = "NText",
    NVarChar = "NVarChar",
    Real = "Real",
    UniqueIdentifier = "UniqueIdentifier",
    SmallDateTime = "SmallDateTime",
    SmallInt = "SmallInt",
    SmallMoney = "SmallMoney",
    Text = "Text",
    Timestamp = "Timestamp",
    TinyInt = "TinyInt",
    VarBinary = "VarBinary",
    VarChar = "VarChar",
    Variant = "Variant",
    Xml = "Xml",
    Udt = "Udt",
    Structured = "Structured",
    Date = "Date",
    Time = "Time",
    DateTime2 = "DateTime2",
    DateTimeOffset = "DateTimeOffset",
    Json = "Json",
    Vector = "Vector",
}

export class SqlParameter implements ISqlParameter {
    compareInfo?: SqlCompareOptions;
    xmlSchemaCollectionDatabase?: string | undefined;
    xmlSchemaCollectionOwningSchema?: string | undefined;
    xmlSchemaCollectionName?: string | undefined;
    forceColumnEncryption?: boolean;
    dbType?: DbType;
    parameterName?: string | undefined;
    localeId?: number;
    precision?: number;
    scale?: number;
    sqlDbType?: SqlDbType;
    sqlValue?: any | undefined;
    udtTypeName?: string | undefined;
    typeName?: string | undefined;
    value?: any | undefined;
    direction?: ParameterDirection;
    isNullable?: boolean;
    offset?: number;
    size?: number;
    sourceColumn?: string | undefined;
    sourceColumnNullMapping?: boolean;
    sourceVersion?: DataRowVersion;

    constructor(data?: ISqlParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.forceColumnEncryption = false;
            this.precision = 0;
            this.scale = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compareInfo = _data["compareInfo"];
            this.xmlSchemaCollectionDatabase = _data["xmlSchemaCollectionDatabase"];
            this.xmlSchemaCollectionOwningSchema = _data["xmlSchemaCollectionOwningSchema"];
            this.xmlSchemaCollectionName = _data["xmlSchemaCollectionName"];
            this.forceColumnEncryption = _data["forceColumnEncryption"] !== undefined ? _data["forceColumnEncryption"] : false;
            this.dbType = _data["dbType"];
            this.parameterName = _data["parameterName"];
            this.localeId = _data["localeId"];
            this.precision = _data["precision"] !== undefined ? _data["precision"] : 0;
            this.scale = _data["scale"] !== undefined ? _data["scale"] : 0;
            this.sqlDbType = _data["sqlDbType"];
            this.sqlValue = _data["sqlValue"];
            this.udtTypeName = _data["udtTypeName"];
            this.typeName = _data["typeName"];
            this.value = _data["value"];
            this.direction = _data["direction"];
            this.isNullable = _data["isNullable"];
            this.offset = _data["offset"];
            this.size = _data["size"];
            this.sourceColumn = _data["sourceColumn"];
            this.sourceColumnNullMapping = _data["sourceColumnNullMapping"];
            this.sourceVersion = _data["sourceVersion"];
        }
    }

    static fromJS(data: any): SqlParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SqlParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compareInfo"] = this.compareInfo;
        data["xmlSchemaCollectionDatabase"] = this.xmlSchemaCollectionDatabase;
        data["xmlSchemaCollectionOwningSchema"] = this.xmlSchemaCollectionOwningSchema;
        data["xmlSchemaCollectionName"] = this.xmlSchemaCollectionName;
        data["forceColumnEncryption"] = this.forceColumnEncryption;
        data["dbType"] = this.dbType;
        data["parameterName"] = this.parameterName;
        data["localeId"] = this.localeId;
        data["precision"] = this.precision;
        data["scale"] = this.scale;
        data["sqlDbType"] = this.sqlDbType;
        data["sqlValue"] = this.sqlValue;
        data["udtTypeName"] = this.udtTypeName;
        data["typeName"] = this.typeName;
        data["value"] = this.value;
        data["direction"] = this.direction;
        data["isNullable"] = this.isNullable;
        data["offset"] = this.offset;
        data["size"] = this.size;
        data["sourceColumn"] = this.sourceColumn;
        data["sourceColumnNullMapping"] = this.sourceColumnNullMapping;
        data["sourceVersion"] = this.sourceVersion;
        return data;
    }
}

export interface ISqlParameter {
    compareInfo?: SqlCompareOptions;
    xmlSchemaCollectionDatabase?: string | undefined;
    xmlSchemaCollectionOwningSchema?: string | undefined;
    xmlSchemaCollectionName?: string | undefined;
    forceColumnEncryption?: boolean;
    dbType?: DbType;
    parameterName?: string | undefined;
    localeId?: number;
    precision?: number;
    scale?: number;
    sqlDbType?: SqlDbType;
    sqlValue?: any | undefined;
    udtTypeName?: string | undefined;
    typeName?: string | undefined;
    value?: any | undefined;
    direction?: ParameterDirection;
    isNullable?: boolean;
    offset?: number;
    size?: number;
    sourceColumn?: string | undefined;
    sourceColumnNullMapping?: boolean;
    sourceVersion?: DataRowVersion;
}

export class StandardDescriptionModel implements IStandardDescriptionModel {
    description?: string | undefined;
    code?: string | undefined;

    constructor(data?: IStandardDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): StandardDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new StandardDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface IStandardDescriptionModel {
    description?: string | undefined;
    code?: string | undefined;
}

export enum SubmissionStatus {
    Draft = "Draft",
    Mapped = "Mapped",
    InValidation = "InValidation",
    Ready = "Ready",
    Submitted = "Submitted",
    Closed = "Closed",
}

export enum TemplateType {
    StaticData = "StaticData",
    BalanceImport = "BalanceImport",
}

export class TermsAndConditionsModel implements ITermsAndConditionsModel {
    termsAndConditionsContent?: string | undefined;

    constructor(data?: ITermsAndConditionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsAndConditionsContent = _data["termsAndConditionsContent"];
        }
    }

    static fromJS(data: any): TermsAndConditionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TermsAndConditionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termsAndConditionsContent"] = this.termsAndConditionsContent;
        return data;
    }
}

export interface ITermsAndConditionsModel {
    termsAndConditionsContent?: string | undefined;
}

export class UpdateAddressModel implements IUpdateAddressModel {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;
    addressID?: string;

    constructor(data?: IUpdateAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.addressLine4 = _data["addressLine4"];
            this.addressLine5 = _data["addressLine5"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postCode = _data["postCode"];
            this.countryCodeID = _data["countryCodeID"];
            this.addressID = _data["addressID"];
        }
    }

    static fromJS(data: any): UpdateAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["addressLine4"] = this.addressLine4;
        data["addressLine5"] = this.addressLine5;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postCode"] = this.postCode;
        data["countryCodeID"] = this.countryCodeID;
        data["addressID"] = this.addressID;
        return data;
    }
}

export interface IUpdateAddressModel {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    addressLine5?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    countryCodeID?: number;
    addressID?: string;
}

export class UpdateChatSessionModel implements IUpdateChatSessionModel {
    chatSessionID?: string;
    chatName?: string | undefined;

    constructor(data?: IUpdateChatSessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.chatName = _data["chatName"];
        }
    }

    static fromJS(data: any): UpdateChatSessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChatSessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["chatName"] = this.chatName;
        return data;
    }
}

export interface IUpdateChatSessionModel {
    chatSessionID?: string;
    chatName?: string | undefined;
}

export class UpdateDirectorModel implements IUpdateDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    directorID?: string;
    legalEntityIDs?: string[] | undefined;

    constructor(data?: IUpdateDirectorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.directorID = _data["directorID"];
            if (Array.isArray(_data["legalEntityIDs"])) {
                this.legalEntityIDs = [] as any;
                for (let item of _data["legalEntityIDs"])
                    this.legalEntityIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateDirectorModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDirectorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["directorID"] = this.directorID;
        if (Array.isArray(this.legalEntityIDs)) {
            data["legalEntityIDs"] = [];
            for (let item of this.legalEntityIDs)
                data["legalEntityIDs"].push(item);
        }
        return data;
    }
}

export interface IUpdateDirectorModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    directorID?: string;
    legalEntityIDs?: string[] | undefined;
}

export class UpdateSelfServeDataImportSubmissionStatusModel implements IUpdateSelfServeDataImportSubmissionStatusModel {
    submissionID?: string;
    submissionStatus?: SubmissionStatus;
    currentStep?: number;

    constructor(data?: IUpdateSelfServeDataImportSubmissionStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionID = _data["submissionID"];
            this.submissionStatus = _data["submissionStatus"];
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): UpdateSelfServeDataImportSubmissionStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSelfServeDataImportSubmissionStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionID"] = this.submissionID;
        data["submissionStatus"] = this.submissionStatus;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface IUpdateSelfServeDataImportSubmissionStatusModel {
    submissionID?: string;
    submissionStatus?: SubmissionStatus;
    currentStep?: number;
}

export class UploadedChatDocumentModel implements IUploadedChatDocumentModel {
    chatSessionID?: string;
    documentID?: string;

    constructor(data?: IUploadedChatDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatSessionID = _data["chatSessionID"];
            this.documentID = _data["documentID"];
        }
    }

    static fromJS(data: any): UploadedChatDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedChatDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatSessionID"] = this.chatSessionID;
        data["documentID"] = this.documentID;
        return data;
    }
}

export interface IUploadedChatDocumentModel {
    chatSessionID?: string;
    documentID?: string;
}

export class UserModel implements IUserModel {
    userID?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["telephone"] = this.telephone;
        return data;
    }
}

export interface IUserModel {
    userID?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    telephone?: string | undefined;
}

export enum UserResumableProcessType {
    ServiceChargeInvoicing = "ServiceChargeInvoicing",
    AnticipatedExpenditure = "AnticipatedExpenditure",
}

export class UserTaskFiltersModel implements IUserTaskFiltersModel {
    includeAllCompany?: boolean;
    includeSubordinates?: boolean;
    includeUserGroup?: boolean;
    includeArchived?: boolean;
    meetingID?: number | undefined;
    caseID?: number | undefined;

    constructor(data?: IUserTaskFiltersModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includeAllCompany = _data["includeAllCompany"];
            this.includeSubordinates = _data["includeSubordinates"];
            this.includeUserGroup = _data["includeUserGroup"];
            this.includeArchived = _data["includeArchived"];
            this.meetingID = _data["meetingID"];
            this.caseID = _data["caseID"];
        }
    }

    static fromJS(data: any): UserTaskFiltersModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskFiltersModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includeAllCompany"] = this.includeAllCompany;
        data["includeSubordinates"] = this.includeSubordinates;
        data["includeUserGroup"] = this.includeUserGroup;
        data["includeArchived"] = this.includeArchived;
        data["meetingID"] = this.meetingID;
        data["caseID"] = this.caseID;
        return data;
    }
}

export interface IUserTaskFiltersModel {
    includeAllCompany?: boolean;
    includeSubordinates?: boolean;
    includeUserGroup?: boolean;
    includeArchived?: boolean;
    meetingID?: number | undefined;
    caseID?: number | undefined;
}

export class UserTaskModel implements IUserTaskModel {
    userTaskID?: number;
    title?: string | undefined;
    description?: string | undefined;
    userTaskTypeID?: number;
    userTaskType?: string | undefined;
    userTaskStatusTypeID?: number;
    userTaskStatusType?: string | undefined;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    asssignedUserGroupName?: string | undefined;
    assignedUsername?: string | undefined;
    slaTypeID?: number;
    slaType?: string | undefined;
    slaTargetDate?: Date;
    createdDate?: Date;
    createdBy?: string;
    closedDate?: Date | undefined;
    closedBy?: string | undefined;
    startDate?: Date;
    updatedBy?: string | undefined;
    meetingID?: number | undefined;
    caseID?: number | undefined;

    constructor(data?: IUserTaskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTaskID = _data["userTaskID"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.userTaskTypeID = _data["userTaskTypeID"];
            this.userTaskType = _data["userTaskType"];
            this.userTaskStatusTypeID = _data["userTaskStatusTypeID"];
            this.userTaskStatusType = _data["userTaskStatusType"];
            this.assignedUserID = _data["assignedUserID"];
            this.assignedUserGroupID = _data["assignedUserGroupID"];
            this.asssignedUserGroupName = _data["asssignedUserGroupName"];
            this.assignedUsername = _data["assignedUsername"];
            this.slaTypeID = _data["slaTypeID"];
            this.slaType = _data["slaType"];
            this.slaTargetDate = _data["slaTargetDate"] ? new Date(_data["slaTargetDate"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : undefined as any;
            this.closedBy = _data["closedBy"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.meetingID = _data["meetingID"];
            this.caseID = _data["caseID"];
        }
    }

    static fromJS(data: any): UserTaskModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTaskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTaskID"] = this.userTaskID;
        data["title"] = this.title;
        data["description"] = this.description;
        data["userTaskTypeID"] = this.userTaskTypeID;
        data["userTaskType"] = this.userTaskType;
        data["userTaskStatusTypeID"] = this.userTaskStatusTypeID;
        data["userTaskStatusType"] = this.userTaskStatusType;
        data["assignedUserID"] = this.assignedUserID;
        data["assignedUserGroupID"] = this.assignedUserGroupID;
        data["asssignedUserGroupName"] = this.asssignedUserGroupName;
        data["assignedUsername"] = this.assignedUsername;
        data["slaTypeID"] = this.slaTypeID;
        data["slaType"] = this.slaType;
        data["slaTargetDate"] = this.slaTargetDate?.isValidDate() ? this.slaTargetDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["closedDate"] = this.closedDate?.isValidDate() ? this.closedDate.toISOString() : <any>undefined;
        data["closedBy"] = this.closedBy;
        data["startDate"] = this.startDate?.isValidDate() ? this.startDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["meetingID"] = this.meetingID;
        data["caseID"] = this.caseID;
        return data;
    }
}

export interface IUserTaskModel {
    userTaskID?: number;
    title?: string | undefined;
    description?: string | undefined;
    userTaskTypeID?: number;
    userTaskType?: string | undefined;
    userTaskStatusTypeID?: number;
    userTaskStatusType?: string | undefined;
    assignedUserID?: string | undefined;
    assignedUserGroupID?: number | undefined;
    asssignedUserGroupName?: string | undefined;
    assignedUsername?: string | undefined;
    slaTypeID?: number;
    slaType?: string | undefined;
    slaTargetDate?: Date;
    createdDate?: Date;
    createdBy?: string;
    closedDate?: Date | undefined;
    closedBy?: string | undefined;
    startDate?: Date;
    updatedBy?: string | undefined;
    meetingID?: number | undefined;
    caseID?: number | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class WorkingHoursModel implements IWorkingHoursModel {
    workingHourID?: number;
    dayOfWeek?: number;
    isOpen?: boolean;
    openTime?: string | undefined;
    closeTime?: string | undefined;

    constructor(data?: IWorkingHoursModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workingHourID = _data["workingHourID"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.isOpen = _data["isOpen"];
            this.openTime = _data["openTime"];
            this.closeTime = _data["closeTime"];
        }
    }

    static fromJS(data: any): WorkingHoursModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkingHoursModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workingHourID"] = this.workingHourID;
        data["dayOfWeek"] = this.dayOfWeek;
        data["isOpen"] = this.isOpen;
        data["openTime"] = this.openTime;
        data["closeTime"] = this.closeTime;
        return data;
    }
}

export interface IWorkingHoursModel {
    workingHourID?: number;
    dayOfWeek?: number;
    isOpen?: boolean;
    openTime?: string | undefined;
    closeTime?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class CPLApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCPLApiException = true;

    static isCPLApiException(obj: any): obj is CPLApiException {
        return obj.isCPLApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CPLApiException(message, status, response, headers, null);
}

/* eslint @typescript-eslint/no-unused-vars: 0 */